export const ApoDuos = [
  {
    char: 'trailblazer-remembrance',
    app: 70.19,
    char_1: 'castorice',
    app_rate_1: '74.87%',
    avg_round_1: 3518.0,
    app_flat_1: 4060,
    char_2: 'tribbie',
    app_rate_2: '44.11%',
    avg_round_2: 3538.0,
    app_flat_2: 2640,
    char_3: 'gallagher',
    app_rate_3: '42.93%',
    avg_round_3: 3515.0,
    app_flat_3: 2517,
    char_4: 'ruan-mei',
    app_rate_4: '28.98%',
    avg_round_4: 3544.0,
    app_flat_4: 1110,
    char_5: 'luocha',
    app_rate_5: '25.81%',
    avg_round_5: 3492.0,
    app_flat_5: 1309,
    char_6: 'the-herta',
    app_rate_6: '14.41%',
    avg_round_6: 3463.0,
    app_flat_6: 961,
    char_7: 'sunday',
    app_rate_7: '9.48%',
    avg_round_7: 3491.0,
    app_flat_7: 496,
    char_8: 'herta',
    app_rate_8: '8.78%',
    avg_round_8: 3445.0,
    app_flat_8: 594,
    char_9: 'lingsha',
    app_rate_9: '6.56%',
    avg_round_9: 3493.0,
    app_flat_9: 389,
    char_10: 'mydei',
    app_rate_10: '6.33%',
    avg_round_10: 3458.0,
    app_flat_10: 335,
    char_11: 'huohuo',
    app_rate_11: '6.14%',
    avg_round_11: 3421.0,
    app_flat_11: 376,
    char_12: 'robin',
    app_rate_12: '4.08%',
    avg_round_12: 3482.0,
    app_flat_12: 160,
    char_13: 'aventurine',
    app_rate_13: '3.69%',
    avg_round_13: 3404.0,
    app_flat_13: 253,
    char_14: 'jade',
    app_rate_14: '3.54%',
    avg_round_14: 3506.0,
    app_flat_14: 234,
    char_15: 'fu-xuan',
    app_rate_15: '2.87%',
    avg_round_15: 3388.0,
    app_flat_15: 135,
    char_16: 'pela',
    app_rate_16: '2.27%',
    avg_round_16: 3398.0,
    app_flat_16: 127,
    char_17: 'sparkle',
    app_rate_17: '1.54%',
    avg_round_17: 3422.0,
    app_flat_17: 73,
    char_18: 'jiaoqiu',
    app_rate_18: '1.47%',
    avg_round_18: 3466.0,
    app_flat_18: 34,
    char_19: 'yunli',
    app_rate_19: '1.31%',
    avg_round_19: 3314.0,
    app_flat_19: 62,
    char_20: 'anaxa',
    app_rate_20: '1.11%',
    avg_round_20: 3618.0,
    app_flat_20: 57,
    char_21: 'argenti',
    app_rate_21: '1.06%',
    avg_round_21: 3497.0,
    app_flat_21: 62,
    char_22: 'acheron',
    app_rate_22: '1.05%',
    avg_round_22: 3565.0,
    app_flat_22: 10,
    char_23: 'blade',
    app_rate_23: '1.0%',
    avg_round_23: 3440.0,
    app_flat_23: 58,
    char_24: 'serval',
    app_rate_24: '0.95%',
    avg_round_24: 3405.0,
    app_flat_24: 58,
    char_25: 'bronya',
    app_rate_25: '0.94%',
    avg_round_25: 3430.0,
    app_flat_25: 45,
    char_26: 'feixiao',
    app_rate_26: '0.92%',
    avg_round_26: 3463.0,
    app_flat_26: 42,
    char_27: 'bailu',
    app_rate_27: '0.51%',
    avg_round_27: 3484.0,
    app_flat_27: 26,
    char_28: 'aglaea',
    app_rate_28: '0.46%',
    avg_round_28: 3400.0,
    app_flat_28: 2,
    char_29: 'tingyun',
    app_rate_29: '0.39%',
    avg_round_29: 3576.0,
    app_flat_29: 14,
    char_30: 'lynx',
    app_rate_30: '0.36%',
    avg_round_30: 3435.0,
    app_flat_30: 19
  },
  {
    char: 'castorice',
    app: 64.63,
    char_1: 'trailblazer-remembrance',
    app_rate_1: '81.3%',
    avg_round_1: 3518.0,
    app_flat_1: 4060,
    char_2: 'tribbie',
    app_rate_2: '53.82%',
    avg_round_2: 3525.0,
    app_flat_2: 2825,
    char_3: 'gallagher',
    app_rate_3: '51.79%',
    avg_round_3: 3515.0,
    app_flat_3: 2684,
    char_4: 'ruan-mei',
    app_rate_4: '37.24%',
    avg_round_4: 3539.0,
    app_flat_4: 1267,
    char_5: 'luocha',
    app_rate_5: '30.87%',
    avg_round_5: 3498.0,
    app_flat_5: 1343,
    char_6: 'sunday',
    app_rate_6: '12.72%',
    avg_round_6: 3492.0,
    app_flat_6: 529,
    char_7: 'lingsha',
    app_rate_7: '6.99%',
    avg_round_7: 3509.0,
    app_flat_7: 313,
    char_8: 'mydei',
    app_rate_8: '5.39%',
    avg_round_8: 3477.0,
    app_flat_8: 268,
    char_9: 'huohuo',
    app_rate_9: '3.43%',
    avg_round_9: 3468.0,
    app_flat_9: 148,
    char_10: 'blade',
    app_rate_10: '2.82%',
    avg_round_10: 3432.0,
    app_flat_10: 132,
    char_11: 'pela',
    app_rate_11: '2.79%',
    avg_round_11: 3384.0,
    app_flat_11: 147,
    char_12: 'robin',
    app_rate_12: '2.15%',
    avg_round_12: 3501.0,
    app_flat_12: 69,
    char_13: 'sparkle',
    app_rate_13: '1.74%',
    avg_round_13: 3415.0,
    app_flat_13: 61,
    char_14: 'fu-xuan',
    app_rate_14: '1.33%',
    avg_round_14: 3517.0,
    app_flat_14: 32,
    char_15: 'tingyun-fugue',
    app_rate_15: '0.97%',
    avg_round_15: 3469.0,
    app_flat_15: 27,
    char_16: 'bronya',
    app_rate_16: '0.77%',
    avg_round_16: 3454.0,
    app_flat_16: 35,
    char_17: 'jiaoqiu',
    app_rate_17: '0.68%',
    avg_round_17: 3447.0,
    app_flat_17: 29,
    char_18: 'bailu',
    app_rate_18: '0.6%',
    avg_round_18: 3497.0,
    app_flat_18: 24,
    char_19: 'tingyun',
    app_rate_19: '0.4%',
    avg_round_19: 0,
    app_flat_19: 0,
    char_20: 'silver-wolf',
    app_rate_20: '0.32%',
    avg_round_20: 3434.0,
    app_flat_20: 7,
    char_21: 'lynx',
    app_rate_21: '0.29%',
    avg_round_21: 3461.0,
    app_flat_21: 9,
    char_22: 'feixiao',
    app_rate_22: '0.24%',
    avg_round_22: 3456.0,
    app_flat_22: 13,
    char_23: 'yunli',
    app_rate_23: '0.24%',
    avg_round_23: 3398.0,
    app_flat_23: 10,
    char_24: 'the-herta',
    app_rate_24: '0.17%',
    avg_round_24: 3341.0,
    app_flat_24: 5,
    char_25: 'clara',
    app_rate_25: '0.15%',
    avg_round_25: 3256.0,
    app_flat_25: 6,
    char_26: 'jade',
    app_rate_26: '0.14%',
    avg_round_26: 3343.0,
    app_flat_26: 5,
    char_27: 'firefly',
    app_rate_27: '0.12%',
    avg_round_27: 3253,
    app_flat_27: 1,
    char_28: 'herta',
    app_rate_28: '0.09%',
    avg_round_28: 3296.0,
    app_flat_28: 3,
    char_29: 'jingliu',
    app_rate_29: '0.08%',
    avg_round_29: 3327.0,
    app_flat_29: 3,
    char_30: 'trailblazer-harmony',
    app_rate_30: '0.06%',
    avg_round_30: 3409.0,
    app_flat_30: 3
  },
  {
    char: 'tribbie',
    app: 63.62,
    char_1: 'castorice',
    app_rate_1: '54.67%',
    avg_round_1: 3525.0,
    app_flat_1: 2825,
    char_2: 'trailblazer-remembrance',
    app_rate_2: '48.66%',
    avg_round_2: 3538.0,
    app_flat_2: 2640,
    char_3: 'the-herta',
    app_rate_3: '32.64%',
    avg_round_3: 3526.0,
    app_flat_3: 1665,
    char_4: 'gallagher',
    app_rate_4: '30.9%',
    avg_round_4: 3522.0,
    app_flat_4: 1790,
    char_5: 'luocha',
    app_rate_5: '21.52%',
    avg_round_5: 3508.0,
    app_flat_5: 977,
    char_6: 'herta',
    app_rate_6: '17.48%',
    avg_round_6: 3513.0,
    app_flat_6: 926,
    char_7: 'sunday',
    app_rate_7: '10.81%',
    avg_round_7: 3496.0,
    app_flat_7: 356,
    char_8: 'lingsha',
    app_rate_8: '10.31%',
    avg_round_8: 3524.0,
    app_flat_8: 523,
    char_9: 'jade',
    app_rate_9: '10.17%',
    avg_round_9: 3552.0,
    app_flat_9: 478,
    char_10: 'aventurine',
    app_rate_10: '9.75%',
    avg_round_10: 3494.0,
    app_flat_10: 525,
    char_11: 'huohuo',
    app_rate_11: '9.06%',
    avg_round_11: 3470.0,
    app_flat_11: 430,
    char_12: 'mydei',
    app_rate_12: '6.65%',
    avg_round_12: 3488.0,
    app_flat_12: 295,
    char_13: 'fu-xuan',
    app_rate_13: '6.24%',
    avg_round_13: 3469.0,
    app_flat_13: 236,
    char_14: 'ruan-mei',
    app_rate_14: '5.05%',
    avg_round_14: 3616.0,
    app_flat_14: 124,
    char_15: 'robin',
    app_rate_15: '3.3%',
    avg_round_15: 3464.0,
    app_flat_15: 85,
    char_16: 'acheron',
    app_rate_16: '2.66%',
    avg_round_16: 3404.0,
    app_flat_16: 27,
    char_17: 'serval',
    app_rate_17: '2.53%',
    avg_round_17: 3447.0,
    app_flat_17: 111,
    char_18: 'argenti',
    app_rate_18: '2.24%',
    avg_round_18: 3545.0,
    app_flat_18: 109,
    char_19: 'jiaoqiu',
    app_rate_19: '2.13%',
    avg_round_19: 3452,
    app_flat_19: 22,
    char_20: 'blade',
    app_rate_20: '1.6%',
    avg_round_20: 3432.0,
    app_flat_20: 58,
    char_21: 'sparkle',
    app_rate_21: '1.56%',
    avg_round_21: 3425.0,
    app_flat_21: 31,
    char_22: 'anaxa',
    app_rate_22: '1.55%',
    avg_round_22: 3575.0,
    app_flat_22: 62,
    char_23: 'yunli',
    app_rate_23: '1.35%',
    avg_round_23: 3403.0,
    app_flat_23: 46,
    char_24: 'feixiao',
    app_rate_24: '1.2%',
    avg_round_24: 3391.0,
    app_flat_24: 46,
    char_25: 'pela',
    app_rate_25: '1.12%',
    avg_round_25: 3408.0,
    app_flat_25: 29,
    char_26: 'aglaea',
    app_rate_26: '0.53%',
    avg_round_26: 3404,
    app_flat_26: 8,
    char_27: 'bronya',
    app_rate_27: '0.44%',
    avg_round_27: 3481.0,
    app_flat_27: 15,
    char_28: 'bailu',
    app_rate_28: '0.44%',
    avg_round_28: 3453.0,
    app_flat_28: 22,
    char_29: 'tingyun-fugue',
    app_rate_29: '0.41%',
    avg_round_29: 3499.0,
    app_flat_29: 4,
    char_30: 'march-7th-swordmaster',
    app_rate_30: '0.36%',
    avg_round_30: 3407.0,
    app_flat_30: 19
  },
  {
    char: 'ruan-mei',
    app: 60.78,
    char_1: 'castorice',
    app_rate_1: '39.59%',
    avg_round_1: 3539.0,
    app_flat_1: 1267,
    char_2: 'tingyun-fugue',
    app_rate_2: '36.49%',
    avg_round_2: 3344.0,
    app_flat_2: 576,
    char_3: 'gallagher',
    app_rate_3: '33.56%',
    avg_round_3: 3463.0,
    app_flat_3: 1057,
    char_4: 'trailblazer-remembrance',
    app_rate_4: '33.46%',
    avg_round_4: 3544.0,
    app_flat_4: 1110,
    char_5: 'firefly',
    app_rate_5: '28.14%',
    avg_round_5: 3243.0,
    app_flat_5: 318,
    char_6: 'lingsha',
    app_rate_6: '27.7%',
    avg_round_6: 3362.0,
    app_flat_6: 475,
    char_7: 'luocha',
    app_rate_7: '10.95%',
    avg_round_7: 3491.0,
    app_flat_7: 310,
    char_8: 'trailblazer-harmony',
    app_rate_8: '9.85%',
    avg_round_8: 3264.0,
    app_flat_8: 166,
    char_9: 'sunday',
    app_rate_9: '8.71%',
    avg_round_9: 3540.0,
    app_flat_9: 202,
    char_10: 'boothill',
    app_rate_10: '7.96%',
    avg_round_10: 3447.0,
    app_flat_10: 248,
    char_11: 'the-herta',
    app_rate_11: '6.61%',
    avg_round_11: 3347.0,
    app_flat_11: 183,
    char_12: 'rappa',
    app_rate_12: '5.63%',
    avg_round_12: 3300.0,
    app_flat_12: 141,
    char_13: 'robin',
    app_rate_13: '5.38%',
    avg_round_13: 3589.0,
    app_flat_13: 117,
    char_14: 'tribbie',
    app_rate_14: '5.29%',
    avg_round_14: 3616.0,
    app_flat_14: 124,
    char_15: 'aventurine',
    app_rate_15: '4.29%',
    avg_round_15: 3323.0,
    app_flat_15: 105,
    char_16: 'huohuo',
    app_rate_16: '4.23%',
    avg_round_16: 3371.0,
    app_flat_16: 106,
    char_17: 'mydei',
    app_rate_17: '3.65%',
    avg_round_17: 3419.0,
    app_flat_17: 105,
    char_18: 'herta',
    app_rate_18: '3.24%',
    avg_round_18: 3276.0,
    app_flat_18: 86,
    char_19: 'jade',
    app_rate_19: '3.16%',
    avg_round_19: 3399.0,
    app_flat_19: 88,
    char_20: 'feixiao',
    app_rate_20: '2.6%',
    avg_round_20: 3482.0,
    app_flat_20: 76,
    char_21: 'fu-xuan',
    app_rate_21: '2.42%',
    avg_round_21: 3350.0,
    app_flat_21: 48,
    char_22: 'bronya',
    app_rate_22: '2.18%',
    avg_round_22: 3444.0,
    app_flat_22: 51,
    char_23: 'anaxa',
    app_rate_23: '2.14%',
    avg_round_23: 3705.0,
    app_flat_23: 63,
    char_24: 'sparkle',
    app_rate_24: '1.54%',
    avg_round_24: 3427.0,
    app_flat_24: 27,
    char_25: 'blade',
    app_rate_25: '1.34%',
    avg_round_25: 3401.0,
    app_flat_25: 35,
    char_26: 'march-7th-swordmaster',
    app_rate_26: '1.28%',
    avg_round_26: 3485.0,
    app_flat_26: 42,
    char_27: 'jiaoqiu',
    app_rate_27: '1.15%',
    avg_round_27: 3503.0,
    app_flat_27: 7,
    char_28: 'acheron',
    app_rate_28: '1.07%',
    avg_round_28: 3339,
    app_flat_28: 4,
    char_29: 'yunli',
    app_rate_29: '0.98%',
    avg_round_29: 3412.0,
    app_flat_29: 19,
    char_30: 'tingyun',
    app_rate_30: '0.74%',
    avg_round_30: 3491.0,
    app_flat_30: 8
  },
  {
    char: 'the-herta',
    app: 50.92,
    char_1: 'herta',
    app_rate_1: '51.92%',
    avg_round_1: 3427.0,
    app_flat_1: 2330,
    char_2: 'tribbie',
    app_rate_2: '40.78%',
    avg_round_2: 3526.0,
    app_flat_2: 1665,
    char_3: 'jade',
    app_rate_3: '34.46%',
    avg_round_3: 3478.0,
    app_flat_3: 1442,
    char_4: 'aventurine',
    app_rate_4: '30.73%',
    avg_round_4: 3426.0,
    app_flat_4: 1496,
    char_5: 'trailblazer-remembrance',
    app_rate_5: '19.86%',
    avg_round_5: 3463.0,
    app_flat_5: 961,
    char_6: 'lingsha',
    app_rate_6: '19.59%',
    avg_round_6: 3475.0,
    app_flat_6: 836,
    char_7: 'robin',
    app_rate_7: '18.25%',
    avg_round_7: 3382.0,
    app_flat_7: 748,
    char_8: 'sunday',
    app_rate_8: '17.95%',
    avg_round_8: 3449.0,
    app_flat_8: 853,
    char_9: 'huohuo',
    app_rate_9: '17.23%',
    avg_round_9: 3443.0,
    app_flat_9: 746,
    char_10: 'fu-xuan',
    app_rate_10: '14.3%',
    avg_round_10: 3394.0,
    app_flat_10: 514,
    char_11: 'ruan-mei',
    app_rate_11: '7.89%',
    avg_round_11: 3347.0,
    app_flat_11: 183,
    char_12: 'serval',
    app_rate_12: '5.81%',
    avg_round_12: 3406.0,
    app_flat_12: 217,
    char_13: 'luocha',
    app_rate_13: '4.82%',
    avg_round_13: 3418.0,
    app_flat_13: 198,
    char_14: 'gallagher',
    app_rate_14: '4.24%',
    avg_round_14: 3443.0,
    app_flat_14: 225,
    char_15: 'argenti',
    app_rate_15: '3.96%',
    avg_round_15: 3500.0,
    app_flat_15: 158,
    char_16: 'anaxa',
    app_rate_16: '2.9%',
    avg_round_16: 3543.0,
    app_flat_16: 108,
    char_17: 'sparkle',
    app_rate_17: '2.08%',
    avg_round_17: 3324.0,
    app_flat_17: 49,
    char_18: 'pela',
    app_rate_18: '0.53%',
    avg_round_18: 3331.0,
    app_flat_18: 24,
    char_19: 'rappa',
    app_rate_19: '0.37%',
    avg_round_19: 3373.0,
    app_flat_19: 12,
    char_20: 'bailu',
    app_rate_20: '0.29%',
    avg_round_20: 3376.0,
    app_flat_20: 15,
    char_21: 'bronya',
    app_rate_21: '0.24%',
    avg_round_21: 3296.0,
    app_flat_21: 8,
    char_22: 'castorice',
    app_rate_22: '0.22%',
    avg_round_22: 3341.0,
    app_flat_22: 5,
    char_23: 'gepard',
    app_rate_23: '0.22%',
    avg_round_23: 3291.0,
    app_flat_23: 8,
    char_24: 'mydei',
    app_rate_24: '0.18%',
    avg_round_24: 3406.0,
    app_flat_24: 8,
    char_25: 'himeko',
    app_rate_25: '0.16%',
    avg_round_25: 3351.0,
    app_flat_25: 7,
    char_26: 'lynx',
    app_rate_26: '0.15%',
    avg_round_26: 3401.0,
    app_flat_26: 6,
    char_27: 'jiaoqiu',
    app_rate_27: '0.11%',
    avg_round_27: 3362,
    app_flat_27: 1,
    char_28: 'yunli',
    app_rate_28: '0.1%',
    avg_round_28: 3747,
    app_flat_28: 2,
    char_29: 'tingyun',
    app_rate_29: '0.09%',
    avg_round_29: 3541,
    app_flat_29: 1,
    char_30: 'tingyun-fugue',
    app_rate_30: '0.09%',
    avg_round_30: 3168.0,
    app_flat_30: 2
  },
  {
    char: 'gallagher',
    app: 47.59,
    char_1: 'castorice',
    app_rate_1: '70.33%',
    avg_round_1: 3515.0,
    app_flat_1: 2684,
    char_2: 'trailblazer-remembrance',
    app_rate_2: '63.31%',
    avg_round_2: 3515.0,
    app_flat_2: 2517,
    char_3: 'ruan-mei',
    app_rate_3: '42.86%',
    avg_round_3: 3463.0,
    app_flat_3: 1057,
    char_4: 'tribbie',
    app_rate_4: '41.31%',
    avg_round_4: 3522.0,
    app_flat_4: 1790,
    char_5: 'sunday',
    app_rate_5: '11.23%',
    avg_round_5: 3470.0,
    app_flat_5: 380,
    char_6: 'tingyun-fugue',
    app_rate_6: '11.08%',
    avg_round_6: 3338.0,
    app_flat_6: 203,
    char_7: 'firefly',
    app_rate_7: '9.11%',
    avg_round_7: 3196.0,
    app_flat_7: 125,
    char_8: 'robin',
    app_rate_8: '5.47%',
    avg_round_8: 3394.0,
    app_flat_8: 214,
    char_9: 'boothill',
    app_rate_9: '5.27%',
    avg_round_9: 3424.0,
    app_flat_9: 146,
    char_10: 'trailblazer-harmony',
    app_rate_10: '4.6%',
    avg_round_10: 3226.0,
    app_flat_10: 102,
    char_11: 'the-herta',
    app_rate_11: '4.54%',
    avg_round_11: 3443.0,
    app_flat_11: 225,
    char_12: 'mydei',
    app_rate_12: '4.41%',
    avg_round_12: 3451.0,
    app_flat_12: 173,
    char_13: 'feixiao',
    app_rate_13: '3.56%',
    avg_round_13: 3384.0,
    app_flat_13: 163,
    char_14: 'herta',
    app_rate_14: '2.71%',
    avg_round_14: 3415.0,
    app_flat_14: 140,
    char_15: 'pela',
    app_rate_15: '2.59%',
    avg_round_15: 3369.0,
    app_flat_15: 110,
    char_16: 'march-7th-swordmaster',
    app_rate_16: '2.36%',
    avg_round_16: 3385.0,
    app_flat_16: 125,
    char_17: 'jiaoqiu',
    app_rate_17: '1.8%',
    avg_round_17: 3341.0,
    app_flat_17: 38,
    char_18: 'blade',
    app_rate_18: '1.63%',
    avg_round_18: 3396.0,
    app_flat_18: 58,
    char_19: 'bronya',
    app_rate_19: '1.49%',
    avg_round_19: 3369.0,
    app_flat_19: 51,
    char_20: 'sparkle',
    app_rate_20: '1.48%',
    avg_round_20: 3361.0,
    app_flat_20: 44,
    char_21: 'rappa',
    app_rate_21: '1.31%',
    avg_round_21: 3256.0,
    app_flat_21: 34,
    char_22: 'acheron',
    app_rate_22: '1.27%',
    avg_round_22: 3275.0,
    app_flat_22: 20,
    char_23: 'anaxa',
    app_rate_23: '1.1%',
    avg_round_23: 3560.0,
    app_flat_23: 52,
    char_24: 'topaz',
    app_rate_24: '1.03%',
    avg_round_24: 3329.0,
    app_flat_24: 36,
    char_25: 'jade',
    app_rate_25: '0.96%',
    avg_round_25: 3489.0,
    app_flat_25: 41,
    char_26: 'serval',
    app_rate_26: '0.43%',
    avg_round_26: 3389.0,
    app_flat_26: 17,
    char_27: 'yunli',
    app_rate_27: '0.42%',
    avg_round_27: 3193.0,
    app_flat_27: 13,
    char_28: 'argenti',
    app_rate_28: '0.3%',
    avg_round_28: 3515.0,
    app_flat_28: 13,
    char_29: 'aglaea',
    app_rate_29: '0.24%',
    avg_round_29: 3192,
    app_flat_29: 2,
    char_30: 'silver-wolf',
    app_rate_30: '0.24%',
    avg_round_30: 3444.0,
    app_flat_30: 4
  },
  {
    char: 'robin',
    app: 44.58,
    char_1: 'feixiao',
    app_rate_1: '52.33%',
    avg_round_1: 3404.0,
    app_flat_1: 1848,
    char_2: 'aventurine',
    app_rate_2: '44.63%',
    avg_round_2: 3383.0,
    app_flat_2: 1577,
    char_3: 'topaz',
    app_rate_3: '24.66%',
    avg_round_3: 3376.0,
    app_flat_3: 760,
    char_4: 'march-7th-swordmaster',
    app_rate_4: '23.93%',
    avg_round_4: 3424.0,
    app_flat_4: 1001,
    char_5: 'the-herta',
    app_rate_5: '20.85%',
    avg_round_5: 3382.0,
    app_flat_5: 748,
    char_6: 'jade',
    app_rate_6: '13.3%',
    avg_round_6: 3415.0,
    app_flat_6: 429,
    char_7: 'sunday',
    app_rate_7: '13.14%',
    avg_round_7: 3452.0,
    app_flat_7: 244,
    char_8: 'lingsha',
    app_rate_8: '11.26%',
    avg_round_8: 3400.0,
    app_flat_8: 411,
    char_9: 'huohuo',
    app_rate_9: '10.57%',
    avg_round_9: 3340.0,
    app_flat_9: 293,
    char_10: 'herta',
    app_rate_10: '9.02%',
    avg_round_10: 3321.0,
    app_flat_10: 310,
    char_11: 'yunli',
    app_rate_11: '8.73%',
    avg_round_11: 3267.0,
    app_flat_11: 222,
    char_12: 'ruan-mei',
    app_rate_12: '7.33%',
    avg_round_12: 3589.0,
    app_flat_12: 117,
    char_13: 'fu-xuan',
    app_rate_13: '6.77%',
    avg_round_13: 3325.0,
    app_flat_13: 176,
    char_14: 'trailblazer-remembrance',
    app_rate_14: '6.42%',
    avg_round_14: 3482.0,
    app_flat_14: 160,
    char_15: 'gallagher',
    app_rate_15: '5.84%',
    avg_round_15: 3394.0,
    app_flat_15: 214,
    char_16: 'anaxa',
    app_rate_16: '4.79%',
    avg_round_16: 3628.0,
    app_flat_16: 125,
    char_17: 'tribbie',
    app_rate_17: '4.71%',
    avg_round_17: 3464.0,
    app_flat_17: 85,
    char_18: 'bronya',
    app_rate_18: '3.2%',
    avg_round_18: 3562.0,
    app_flat_18: 58,
    char_19: 'castorice',
    app_rate_19: '3.12%',
    avg_round_19: 3501.0,
    app_flat_19: 69,
    char_20: 'luocha',
    app_rate_20: '2.88%',
    avg_round_20: 3368.0,
    app_flat_20: 82,
    char_21: 'sparkle',
    app_rate_21: '2.59%',
    avg_round_21: 3375.0,
    app_flat_21: 41,
    char_22: 'aglaea',
    app_rate_22: '2.34%',
    avg_round_22: 3353.0,
    app_flat_22: 17,
    char_23: 'jiaoqiu',
    app_rate_23: '2.34%',
    avg_round_23: 3478.0,
    app_flat_23: 12,
    char_24: 'acheron',
    app_rate_24: '2.28%',
    avg_round_24: 3463.0,
    app_flat_24: 4,
    char_25: 'tingyun',
    app_rate_25: '1.97%',
    avg_round_25: 3294.0,
    app_flat_25: 41,
    char_26: 'seele',
    app_rate_26: '1.56%',
    avg_round_26: 3434.0,
    app_flat_26: 22,
    char_27: 'clara',
    app_rate_27: '1.43%',
    avg_round_27: 3170.0,
    app_flat_27: 22,
    char_28: 'moze',
    app_rate_28: '1.24%',
    avg_round_28: 3308.0,
    app_flat_28: 41,
    char_29: 'mydei',
    app_rate_29: '1.0%',
    avg_round_29: 3381.0,
    app_flat_29: 30,
    char_30: 'blade',
    app_rate_30: '0.95%',
    avg_round_30: 3270.0,
    app_flat_30: 14
  },
  {
    char: 'aventurine',
    app: 38.52,
    char_1: 'robin',
    app_rate_1: '51.65%',
    avg_round_1: 3383.0,
    app_flat_1: 1577,
    char_2: 'the-herta',
    app_rate_2: '40.62%',
    avg_round_2: 3426.0,
    app_flat_2: 1496,
    char_3: 'feixiao',
    app_rate_3: '40.29%',
    avg_round_3: 3391.0,
    app_flat_3: 1230,
    char_4: 'herta',
    app_rate_4: '22.8%',
    avg_round_4: 3401.0,
    app_flat_4: 879,
    char_5: 'topaz',
    app_rate_5: '22.37%',
    avg_round_5: 3379.0,
    app_flat_5: 587,
    char_6: 'tribbie',
    app_rate_6: '16.11%',
    avg_round_6: 3494.0,
    app_flat_6: 525,
    char_7: 'jade',
    app_rate_7: '15.26%',
    avg_round_7: 3456.0,
    app_flat_7: 482,
    char_8: 'march-7th-swordmaster',
    app_rate_8: '14.82%',
    avg_round_8: 3408.0,
    app_flat_8: 570,
    char_9: 'sunday',
    app_rate_9: '13.65%',
    avg_round_9: 3400.0,
    app_flat_9: 411,
    char_10: 'acheron',
    app_rate_10: '11.23%',
    avg_round_10: 3304.0,
    app_flat_10: 152,
    char_11: 'jiaoqiu',
    app_rate_11: '9.84%',
    avg_round_11: 3309.0,
    app_flat_11: 137,
    char_12: 'ruan-mei',
    app_rate_12: '6.78%',
    avg_round_12: 3323.0,
    app_flat_12: 105,
    char_13: 'trailblazer-remembrance',
    app_rate_13: '6.73%',
    avg_round_13: 3404.0,
    app_flat_13: 253,
    char_14: 'sparkle',
    app_rate_14: '4.67%',
    avg_round_14: 3288.0,
    app_flat_14: 30,
    char_15: 'pela',
    app_rate_15: '3.93%',
    avg_round_15: 3314.0,
    app_flat_15: 127,
    char_16: 'anaxa',
    app_rate_16: '2.29%',
    avg_round_16: 3502.0,
    app_flat_16: 58,
    char_17: 'serval',
    app_rate_17: '2.09%',
    avg_round_17: 3400.0,
    app_flat_17: 74,
    char_18: 'tingyun-fugue',
    app_rate_18: '1.97%',
    avg_round_18: 3307.0,
    app_flat_18: 27,
    char_19: 'argenti',
    app_rate_19: '1.87%',
    avg_round_19: 3465.0,
    app_flat_19: 51,
    char_20: 'yunli',
    app_rate_20: '1.77%',
    avg_round_20: 3246.0,
    app_flat_20: 41,
    char_21: 'moze',
    app_rate_21: '1.31%',
    avg_round_21: 3301.0,
    app_flat_21: 40,
    char_22: 'bronya',
    app_rate_22: '1.1%',
    avg_round_22: 3336.0,
    app_flat_22: 22,
    char_23: 'silver-wolf',
    app_rate_23: '0.84%',
    avg_round_23: 3244.0,
    app_flat_23: 17,
    char_24: 'rappa',
    app_rate_24: '0.8%',
    avg_round_24: 3285.0,
    app_flat_24: 17,
    char_25: 'boothill',
    app_rate_25: '0.79%',
    avg_round_25: 3378.0,
    app_flat_25: 9,
    char_26: 'firefly',
    app_rate_26: '0.69%',
    avg_round_26: 3178.0,
    app_flat_26: 2,
    char_27: 'clara',
    app_rate_27: '0.65%',
    avg_round_27: 3156.0,
    app_flat_27: 13,
    char_28: 'imbibitor-lunae',
    app_rate_28: '0.44%',
    avg_round_28: 3106,
    app_flat_28: 1,
    char_29: 'trailblazer-harmony',
    app_rate_29: '0.35%',
    avg_round_29: 3087,
    app_flat_29: 3,
    char_30: 'dr-ratio',
    app_rate_30: '0.33%',
    avg_round_30: 3250.0,
    app_flat_30: 4
  },
  {
    char: 'sunday',
    app: 33.93,
    char_1: 'the-herta',
    app_rate_1: '26.93%',
    avg_round_1: 3449.0,
    app_flat_1: 853,
    char_2: 'castorice',
    app_rate_2: '24.24%',
    avg_round_2: 3492.0,
    app_flat_2: 529,
    char_3: 'mydei',
    app_rate_3: '21.52%',
    avg_round_3: 3435.0,
    app_flat_3: 451,
    char_4: 'luocha',
    app_rate_4: '20.89%',
    avg_round_4: 3430.0,
    app_flat_4: 432,
    char_5: 'tribbie',
    app_rate_5: '20.27%',
    avg_round_5: 3496.0,
    app_flat_5: 356,
    char_6: 'trailblazer-remembrance',
    app_rate_6: '19.6%',
    avg_round_6: 3491.0,
    app_flat_6: 496,
    char_7: 'robin',
    app_rate_7: '17.26%',
    avg_round_7: 3452.0,
    app_flat_7: 244,
    char_8: 'gallagher',
    app_rate_8: '15.75%',
    avg_round_8: 3470.0,
    app_flat_8: 380,
    char_9: 'ruan-mei',
    app_rate_9: '15.59%',
    avg_round_9: 3540.0,
    app_flat_9: 202,
    char_10: 'aventurine',
    app_rate_10: '15.5%',
    avg_round_10: 3400.0,
    app_flat_10: 411,
    char_11: 'herta',
    app_rate_11: '14.83%',
    avg_round_11: 3432.0,
    app_flat_11: 499,
    char_12: 'huohuo',
    app_rate_12: '14.13%',
    avg_round_12: 3399.0,
    app_flat_12: 292,
    char_13: 'jade',
    app_rate_13: '8.91%',
    avg_round_13: 3499.0,
    app_flat_13: 252,
    char_14: 'lingsha',
    app_rate_14: '7.64%',
    avg_round_14: 3463.0,
    app_flat_14: 208,
    char_15: 'anaxa',
    app_rate_15: '5.7%',
    avg_round_15: 3609.0,
    app_flat_15: 109,
    char_16: 'jiaoqiu',
    app_rate_16: '5.66%',
    avg_round_16: 3399.0,
    app_flat_16: 31,
    char_17: 'fu-xuan',
    app_rate_17: '5.36%',
    avg_round_17: 3368.0,
    app_flat_17: 112,
    char_18: 'acheron',
    app_rate_18: '4.33%',
    avg_round_18: 3190.0,
    app_flat_18: 9,
    char_19: 'aglaea',
    app_rate_19: '3.78%',
    avg_round_19: 3344.0,
    app_flat_19: 25,
    char_20: 'yunli',
    app_rate_20: '3.34%',
    avg_round_20: 3212.0,
    app_flat_20: 66,
    char_21: 'sparkle',
    app_rate_21: '3.32%',
    avg_round_21: 3389.0,
    app_flat_21: 56,
    char_22: 'bronya',
    app_rate_22: '2.87%',
    avg_round_22: 3420.0,
    app_flat_22: 47,
    char_23: 'argenti',
    app_rate_23: '2.24%',
    avg_round_23: 3369.0,
    app_flat_23: 38,
    char_24: 'feixiao',
    app_rate_24: '2.11%',
    avg_round_24: 3431.0,
    app_flat_24: 48,
    char_25: 'pela',
    app_rate_25: '2.03%',
    avg_round_25: 3419.0,
    app_flat_25: 31,
    char_26: 'boothill',
    app_rate_26: '1.86%',
    avg_round_26: 3438.0,
    app_flat_26: 27,
    char_27: 'serval',
    app_rate_27: '1.82%',
    avg_round_27: 3378.0,
    app_flat_27: 49,
    char_28: 'blade',
    app_rate_28: '1.73%',
    avg_round_28: 3320.0,
    app_flat_28: 16,
    char_29: 'tingyun-fugue',
    app_rate_29: '1.54%',
    avg_round_29: 3557.0,
    app_flat_29: 14,
    char_30: 'seele',
    app_rate_30: '1.42%',
    avg_round_30: 3360.0,
    app_flat_30: 21
  },
  {
    char: 'lingsha',
    app: 32.26,
    char_1: 'ruan-mei',
    app_rate_1: '52.18%',
    avg_round_1: 3362.0,
    app_flat_1: 475,
    char_2: 'tingyun-fugue',
    app_rate_2: '40.67%',
    avg_round_2: 3322.0,
    app_flat_2: 298,
    char_3: 'firefly',
    app_rate_3: '31.82%',
    avg_round_3: 3263.0,
    app_flat_3: 172,
    char_4: 'the-herta',
    app_rate_4: '30.92%',
    avg_round_4: 3475.0,
    app_flat_4: 836,
    char_5: 'tribbie',
    app_rate_5: '20.34%',
    avg_round_5: 3524.0,
    app_flat_5: 523,
    char_6: 'robin',
    app_rate_6: '15.56%',
    avg_round_6: 3400.0,
    app_flat_6: 411,
    char_7: 'jade',
    app_rate_7: '15.3%',
    avg_round_7: 3497.0,
    app_flat_7: 390,
    char_8: 'trailblazer-remembrance',
    app_rate_8: '14.26%',
    avg_round_8: 3493.0,
    app_flat_8: 389,
    char_9: 'castorice',
    app_rate_9: '14.0%',
    avg_round_9: 3509.0,
    app_flat_9: 313,
    char_10: 'herta',
    app_rate_10: '13.0%',
    avg_round_10: 3445.0,
    app_flat_10: 372,
    char_11: 'sunday',
    app_rate_11: '8.03%',
    avg_round_11: 3463.0,
    app_flat_11: 208,
    char_12: 'feixiao',
    app_rate_12: '7.67%',
    avg_round_12: 3377.0,
    app_flat_12: 216,
    char_13: 'trailblazer-harmony',
    app_rate_13: '6.51%',
    avg_round_13: 3260.0,
    app_flat_13: 40,
    char_14: 'rappa',
    app_rate_14: '6.19%',
    avg_round_14: 3330.0,
    app_flat_14: 80,
    char_15: 'march-7th-swordmaster',
    app_rate_15: '3.78%',
    avg_round_15: 3394.0,
    app_flat_15: 130,
    char_16: 'boothill',
    app_rate_16: '3.4%',
    avg_round_16: 3448.0,
    app_flat_16: 60,
    char_17: 'topaz',
    app_rate_17: '3.02%',
    avg_round_17: 3347.0,
    app_flat_17: 80,
    char_18: 'lingsha',
    app_rate_18: '2.2%',
    avg_round_18: 0,
    app_flat_18: 0,
    char_19: 'sparkle',
    app_rate_19: '1.68%',
    avg_round_19: 3328.0,
    app_flat_19: 16,
    char_20: 'serval',
    app_rate_20: '1.62%',
    avg_round_20: 3428.0,
    app_flat_20: 35,
    char_21: 'anaxa',
    app_rate_21: '1.1%',
    avg_round_21: 3575.0,
    app_flat_21: 29,
    char_22: 'jiaoqiu',
    app_rate_22: '1.08%',
    avg_round_22: 3283.0,
    app_flat_22: 13,
    char_23: 'acheron',
    app_rate_23: '1.06%',
    avg_round_23: 3255.0,
    app_flat_23: 8,
    char_24: 'yunli',
    app_rate_24: '1.0%',
    avg_round_24: 3205.0,
    app_flat_24: 17,
    char_25: 'argenti',
    app_rate_25: '0.88%',
    avg_round_25: 3452.0,
    app_flat_25: 22,
    char_26: 'mydei',
    app_rate_26: '0.86%',
    avg_round_26: 3389.0,
    app_flat_26: 24,
    char_27: 'bronya',
    app_rate_27: '0.74%',
    avg_round_27: 3352.0,
    app_flat_27: 12,
    char_28: 'blade',
    app_rate_28: '0.58%',
    avg_round_28: 3426.0,
    app_flat_28: 8,
    char_29: 'pela',
    app_rate_29: '0.58%',
    avg_round_29: 3343,
    app_flat_29: 15,
    char_30: 'himeko',
    app_rate_30: '0.24%',
    avg_round_30: 3202.0,
    app_flat_30: 4
  },
  {
    char: 'luocha',
    app: 27.93,
    char_1: 'castorice',
    app_rate_1: '71.44%',
    avg_round_1: 3498.0,
    app_flat_1: 1343,
    char_2: 'trailblazer-remembrance',
    app_rate_2: '64.86%',
    avg_round_2: 3492.0,
    app_flat_2: 1309,
    char_3: 'tribbie',
    app_rate_3: '49.01%',
    avg_round_3: 3508.0,
    app_flat_3: 977,
    char_4: 'sunday',
    app_rate_4: '25.38%',
    avg_round_4: 3430.0,
    app_flat_4: 432,
    char_5: 'ruan-mei',
    app_rate_5: '23.83%',
    avg_round_5: 3491.0,
    app_flat_5: 310,
    char_6: 'mydei',
    app_rate_6: '20.95%',
    avg_round_6: 3430.0,
    app_flat_6: 380,
    char_7: 'the-herta',
    app_rate_7: '8.79%',
    avg_round_7: 3418.0,
    app_flat_7: 198,
    char_8: 'robin',
    app_rate_8: '4.59%',
    avg_round_8: 3368.0,
    app_flat_8: 82,
    char_9: 'herta',
    app_rate_9: '4.29%',
    avg_round_9: 3402.0,
    app_flat_9: 99,
    char_10: 'jade',
    app_rate_10: '3.21%',
    avg_round_10: 3436.0,
    app_flat_10: 69,
    char_11: 'sparkle',
    app_rate_11: '2.88%',
    avg_round_11: 3388.0,
    app_flat_11: 40,
    char_12: 'pela',
    app_rate_12: '2.79%',
    avg_round_12: 3347.0,
    app_flat_12: 58,
    char_13: 'bronya',
    app_rate_13: '2.65%',
    avg_round_13: 3358.0,
    app_flat_13: 45,
    char_14: 'blade',
    app_rate_14: '2.42%',
    avg_round_14: 3402.0,
    app_flat_14: 46,
    char_15: 'jiaoqiu',
    app_rate_15: '2.19%',
    avg_round_15: 3409.0,
    app_flat_15: 25,
    char_16: 'feixiao',
    app_rate_16: '1.41%',
    avg_round_16: 3344.0,
    app_flat_16: 32,
    char_17: 'anaxa',
    app_rate_17: '0.9%',
    avg_round_17: 3540.0,
    app_flat_17: 16,
    char_18: 'tingyun-fugue',
    app_rate_18: '0.78%',
    avg_round_18: 3413.0,
    app_flat_18: 6,
    char_19: 'argenti',
    app_rate_19: '0.78%',
    avg_round_19: 3469.0,
    app_flat_19: 15,
    char_20: 'march-7th-swordmaster',
    app_rate_20: '0.74%',
    avg_round_20: 3346.0,
    app_flat_20: 20,
    char_21: 'yunli',
    app_rate_21: '0.72%',
    avg_round_21: 3244.0,
    app_flat_21: 9,
    char_22: 'acheron',
    app_rate_22: '0.69%',
    avg_round_22: 3356.0,
    app_flat_22: 6,
    char_23: 'imbibitor-lunae',
    app_rate_23: '0.55%',
    avg_round_23: 0,
    app_flat_23: 0,
    char_24: 'topaz',
    app_rate_24: '0.51%',
    avg_round_24: 3295.0,
    app_flat_24: 9,
    char_25: 'rappa',
    app_rate_25: '0.44%',
    avg_round_25: 3315,
    app_flat_25: 5,
    char_26: 'serval',
    app_rate_26: '0.42%',
    avg_round_26: 3354.0,
    app_flat_26: 7,
    char_27: 'boothill',
    app_rate_27: '0.35%',
    avg_round_27: 3285.0,
    app_flat_27: 5,
    char_28: 'jingliu',
    app_rate_28: '0.3%',
    avg_round_28: 3215,
    app_flat_28: 3,
    char_29: 'silver-wolf',
    app_rate_29: '0.28%',
    avg_round_29: 3373.0,
    app_flat_29: 5,
    char_30: 'aglaea',
    app_rate_30: '0.28%',
    avg_round_30: 3418,
    app_flat_30: 1
  },
  {
    char: 'herta',
    app: 26.84,
    char_1: 'the-herta',
    app_rate_1: '98.51%',
    avg_round_1: 3427.0,
    app_flat_1: 2330,
    char_2: 'tribbie',
    app_rate_2: '41.45%',
    avg_round_2: 3513.0,
    app_flat_2: 926,
    char_3: 'aventurine',
    app_rate_3: '32.73%',
    avg_round_3: 3401.0,
    app_flat_3: 879,
    char_4: 'trailblazer-remembrance',
    app_rate_4: '22.96%',
    avg_round_4: 3445.0,
    app_flat_4: 594,
    char_5: 'sunday',
    app_rate_5: '18.76%',
    avg_round_5: 3432.0,
    app_flat_5: 499,
    char_6: 'huohuo',
    app_rate_6: '16.28%',
    avg_round_6: 3422.0,
    app_flat_6: 389,
    char_7: 'lingsha',
    app_rate_7: '15.63%',
    avg_round_7: 3445.0,
    app_flat_7: 372,
    char_8: 'robin',
    app_rate_8: '14.99%',
    avg_round_8: 3321.0,
    app_flat_8: 310,
    char_9: 'fu-xuan',
    app_rate_9: '14.99%',
    avg_round_9: 3367.0,
    app_flat_9: 295,
    char_10: 'ruan-mei',
    app_rate_10: '7.35%',
    avg_round_10: 3276.0,
    app_flat_10: 86,
    char_11: 'gallagher',
    app_rate_11: '4.8%',
    avg_round_11: 3415.0,
    app_flat_11: 140,
    char_12: 'luocha',
    app_rate_12: '4.47%',
    avg_round_12: 3402.0,
    app_flat_12: 99,
    char_13: 'sparkle',
    app_rate_13: '2.28%',
    avg_round_13: 3292.0,
    app_flat_13: 25,
    char_14: 'jade',
    app_rate_14: '1.63%',
    avg_round_14: 3240.0,
    app_flat_14: 29,
    char_15: 'pela',
    app_rate_15: '0.67%',
    avg_round_15: 3259.0,
    app_flat_15: 13,
    char_16: 'bailu',
    app_rate_16: '0.36%',
    avg_round_16: 3356,
    app_flat_16: 10,
    char_17: 'gepard',
    app_rate_17: '0.26%',
    avg_round_17: 3229.0,
    app_flat_17: 4,
    char_18: 'bronya',
    app_rate_18: '0.26%',
    avg_round_18: 3184,
    app_flat_18: 4,
    char_19: 'castorice',
    app_rate_19: '0.22%',
    avg_round_19: 3296.0,
    app_flat_19: 3,
    char_20: 'yunli',
    app_rate_20: '0.17%',
    avg_round_20: 3747,
    app_flat_20: 2,
    char_21: 'tingyun',
    app_rate_21: '0.14%',
    avg_round_21: 3541,
    app_flat_21: 1,
    char_22: 'jiaoqiu',
    app_rate_22: '0.12%',
    avg_round_22: 0,
    app_flat_22: 0,
    char_23: 'lynx',
    app_rate_23: '0.12%',
    avg_round_23: 3330,
    app_flat_23: 1,
    char_24: 'clara',
    app_rate_24: '0.12%',
    avg_round_24: 3017,
    app_flat_24: 1,
    char_25: 'mydei',
    app_rate_25: '0.1%',
    avg_round_25: 3542,
    app_flat_25: 1,
    char_26: 'tingyun-fugue',
    app_rate_26: '0.07%',
    avg_round_26: 3168.0,
    app_flat_26: 2,
    char_27: 'silver-wolf',
    app_rate_27: '0.07%',
    avg_round_27: 0,
    app_flat_27: 0,
    char_28: 'acheron',
    app_rate_28: '0.05%',
    avg_round_28: 0,
    app_flat_28: 0,
    char_29: 'march-7th',
    app_rate_29: '0.05%',
    avg_round_29: 0,
    app_flat_29: 0,
    char_30: 'hanya',
    app_rate_30: '0.05%',
    avg_round_30: 0,
    app_flat_30: 0
  },
  {
    char: 'feixiao',
    app: 25.19,
    char_1: 'robin',
    app_rate_1: '92.61%',
    avg_round_1: 3404.0,
    app_flat_1: 1848,
    char_2: 'aventurine',
    app_rate_2: '61.6%',
    avg_round_2: 3391.0,
    app_flat_2: 1230,
    char_3: 'march-7th-swordmaster',
    app_rate_3: '44.46%',
    avg_round_3: 3416.0,
    app_flat_3: 1068,
    char_4: 'topaz',
    app_rate_4: '42.9%',
    avg_round_4: 3377.0,
    app_flat_4: 766,
    char_5: 'lingsha',
    app_rate_5: '9.82%',
    avg_round_5: 3377.0,
    app_flat_5: 216,
    char_6: 'gallagher',
    app_rate_6: '6.73%',
    avg_round_6: 3384.0,
    app_flat_6: 163,
    char_7: 'ruan-mei',
    app_rate_7: '6.27%',
    avg_round_7: 3482.0,
    app_flat_7: 76,
    char_8: 'fu-xuan',
    app_rate_8: '5.47%',
    avg_round_8: 3344.0,
    app_flat_8: 101,
    char_9: 'huohuo',
    app_rate_9: '3.91%',
    avg_round_9: 3357.0,
    app_flat_9: 88,
    char_10: 'bronya',
    app_rate_10: '3.89%',
    avg_round_10: 3467.0,
    app_flat_10: 61,
    char_11: 'tribbie',
    app_rate_11: '3.02%',
    avg_round_11: 3391.0,
    app_flat_11: 46,
    char_12: 'sunday',
    app_rate_12: '2.84%',
    avg_round_12: 3431.0,
    app_flat_12: 48,
    char_13: 'yunli',
    app_rate_13: '2.63%',
    avg_round_13: 3333.0,
    app_flat_13: 45,
    char_14: 'trailblazer-remembrance',
    app_rate_14: '2.56%',
    avg_round_14: 3463.0,
    app_flat_14: 42,
    char_15: 'moze',
    app_rate_15: '2.38%',
    avg_round_15: 3301.0,
    app_flat_15: 44,
    char_16: 'jade',
    app_rate_16: '2.35%',
    avg_round_16: 3310.0,
    app_flat_16: 5,
    char_17: 'luocha',
    app_rate_17: '1.56%',
    avg_round_17: 3344.0,
    app_flat_17: 32,
    char_18: 'sparkle',
    app_rate_18: '1.13%',
    avg_round_18: 3334.0,
    app_flat_18: 16,
    char_19: 'jiaoqiu',
    app_rate_19: '0.69%',
    avg_round_19: 3332,
    app_flat_19: 6,
    char_20: 'castorice',
    app_rate_20: '0.61%',
    avg_round_20: 3456.0,
    app_flat_20: 13,
    char_21: 'clara',
    app_rate_21: '0.59%',
    avg_round_21: 3247.0,
    app_flat_21: 13,
    char_22: 'bailu',
    app_rate_22: '0.41%',
    avg_round_22: 3352.0,
    app_flat_22: 10,
    char_23: 'tingyun-fugue',
    app_rate_23: '0.33%',
    avg_round_23: 3258.0,
    app_flat_23: 4,
    char_24: 'aglaea',
    app_rate_24: '0.2%',
    avg_round_24: 0,
    app_flat_24: 0,
    char_25: 'seele',
    app_rate_25: '0.18%',
    avg_round_25: 0,
    app_flat_25: 0,
    char_26: 'boothill',
    app_rate_26: '0.1%',
    avg_round_26: 0,
    app_flat_26: 0,
    char_27: 'blade',
    app_rate_27: '0.1%',
    avg_round_27: 0,
    app_flat_27: 0,
    char_28: 'acheron',
    app_rate_28: '0.08%',
    avg_round_28: 0,
    app_flat_28: 0,
    char_29: 'gepard',
    app_rate_29: '0.08%',
    avg_round_29: 3289,
    app_flat_29: 2,
    char_30: 'himeko',
    app_rate_30: '0.05%',
    avg_round_30: 3192,
    app_flat_30: 1
  },
  {
    char: 'tingyun-fugue',
    app: 23.48,
    char_1: 'ruan-mei',
    app_rate_1: '94.46%',
    avg_round_1: 3344.0,
    app_flat_1: 576,
    char_2: 'firefly',
    app_rate_2: '61.71%',
    avg_round_2: 3256.0,
    app_flat_2: 238,
    char_3: 'lingsha',
    app_rate_3: '55.89%',
    avg_round_3: 3322.0,
    app_flat_3: 298,
    char_4: 'gallagher',
    app_rate_4: '22.45%',
    avg_round_4: 3338.0,
    app_flat_4: 203,
    char_5: 'boothill',
    app_rate_5: '16.96%',
    avg_round_5: 3474.0,
    app_flat_5: 182,
    char_6: 'rappa',
    app_rate_6: '14.27%',
    avg_round_6: 3307.0,
    app_flat_6: 136,
    char_7: 'trailblazer-harmony',
    app_rate_7: '11.23%',
    avg_round_7: 3422.0,
    app_flat_7: 43,
    char_8: 'aventurine',
    app_rate_8: '3.24%',
    avg_round_8: 3307.0,
    app_flat_8: 27,
    char_9: 'castorice',
    app_rate_9: '2.66%',
    avg_round_9: 3469.0,
    app_flat_9: 27,
    char_10: 'bronya',
    app_rate_10: '2.55%',
    avg_round_10: 3435.0,
    app_flat_10: 4,
    char_11: 'sunday',
    app_rate_11: '2.22%',
    avg_round_11: 3557.0,
    app_flat_11: 14,
    char_12: 'huohuo',
    app_rate_12: '2.17%',
    avg_round_12: 3248.0,
    app_flat_12: 16,
    char_13: 'acheron',
    app_rate_13: '1.37%',
    avg_round_13: 3331.0,
    app_flat_13: 9,
    char_14: 'tribbie',
    app_rate_14: '1.1%',
    avg_round_14: 3499.0,
    app_flat_14: 4,
    char_15: 'fu-xuan',
    app_rate_15: '0.96%',
    avg_round_15: 3190.0,
    app_flat_15: 6,
    char_16: 'trailblazer-remembrance',
    app_rate_16: '0.96%',
    avg_round_16: 3481.0,
    app_flat_16: 9,
    char_17: 'luocha',
    app_rate_17: '0.93%',
    avg_round_17: 3413.0,
    app_flat_17: 6,
    char_18: 'jiaoqiu',
    app_rate_18: '0.71%',
    avg_round_18: 3370.0,
    app_flat_18: 9,
    char_19: 'xueyi',
    app_rate_19: '0.58%',
    avg_round_19: 3211.0,
    app_flat_19: 4,
    char_20: 'robin',
    app_rate_20: '0.58%',
    avg_round_20: 3358.0,
    app_flat_20: 2,
    char_21: 'himeko',
    app_rate_21: '0.49%',
    avg_round_21: 3109,
    app_flat_21: 2,
    char_22: 'anaxa',
    app_rate_22: '0.47%',
    avg_round_22: 3542.0,
    app_flat_22: 6,
    char_23: 'sparkle',
    app_rate_23: '0.38%',
    avg_round_23: 0,
    app_flat_23: 0,
    char_24: 'feixiao',
    app_rate_24: '0.36%',
    avg_round_24: 3258.0,
    app_flat_24: 4,
    char_25: 'march-7th-swordmaster',
    app_rate_25: '0.3%',
    avg_round_25: 3339,
    app_flat_25: 2,
    char_26: 'yunli',
    app_rate_26: '0.22%',
    avg_round_26: 0,
    app_flat_26: 0,
    char_27: 'mydei',
    app_rate_27: '0.19%',
    avg_round_27: 3354,
    app_flat_27: 1,
    char_28: 'the-herta',
    app_rate_28: '0.19%',
    avg_round_28: 3168.0,
    app_flat_28: 2,
    char_29: 'silver-wolf',
    app_rate_29: '0.16%',
    avg_round_29: 3305,
    app_flat_29: 1,
    char_30: 'sampo',
    app_rate_30: '0.14%',
    avg_round_30: 2955,
    app_flat_30: 1
  },
  {
    char: 'jade',
    app: 19.41,
    char_1: 'the-herta',
    app_rate_1: '90.4%',
    avg_round_1: 3478.0,
    app_flat_1: 1442,
    char_2: 'tribbie',
    app_rate_2: '33.34%',
    avg_round_2: 3552.0,
    app_flat_2: 478,
    char_3: 'robin',
    app_rate_3: '30.55%',
    avg_round_3: 3415.0,
    app_flat_3: 429,
    char_4: 'aventurine',
    app_rate_4: '30.29%',
    avg_round_4: 3456.0,
    app_flat_4: 482,
    char_5: 'lingsha',
    app_rate_5: '25.44%',
    avg_round_5: 3497.0,
    app_flat_5: 390,
    char_6: 'huohuo',
    app_rate_6: '17.44%',
    avg_round_6: 3470.0,
    app_flat_6: 272,
    char_7: 'sunday',
    app_rate_7: '15.58%',
    avg_round_7: 3499.0,
    app_flat_7: 252,
    char_8: 'fu-xuan',
    app_rate_8: '12.82%',
    avg_round_8: 3421.0,
    app_flat_8: 168,
    char_9: 'trailblazer-remembrance',
    app_rate_9: '12.79%',
    avg_round_9: 3506.0,
    app_flat_9: 234,
    char_10: 'ruan-mei',
    app_rate_10: '9.9%',
    avg_round_10: 3399.0,
    app_flat_10: 88,
    char_11: 'luocha',
    app_rate_11: '4.62%',
    avg_round_11: 3436.0,
    app_flat_11: 69,
    char_12: 'feixiao',
    app_rate_12: '3.06%',
    avg_round_12: 3310.0,
    app_flat_12: 5,
    char_13: 'sparkle',
    app_rate_13: '2.39%',
    avg_round_13: 3345.0,
    app_flat_13: 24,
    char_14: 'gallagher',
    app_rate_14: '2.36%',
    avg_round_14: 3489.0,
    app_flat_14: 41,
    char_15: 'herta',
    app_rate_15: '2.26%',
    avg_round_15: 3240.0,
    app_flat_15: 29,
    char_16: 'blade',
    app_rate_16: '1.0%',
    avg_round_16: 3208,
    app_flat_16: 6,
    char_17: 'bronya',
    app_rate_17: '0.66%',
    avg_round_17: 3304.0,
    app_flat_17: 7,
    char_18: 'yunli',
    app_rate_18: '0.53%',
    avg_round_18: 3178.0,
    app_flat_18: 3,
    char_19: 'mydei',
    app_rate_19: '0.53%',
    avg_round_19: 3352.0,
    app_flat_19: 6,
    char_20: 'pela',
    app_rate_20: '0.53%',
    avg_round_20: 3402.0,
    app_flat_20: 10,
    char_21: 'topaz',
    app_rate_21: '0.5%',
    avg_round_21: 0,
    app_flat_21: 0,
    char_22: 'castorice',
    app_rate_22: '0.46%',
    avg_round_22: 3343.0,
    app_flat_22: 5,
    char_23: 'anaxa',
    app_rate_23: '0.33%',
    avg_round_23: 3483,
    app_flat_23: 3,
    char_24: 'lynx',
    app_rate_24: '0.33%',
    avg_round_24: 3403.0,
    app_flat_24: 5,
    char_25: 'bailu',
    app_rate_25: '0.3%',
    avg_round_25: 3391.0,
    app_flat_25: 4,
    char_26: 'clara',
    app_rate_26: '0.27%',
    avg_round_26: 0,
    app_flat_26: 0,
    char_27: 'jiaoqiu',
    app_rate_27: '0.2%',
    avg_round_27: 3362,
    app_flat_27: 1,
    char_28: 'aglaea',
    app_rate_28: '0.17%',
    avg_round_28: 0,
    app_flat_28: 0,
    char_29: 'tingyun-fugue',
    app_rate_29: '0.17%',
    avg_round_29: 0,
    app_flat_29: 0,
    char_30: 'gepard',
    app_rate_30: '0.13%',
    avg_round_30: 3368,
    app_flat_30: 2
  },
  {
    char: 'huohuo',
    app: 17.79,
    char_1: 'the-herta',
    app_rate_1: '49.29%',
    avg_round_1: 3443.0,
    app_flat_1: 746,
    char_2: 'tribbie',
    app_rate_2: '32.38%',
    avg_round_2: 3470.0,
    app_flat_2: 430,
    char_3: 'sunday',
    app_rate_3: '26.95%',
    avg_round_3: 3399.0,
    app_flat_3: 292,
    char_4: 'robin',
    app_rate_4: '26.48%',
    avg_round_4: 3340.0,
    app_flat_4: 293,
    char_5: 'herta',
    app_rate_5: '24.56%',
    avg_round_5: 3422.0,
    app_flat_5: 389,
    char_6: 'trailblazer-remembrance',
    app_rate_6: '24.23%',
    avg_round_6: 3421.0,
    app_flat_6: 376,
    char_7: 'jade',
    app_rate_7: '19.01%',
    avg_round_7: 3470.0,
    app_flat_7: 272,
    char_8: 'ruan-mei',
    app_rate_8: '14.45%',
    avg_round_8: 3371.0,
    app_flat_8: 106,
    char_9: 'castorice',
    app_rate_9: '12.46%',
    avg_round_9: 3468.0,
    app_flat_9: 148,
    char_10: 'yunli',
    app_rate_10: '11.34%',
    avg_round_10: 3242.0,
    app_flat_10: 111,
    char_11: 'mydei',
    app_rate_11: '9.2%',
    avg_round_11: 3398.0,
    app_flat_11: 122,
    char_12: 'sparkle',
    app_rate_12: '5.69%',
    avg_round_12: 3316.0,
    app_flat_12: 47,
    char_13: 'feixiao',
    app_rate_13: '5.54%',
    avg_round_13: 3357.0,
    app_flat_13: 88,
    char_14: 'march-7th-swordmaster',
    app_rate_14: '3.33%',
    avg_round_14: 3377.0,
    app_flat_14: 60,
    char_15: 'serval',
    app_rate_15: '3.22%',
    avg_round_15: 3407.0,
    app_flat_15: 40,
    char_16: 'tingyun-fugue',
    app_rate_16: '2.86%',
    avg_round_16: 3248.0,
    app_flat_16: 16,
    char_17: 'anaxa',
    app_rate_17: '2.83%',
    avg_round_17: 3541.0,
    app_flat_17: 34,
    char_18: 'argenti',
    app_rate_18: '2.83%',
    avg_round_18: 3445.0,
    app_flat_18: 34,
    char_19: 'aglaea',
    app_rate_19: '2.75%',
    avg_round_19: 3234.0,
    app_flat_19: 9,
    char_20: 'topaz',
    app_rate_20: '2.54%',
    avg_round_20: 3296.0,
    app_flat_20: 27,
    char_21: 'tingyun',
    app_rate_21: '1.88%',
    avg_round_21: 3253.0,
    app_flat_21: 17,
    char_22: 'jiaoqiu',
    app_rate_22: '1.85%',
    avg_round_22: 3296.0,
    app_flat_22: 10,
    char_23: 'acheron',
    app_rate_23: '1.7%',
    avg_round_23: 3174.0,
    app_flat_23: 6,
    char_24: 'bronya',
    app_rate_24: '1.63%',
    avg_round_24: 3362.0,
    app_flat_24: 24,
    char_25: 'pela',
    app_rate_25: '1.48%',
    avg_round_25: 3316.0,
    app_flat_25: 16,
    char_26: 'rappa',
    app_rate_26: '1.41%',
    avg_round_26: 3263.0,
    app_flat_26: 11,
    char_27: 'firefly',
    app_rate_27: '1.23%',
    avg_round_27: 3149,
    app_flat_27: 1,
    char_28: 'imbibitor-lunae',
    app_rate_28: '1.16%',
    avg_round_28: 0,
    app_flat_28: 0,
    char_29: 'clara',
    app_rate_29: '0.76%',
    avg_round_29: 3040.0,
    app_flat_29: 2,
    char_30: 'blade',
    app_rate_30: '0.72%',
    avg_round_30: 3358,
    app_flat_30: 4
  },
  {
    char: 'firefly',
    app: 17.49,
    char_1: 'ruan-mei',
    app_rate_1: '97.79%',
    avg_round_1: 3243.0,
    app_flat_1: 318,
    char_2: 'tingyun-fugue',
    app_rate_2: '82.83%',
    avg_round_2: 3256.0,
    app_flat_2: 238,
    char_3: 'lingsha',
    app_rate_3: '58.7%',
    avg_round_3: 3263.0,
    app_flat_3: 172,
    char_4: 'trailblazer-harmony',
    app_rate_4: '26.6%',
    avg_round_4: 3214.0,
    app_flat_4: 100,
    char_5: 'gallagher',
    app_rate_5: '24.8%',
    avg_round_5: 3196.0,
    app_flat_5: 125,
    char_6: 'bronya',
    app_rate_6: '1.73%',
    avg_round_6: 0,
    app_flat_6: 0,
    char_7: 'aventurine',
    app_rate_7: '1.51%',
    avg_round_7: 3178.0,
    app_flat_7: 2,
    char_8: 'huohuo',
    app_rate_8: '1.25%',
    avg_round_8: 3149,
    app_flat_8: 1,
    char_9: 'rappa',
    app_rate_9: '0.66%',
    avg_round_9: 0,
    app_flat_9: 0,
    char_10: 'fu-xuan',
    app_rate_10: '0.55%',
    avg_round_10: 0,
    app_flat_10: 0,
    char_11: 'castorice',
    app_rate_11: '0.44%',
    avg_round_11: 3253,
    app_flat_11: 1,
    char_12: 'himeko',
    app_rate_12: '0.33%',
    avg_round_12: 0,
    app_flat_12: 0,
    char_13: 'luocha',
    app_rate_13: '0.29%',
    avg_round_13: 0,
    app_flat_13: 0,
    char_14: 'sunday',
    app_rate_14: '0.29%',
    avg_round_14: 0,
    app_flat_14: 0,
    char_15: 'trailblazer-remembrance',
    app_rate_15: '0.26%',
    avg_round_15: 0,
    app_flat_15: 0,
    char_16: 'jiaoqiu',
    app_rate_16: '0.18%',
    avg_round_16: 0,
    app_flat_16: 0,
    char_17: 'march-7th-swordmaster',
    app_rate_17: '0.18%',
    avg_round_17: 0,
    app_flat_17: 0,
    char_18: 'tribbie',
    app_rate_18: '0.15%',
    avg_round_18: 0,
    app_flat_18: 0,
    char_19: 'bailu',
    app_rate_19: '0.15%',
    avg_round_19: 0,
    app_flat_19: 0,
    char_20: 'asta',
    app_rate_20: '0.15%',
    avg_round_20: 0,
    app_flat_20: 0,
    char_21: 'acheron',
    app_rate_21: '0.15%',
    avg_round_21: 0,
    app_flat_21: 0,
    char_22: 'sparkle',
    app_rate_22: '0.15%',
    avg_round_22: 0,
    app_flat_22: 0,
    char_23: 'silver-wolf',
    app_rate_23: '0.15%',
    avg_round_23: 0,
    app_flat_23: 0,
    char_24: 'robin',
    app_rate_24: '0.11%',
    avg_round_24: 0,
    app_flat_24: 0,
    char_25: 'blade',
    app_rate_25: '0.11%',
    avg_round_25: 0,
    app_flat_25: 0,
    char_26: 'tingyun',
    app_rate_26: '0.07%',
    avg_round_26: 0,
    app_flat_26: 0,
    char_27: 'mydei',
    app_rate_27: '0.07%',
    avg_round_27: 0,
    app_flat_27: 0,
    char_28: 'yunli',
    app_rate_28: '0.07%',
    avg_round_28: 0,
    app_flat_28: 0,
    char_29: 'clara',
    app_rate_29: '0.04%',
    avg_round_29: 0,
    app_flat_29: 0,
    char_30: 'hanya',
    app_rate_30: '0.04%',
    avg_round_30: 0,
    app_flat_30: 0
  },
  {
    char: 'fu-xuan',
    app: 13.83,
    char_1: 'the-herta',
    app_rate_1: '52.66%',
    avg_round_1: 3394.0,
    app_flat_1: 514,
    char_2: 'herta',
    app_rate_2: '29.08%',
    avg_round_2: 3367.0,
    app_flat_2: 295,
    char_3: 'tribbie',
    app_rate_3: '28.7%',
    avg_round_3: 3469.0,
    app_flat_3: 236,
    char_4: 'robin',
    app_rate_4: '21.81%',
    avg_round_4: 3325.0,
    app_flat_4: 176,
    char_5: 'acheron',
    app_rate_5: '19.38%',
    avg_round_5: 3305.0,
    app_flat_5: 54,
    char_6: 'jade',
    app_rate_6: '17.99%',
    avg_round_6: 3421.0,
    app_flat_6: 168,
    char_7: 'jiaoqiu',
    app_rate_7: '14.77%',
    avg_round_7: 3311.0,
    app_flat_7: 51,
    char_8: 'trailblazer-remembrance',
    app_rate_8: '14.54%',
    avg_round_8: 3388.0,
    app_flat_8: 135,
    char_9: 'sparkle',
    app_rate_9: '14.54%',
    avg_round_9: 3256.0,
    app_flat_9: 26,
    char_10: 'sunday',
    app_rate_10: '13.14%',
    avg_round_10: 3368.0,
    app_flat_10: 112,
    char_11: 'ruan-mei',
    app_rate_11: '10.62%',
    avg_round_11: 3350.0,
    app_flat_11: 48,
    char_12: 'feixiao',
    app_rate_12: '9.97%',
    avg_round_12: 3344.0,
    app_flat_12: 101,
    char_13: 'pela',
    app_rate_13: '7.22%',
    avg_round_13: 3317.0,
    app_flat_13: 52,
    char_14: 'castorice',
    app_rate_14: '6.2%',
    avg_round_14: 3517.0,
    app_flat_14: 32,
    char_15: 'march-7th-swordmaster',
    app_rate_15: '6.2%',
    avg_round_15: 3361.0,
    app_flat_15: 63,
    char_16: 'serval',
    app_rate_16: '3.77%',
    avg_round_16: 3349.0,
    app_flat_16: 31,
    char_17: 'topaz',
    app_rate_17: '3.26%',
    avg_round_17: 3298.0,
    app_flat_17: 36,
    char_18: 'silver-wolf',
    app_rate_18: '2.84%',
    avg_round_18: 3156.0,
    app_flat_18: 9,
    char_19: 'yunli',
    app_rate_19: '2.7%',
    avg_round_19: 3179.0,
    app_flat_19: 15,
    char_20: 'bronya',
    app_rate_20: '2.66%',
    avg_round_20: 3150.0,
    app_flat_20: 4,
    char_21: 'argenti',
    app_rate_21: '1.91%',
    avg_round_21: 3429.0,
    app_flat_21: 18,
    char_22: 'anaxa',
    app_rate_22: '1.86%',
    avg_round_22: 3521.0,
    app_flat_22: 13,
    char_23: 'tingyun-fugue',
    app_rate_23: '1.63%',
    avg_round_23: 3190.0,
    app_flat_23: 6,
    char_24: 'seele',
    app_rate_24: '1.58%',
    avg_round_24: 3286.0,
    app_flat_24: 5,
    char_25: 'blade',
    app_rate_25: '1.16%',
    avg_round_25: 3276.0,
    app_flat_25: 6,
    char_26: 'aglaea',
    app_rate_26: '1.16%',
    avg_round_26: 3309.0,
    app_flat_26: 4,
    char_27: 'clara',
    app_rate_27: '0.79%',
    avg_round_27: 0,
    app_flat_27: 0,
    char_28: 'qingque',
    app_rate_28: '0.75%',
    avg_round_28: 3106,
    app_flat_28: 1,
    char_29: 'firefly',
    app_rate_29: '0.7%',
    avg_round_29: 0,
    app_flat_29: 0,
    char_30: 'rappa',
    app_rate_30: '0.7%',
    avg_round_30: 3172.0,
    app_flat_30: 5
  },
  {
    char: 'mydei',
    app: 12.03,
    char_1: 'sunday',
    app_rate_1: '60.69%',
    avg_round_1: 3435.0,
    app_flat_1: 451,
    char_2: 'luocha',
    app_rate_2: '48.63%',
    avg_round_2: 3430.0,
    app_flat_2: 380,
    char_3: 'trailblazer-remembrance',
    app_rate_3: '36.9%',
    avg_round_3: 3458.0,
    app_flat_3: 335,
    char_4: 'tribbie',
    app_rate_4: '35.14%',
    avg_round_4: 3488.0,
    app_flat_4: 295,
    char_5: 'castorice',
    app_rate_5: '28.98%',
    avg_round_5: 3477.0,
    app_flat_5: 268,
    char_6: 'ruan-mei',
    app_rate_6: '18.43%',
    avg_round_6: 3419.0,
    app_flat_6: 105,
    char_7: 'gallagher',
    app_rate_7: '17.46%',
    avg_round_7: 3451.0,
    app_flat_7: 173,
    char_8: 'huohuo',
    app_rate_8: '13.6%',
    avg_round_8: 3398.0,
    app_flat_8: 122,
    char_9: 'sparkle',
    app_rate_9: '9.0%',
    avg_round_9: 3386.0,
    app_flat_9: 83,
    char_10: 'bronya',
    app_rate_10: '8.3%',
    avg_round_10: 3345.0,
    app_flat_10: 69,
    char_11: 'jiaoqiu',
    app_rate_11: '5.52%',
    avg_round_11: 3380.0,
    app_flat_11: 26,
    char_12: 'pela',
    app_rate_12: '3.91%',
    avg_round_12: 3377.0,
    app_flat_12: 27,
    char_13: 'robin',
    app_rate_13: '3.7%',
    avg_round_13: 3381.0,
    app_flat_13: 30,
    char_14: 'lingsha',
    app_rate_14: '2.3%',
    avg_round_14: 3389.0,
    app_flat_14: 24,
    char_15: 'lynx',
    app_rate_15: '1.66%',
    avg_round_15: 3340.0,
    app_flat_15: 17,
    char_16: 'jade',
    app_rate_16: '0.86%',
    avg_round_16: 3352.0,
    app_flat_16: 6,
    char_17: 'the-herta',
    app_rate_17: '0.75%',
    avg_round_17: 3406.0,
    app_flat_17: 8,
    char_18: 'fu-xuan',
    app_rate_18: '0.54%',
    avg_round_18: 3439.0,
    app_flat_18: 3,
    char_19: 'blade',
    app_rate_19: '0.48%',
    avg_round_19: 3454.0,
    app_flat_19: 4,
    char_20: 'tingyun-fugue',
    app_rate_20: '0.37%',
    avg_round_20: 3354,
    app_flat_20: 1,
    char_21: 'bailu',
    app_rate_21: '0.37%',
    avg_round_21: 3331,
    app_flat_21: 4,
    char_22: 'aventurine',
    app_rate_22: '0.27%',
    avg_round_22: 3368,
    app_flat_22: 2,
    char_23: 'silver-wolf',
    app_rate_23: '0.27%',
    avg_round_23: 3300.0,
    app_flat_23: 3,
    char_24: 'herta',
    app_rate_24: '0.21%',
    avg_round_24: 3542,
    app_flat_24: 1,
    char_25: 'jingliu',
    app_rate_25: '0.21%',
    avg_round_25: 3025,
    app_flat_25: 1,
    char_26: 'argenti',
    app_rate_26: '0.16%',
    avg_round_26: 3542,
    app_flat_26: 1,
    char_27: 'tingyun',
    app_rate_27: '0.11%',
    avg_round_27: 0,
    app_flat_27: 0,
    char_28: 'firefly',
    app_rate_28: '0.11%',
    avg_round_28: 0,
    app_flat_28: 0,
    char_29: 'anaxa',
    app_rate_29: '0.11%',
    avg_round_29: 0,
    app_flat_29: 0,
    char_30: 'acheron',
    app_rate_30: '0.11%',
    avg_round_30: 0,
    app_flat_30: 0
  },
  {
    char: 'topaz',
    app: 11.74,
    char_1: 'robin',
    app_rate_1: '93.68%',
    avg_round_1: 3376.0,
    app_flat_1: 760,
    char_2: 'feixiao',
    app_rate_2: '92.09%',
    avg_round_2: 3377.0,
    app_flat_2: 766,
    char_3: 'aventurine',
    app_rate_3: '73.42%',
    avg_round_3: 3379.0,
    app_flat_3: 587,
    char_4: 'lingsha',
    app_rate_4: '8.29%',
    avg_round_4: 3347.0,
    app_flat_4: 80,
    char_5: 'gallagher',
    app_rate_5: '4.17%',
    avg_round_5: 3329.0,
    app_flat_5: 36,
    char_6: 'huohuo',
    app_rate_6: '3.84%',
    avg_round_6: 3296.0,
    app_flat_6: 27,
    char_7: 'fu-xuan',
    app_rate_7: '3.84%',
    avg_round_7: 3298.0,
    app_flat_7: 36,
    char_8: 'yunli',
    app_rate_8: '3.73%',
    avg_round_8: 3252.0,
    app_flat_8: 24,
    char_9: 'ruan-mei',
    app_rate_9: '3.73%',
    avg_round_9: 3382.0,
    app_flat_9: 19,
    char_10: 'sunday',
    app_rate_10: '2.47%',
    avg_round_10: 3291.0,
    app_flat_10: 13,
    char_11: 'march-7th-swordmaster',
    app_rate_11: '2.42%',
    avg_round_11: 3298.0,
    app_flat_11: 24,
    char_12: 'tribbie',
    app_rate_12: '1.43%',
    avg_round_12: 3370.0,
    app_flat_12: 6,
    char_13: 'luocha',
    app_rate_13: '1.21%',
    avg_round_13: 3295.0,
    app_flat_13: 9,
    char_14: 'trailblazer-remembrance',
    app_rate_14: '0.93%',
    avg_round_14: 3376.0,
    app_flat_14: 5,
    char_15: 'clara',
    app_rate_15: '0.88%',
    avg_round_15: 3120.0,
    app_flat_15: 4,
    char_16: 'jade',
    app_rate_16: '0.82%',
    avg_round_16: 0,
    app_flat_16: 0,
    char_17: 'bronya',
    app_rate_17: '0.77%',
    avg_round_17: 3320.0,
    app_flat_17: 7,
    char_18: 'dr-ratio',
    app_rate_18: '0.66%',
    avg_round_18: 3149.0,
    app_flat_18: 3,
    char_19: 'sparkle',
    app_rate_19: '0.6%',
    avg_round_19: 3323,
    app_flat_19: 2,
    char_20: 'jiaoqiu',
    app_rate_20: '0.16%',
    avg_round_20: 0,
    app_flat_20: 0,
    char_21: 'bailu',
    app_rate_21: '0.16%',
    avg_round_21: 0,
    app_flat_21: 0,
    char_22: 'tingyun',
    app_rate_22: '0.11%',
    avg_round_22: 0,
    app_flat_22: 0,
    char_23: 'tingyun-fugue',
    app_rate_23: '0.11%',
    avg_round_23: 0,
    app_flat_23: 0,
    char_24: 'acheron',
    app_rate_24: '0.05%',
    avg_round_24: 0,
    app_flat_24: 0,
    char_25: 'asta',
    app_rate_25: '0.05%',
    avg_round_25: 0,
    app_flat_25: 0,
    char_26: 'castorice',
    app_rate_26: '0.05%',
    avg_round_26: 3082,
    app_flat_26: 1,
    char_27: 'dan-heng',
    app_rate_27: '0.05%',
    avg_round_27: 0,
    app_flat_27: 0,
    char_28: 'natasha',
    app_rate_28: '0.05%',
    avg_round_28: 0,
    app_flat_28: 0,
    char_29: 'march-7th',
    app_rate_29: '0.05%',
    avg_round_29: 0,
    app_flat_29: 0,
    char_30: 'blade',
    app_rate_30: '0.05%',
    avg_round_30: 0,
    app_flat_30: 0
  },
  {
    char: 'march-7th-swordmaster',
    app: 11.7,
    char_1: 'feixiao',
    app_rate_1: '95.76%',
    avg_round_1: 3416.0,
    app_flat_1: 1068,
    char_2: 'robin',
    app_rate_2: '91.18%',
    avg_round_2: 3424.0,
    app_flat_2: 1001,
    char_3: 'aventurine',
    app_rate_3: '48.82%',
    avg_round_3: 3408.0,
    app_flat_3: 570,
    char_4: 'lingsha',
    app_rate_4: '10.41%',
    avg_round_4: 3394.0,
    app_flat_4: 130,
    char_5: 'gallagher',
    app_rate_5: '9.59%',
    avg_round_5: 3385.0,
    app_flat_5: 125,
    char_6: 'fu-xuan',
    app_rate_6: '7.33%',
    avg_round_6: 3361.0,
    app_flat_6: 63,
    char_7: 'ruan-mei',
    app_rate_7: '6.67%',
    avg_round_7: 3485.0,
    app_flat_7: 42,
    char_8: 'bronya',
    app_rate_8: '6.45%',
    avg_round_8: 3498,
    app_flat_8: 42,
    char_9: 'huohuo',
    app_rate_9: '5.07%',
    avg_round_9: 3377.0,
    app_flat_9: 60,
    char_10: 'sunday',
    app_rate_10: '2.87%',
    avg_round_10: 3415.0,
    app_flat_10: 37,
    char_11: 'topaz',
    app_rate_11: '2.42%',
    avg_round_11: 3298.0,
    app_flat_11: 24,
    char_12: 'trailblazer-remembrance',
    app_rate_12: '2.09%',
    avg_round_12: 3474.0,
    app_flat_12: 18,
    char_13: 'tribbie',
    app_rate_13: '1.98%',
    avg_round_13: 3407.0,
    app_flat_13: 19,
    char_14: 'luocha',
    app_rate_14: '1.76%',
    avg_round_14: 3346.0,
    app_flat_14: 20,
    char_15: 'yunli',
    app_rate_15: '1.49%',
    avg_round_15: 3233.0,
    app_flat_15: 14,
    char_16: 'sparkle',
    app_rate_16: '1.21%',
    avg_round_16: 3356.0,
    app_flat_16: 10,
    char_17: 'clara',
    app_rate_17: '0.77%',
    avg_round_17: 3200.0,
    app_flat_17: 2,
    char_18: 'bailu',
    app_rate_18: '0.77%',
    avg_round_18: 3352.0,
    app_flat_18: 10,
    char_19: 'tingyun-fugue',
    app_rate_19: '0.61%',
    avg_round_19: 3339,
    app_flat_19: 2,
    char_20: 'jiaoqiu',
    app_rate_20: '0.33%',
    avg_round_20: 3290.0,
    app_flat_20: 2,
    char_21: 'trailblazer-harmony',
    app_rate_21: '0.28%',
    avg_round_21: 3242.0,
    app_flat_21: 2,
    char_22: 'firefly',
    app_rate_22: '0.28%',
    avg_round_22: 0,
    app_flat_22: 0,
    char_23: 'gepard',
    app_rate_23: '0.17%',
    avg_round_23: 3289,
    app_flat_23: 2,
    char_24: 'anaxa',
    app_rate_24: '0.17%',
    avg_round_24: 0,
    app_flat_24: 0,
    char_25: 'moze',
    app_rate_25: '0.17%',
    avg_round_25: 3086,
    app_flat_25: 1,
    char_26: 'jade',
    app_rate_26: '0.17%',
    avg_round_26: 3330.0,
    app_flat_26: 2,
    char_27: 'seele',
    app_rate_27: '0.11%',
    avg_round_27: 0,
    app_flat_27: 0,
    char_28: 'tingyun',
    app_rate_28: '0.11%',
    avg_round_28: 3238,
    app_flat_28: 1,
    char_29: 'herta',
    app_rate_29: '0.11%',
    avg_round_29: 3620,
    app_flat_29: 1,
    char_30: 'the-herta',
    app_rate_30: '0.11%',
    avg_round_30: 3209,
    app_flat_30: 1
  },
  {
    char: 'acheron',
    app: 10.65,
    char_1: 'jiaoqiu',
    app_rate_1: '80.7%',
    avg_round_1: 3325.0,
    app_flat_1: 248,
    char_2: 'aventurine',
    app_rate_2: '40.59%',
    avg_round_2: 3304.0,
    app_flat_2: 152,
    char_3: 'pela',
    app_rate_3: '32.12%',
    avg_round_3: 3330.0,
    app_flat_3: 212,
    char_4: 'sparkle',
    app_rate_4: '31.64%',
    avg_round_4: 3381.0,
    app_flat_4: 10,
    char_5: 'fu-xuan',
    app_rate_5: '25.17%',
    avg_round_5: 3305.0,
    app_flat_5: 54,
    char_6: 'tribbie',
    app_rate_6: '15.91%',
    avg_round_6: 3404.0,
    app_flat_6: 27,
    char_7: 'sunday',
    app_rate_7: '13.79%',
    avg_round_7: 3190.0,
    app_flat_7: 9,
    char_8: 'robin',
    app_rate_8: '9.56%',
    avg_round_8: 3463.0,
    app_flat_8: 4,
    char_9: 'silver-wolf',
    app_rate_9: '6.96%',
    avg_round_9: 3219.0,
    app_flat_9: 29,
    char_10: 'trailblazer-remembrance',
    app_rate_10: '6.9%',
    avg_round_10: 3565.0,
    app_flat_10: 10,
    char_11: 'bronya',
    app_rate_11: '6.35%',
    avg_round_11: 0,
    app_flat_11: 0,
    char_12: 'ruan-mei',
    app_rate_12: '6.11%',
    avg_round_12: 3339,
    app_flat_12: 4,
    char_13: 'gallagher',
    app_rate_13: '5.69%',
    avg_round_13: 3275.0,
    app_flat_13: 20,
    char_14: 'lingsha',
    app_rate_14: '3.21%',
    avg_round_14: 3255.0,
    app_flat_14: 8,
    char_15: 'tingyun-fugue',
    app_rate_15: '3.02%',
    avg_round_15: 3331.0,
    app_flat_15: 9,
    char_16: 'huohuo',
    app_rate_16: '2.84%',
    avg_round_16: 3174.0,
    app_flat_16: 6,
    char_17: 'black-swan',
    app_rate_17: '1.88%',
    avg_round_17: 3050.0,
    app_flat_17: 2,
    char_18: 'luocha',
    app_rate_18: '1.81%',
    avg_round_18: 3356.0,
    app_flat_18: 6,
    char_19: 'gepard',
    app_rate_19: '1.39%',
    avg_round_19: 3288,
    app_flat_19: 3,
    char_20: 'kafka',
    app_rate_20: '1.15%',
    avg_round_20: 0,
    app_flat_20: 0,
    char_21: 'welt',
    app_rate_21: '0.3%',
    avg_round_21: 3412,
    app_flat_21: 2,
    char_22: 'yunli',
    app_rate_22: '0.3%',
    avg_round_22: 0,
    app_flat_22: 0,
    char_23: 'march-7th',
    app_rate_23: '0.3%',
    avg_round_23: 0,
    app_flat_23: 0,
    char_24: 'castorice',
    app_rate_24: '0.3%',
    avg_round_24: 0,
    app_flat_24: 0,
    char_25: 'anaxa',
    app_rate_25: '0.24%',
    avg_round_25: 3107,
    app_flat_25: 2,
    char_26: 'firefly',
    app_rate_26: '0.24%',
    avg_round_26: 0,
    app_flat_26: 0,
    char_27: 'feixiao',
    app_rate_27: '0.18%',
    avg_round_27: 0,
    app_flat_27: 0,
    char_28: 'tingyun',
    app_rate_28: '0.18%',
    avg_round_28: 0,
    app_flat_28: 0,
    char_29: 'bailu',
    app_rate_29: '0.18%',
    avg_round_29: 0,
    app_flat_29: 0,
    char_30: 'boothill',
    app_rate_30: '0.12%',
    avg_round_30: 0,
    app_flat_30: 0
  },
  {
    char: 'jiaoqiu',
    app: 10.22,
    char_1: 'acheron',
    app_rate_1: '84.11%',
    avg_round_1: 3325.0,
    app_flat_1: 248,
    char_2: 'aventurine',
    app_rate_2: '37.07%',
    avg_round_2: 3309.0,
    app_flat_2: 137,
    char_3: 'sparkle',
    app_rate_3: '26.67%',
    avg_round_3: 3359,
    app_flat_3: 14,
    char_4: 'pela',
    app_rate_4: '21.25%',
    avg_round_4: 3339.0,
    app_flat_4: 189,
    char_5: 'fu-xuan',
    app_rate_5: '19.99%',
    avg_round_5: 3311.0,
    app_flat_5: 51,
    char_6: 'sunday',
    app_rate_6: '18.79%',
    avg_round_6: 3399.0,
    app_flat_6: 31,
    char_7: 'tribbie',
    app_rate_7: '13.24%',
    avg_round_7: 3452,
    app_flat_7: 22,
    char_8: 'robin',
    app_rate_8: '10.21%',
    avg_round_8: 3478.0,
    app_flat_8: 12,
    char_9: 'trailblazer-remembrance',
    app_rate_9: '10.09%',
    avg_round_9: 3466.0,
    app_flat_9: 34,
    char_10: 'gallagher',
    app_rate_10: '8.39%',
    avg_round_10: 3341.0,
    app_flat_10: 38,
    char_11: 'ruan-mei',
    app_rate_11: '6.81%',
    avg_round_11: 3503.0,
    app_flat_11: 7,
    char_12: 'mydei',
    app_rate_12: '6.49%',
    avg_round_12: 3380.0,
    app_flat_12: 26,
    char_13: 'luocha',
    app_rate_13: '5.99%',
    avg_round_13: 3409.0,
    app_flat_13: 25,
    char_14: 'bronya',
    app_rate_14: '5.61%',
    avg_round_14: 3341.0,
    app_flat_14: 3,
    char_15: 'castorice',
    app_rate_15: '4.29%',
    avg_round_15: 3447.0,
    app_flat_15: 29,
    char_16: 'lingsha',
    app_rate_16: '3.4%',
    avg_round_16: 3283.0,
    app_flat_16: 13,
    char_17: 'huohuo',
    app_rate_17: '3.22%',
    avg_round_17: 3296.0,
    app_flat_17: 10,
    char_18: 'silver-wolf',
    app_rate_18: '2.4%',
    avg_round_18: 3256.0,
    app_flat_18: 18,
    char_19: 'feixiao',
    app_rate_19: '1.7%',
    avg_round_19: 3332,
    app_flat_19: 6,
    char_20: 'anaxa',
    app_rate_20: '1.7%',
    avg_round_20: 3519.0,
    app_flat_20: 6,
    char_21: 'tingyun-fugue',
    app_rate_21: '1.64%',
    avg_round_21: 3370.0,
    app_flat_21: 9,
    char_22: 'gepard',
    app_rate_22: '0.82%',
    avg_round_22: 3288,
    app_flat_22: 3,
    char_23: 'the-herta',
    app_rate_23: '0.57%',
    avg_round_23: 3362,
    app_flat_23: 1,
    char_24: 'blade',
    app_rate_24: '0.5%',
    avg_round_24: 3483,
    app_flat_24: 1,
    char_25: 'kafka',
    app_rate_25: '0.44%',
    avg_round_25: 0,
    app_flat_25: 0,
    char_26: 'black-swan',
    app_rate_26: '0.44%',
    avg_round_26: 2962,
    app_flat_26: 1,
    char_27: 'yunli',
    app_rate_27: '0.44%',
    avg_round_27: 3214,
    app_flat_27: 1,
    char_28: 'march-7th-swordmaster',
    app_rate_28: '0.38%',
    avg_round_28: 3290.0,
    app_flat_28: 2,
    char_29: 'jade',
    app_rate_29: '0.38%',
    avg_round_29: 3362,
    app_flat_29: 1,
    char_30: 'herta',
    app_rate_30: '0.32%',
    avg_round_30: 0,
    app_flat_30: 0
  },
  {
    char: 'sparkle',
    app: 8.95,
    char_1: 'acheron',
    app_rate_1: '37.65%',
    avg_round_1: 3381.0,
    app_flat_1: 10,
    char_2: 'jiaoqiu',
    app_rate_2: '30.45%',
    avg_round_2: 3359,
    app_flat_2: 14,
    char_3: 'fu-xuan',
    app_rate_3: '22.46%',
    avg_round_3: 3256.0,
    app_flat_3: 26,
    char_4: 'aventurine',
    app_rate_4: '20.09%',
    avg_round_4: 3288.0,
    app_flat_4: 30,
    char_5: 'robin',
    app_rate_5: '12.89%',
    avg_round_5: 3375.0,
    app_flat_5: 41,
    char_6: 'sunday',
    app_rate_6: '12.6%',
    avg_round_6: 3389.0,
    app_flat_6: 56,
    char_7: 'castorice',
    app_rate_7: '12.53%',
    avg_round_7: 3415.0,
    app_flat_7: 61,
    char_8: 'trailblazer-remembrance',
    app_rate_8: '12.1%',
    avg_round_8: 3422.0,
    app_flat_8: 73,
    char_9: 'mydei',
    app_rate_9: '12.1%',
    avg_round_9: 3386.0,
    app_flat_9: 83,
    char_10: 'the-herta',
    app_rate_10: '11.81%',
    avg_round_10: 3324.0,
    app_flat_10: 49,
    char_11: 'huohuo',
    app_rate_11: '11.3%',
    avg_round_11: 3316.0,
    app_flat_11: 47,
    char_12: 'tribbie',
    app_rate_12: '11.09%',
    avg_round_12: 3425.0,
    app_flat_12: 31,
    char_13: 'ruan-mei',
    app_rate_13: '10.44%',
    avg_round_13: 3427.0,
    app_flat_13: 27,
    char_14: 'luocha',
    app_rate_14: '9.0%',
    avg_round_14: 3388.0,
    app_flat_14: 40,
    char_15: 'gallagher',
    app_rate_15: '7.85%',
    avg_round_15: 3361.0,
    app_flat_15: 44,
    char_16: 'yunli',
    app_rate_16: '7.7%',
    avg_round_16: 3222.0,
    app_flat_16: 23,
    char_17: 'herta',
    app_rate_17: '6.84%',
    avg_round_17: 3292.0,
    app_flat_17: 25,
    char_18: 'lingsha',
    app_rate_18: '6.05%',
    avg_round_18: 3328.0,
    app_flat_18: 16,
    char_19: 'pela',
    app_rate_19: '5.9%',
    avg_round_19: 3580.0,
    app_flat_19: 5,
    char_20: 'jade',
    app_rate_20: '5.18%',
    avg_round_20: 3345.0,
    app_flat_20: 24,
    char_21: 'seele',
    app_rate_21: '4.1%',
    avg_round_21: 3358.0,
    app_flat_21: 13,
    char_22: 'imbibitor-lunae',
    app_rate_22: '4.03%',
    avg_round_22: 3106,
    app_flat_22: 1,
    char_23: 'silver-wolf',
    app_rate_23: '3.89%',
    avg_round_23: 0,
    app_flat_23: 0,
    char_24: 'feixiao',
    app_rate_24: '3.17%',
    avg_round_24: 3334.0,
    app_flat_24: 16,
    char_25: 'tingyun',
    app_rate_25: '2.45%',
    avg_round_25: 3377,
    app_flat_25: 8,
    char_26: 'anaxa',
    app_rate_26: '2.16%',
    avg_round_26: 3595.0,
    app_flat_26: 11,
    char_27: 'bronya',
    app_rate_27: '1.73%',
    avg_round_27: 3271,
    app_flat_27: 7,
    char_28: 'march-7th-swordmaster',
    app_rate_28: '1.58%',
    avg_round_28: 3356.0,
    app_flat_28: 10,
    char_29: 'blade',
    app_rate_29: '1.44%',
    avg_round_29: 3126,
    app_flat_29: 4,
    char_30: 'qingque',
    app_rate_30: '1.37%',
    avg_round_30: 3106,
    app_flat_30: 1
  },
  {
    char: 'trailblazer-harmony',
    app: 6.48,
    char_1: 'ruan-mei',
    app_rate_1: '92.44%',
    avg_round_1: 3264.0,
    app_flat_1: 166,
    char_2: 'firefly',
    app_rate_2: '71.84%',
    avg_round_2: 3214.0,
    app_flat_2: 100,
    char_3: 'tingyun-fugue',
    app_rate_3: '40.7%',
    avg_round_3: 3422.0,
    app_flat_3: 43,
    char_4: 'gallagher',
    app_rate_4: '33.83%',
    avg_round_4: 3226.0,
    app_flat_4: 102,
    char_5: 'lingsha',
    app_rate_5: '32.44%',
    avg_round_5: 3260.0,
    app_flat_5: 40,
    char_6: 'boothill',
    app_rate_6: '12.74%',
    avg_round_6: 3456.0,
    app_flat_6: 51,
    char_7: 'rappa',
    app_rate_7: '8.36%',
    avg_round_7: 3279.0,
    app_flat_7: 22,
    char_8: 'aventurine',
    app_rate_8: '2.09%',
    avg_round_8: 3087,
    app_flat_8: 3,
    char_9: 'huohuo',
    app_rate_9: '1.19%',
    avg_round_9: 0,
    app_flat_9: 0,
    char_10: 'bronya',
    app_rate_10: '1.0%',
    avg_round_10: 3461,
    app_flat_10: 5,
    char_11: 'luocha',
    app_rate_11: '0.8%',
    avg_round_11: 3262.0,
    app_flat_11: 2,
    char_12: 'xueyi',
    app_rate_12: '0.8%',
    avg_round_12: 3250,
    app_flat_12: 1,
    char_13: 'castorice',
    app_rate_13: '0.6%',
    avg_round_13: 3409.0,
    app_flat_13: 3,
    char_14: 'sunday',
    app_rate_14: '0.5%',
    avg_round_14: 2908,
    app_flat_14: 1,
    char_15: 'march-7th-swordmaster',
    app_rate_15: '0.5%',
    avg_round_15: 3242.0,
    app_flat_15: 2,
    char_16: 'fu-xuan',
    app_rate_16: '0.5%',
    avg_round_16: 0,
    app_flat_16: 0,
    char_17: 'anaxa',
    app_rate_17: '0.4%',
    avg_round_17: 0,
    app_flat_17: 0,
    char_18: 'tribbie',
    app_rate_18: '0.4%',
    avg_round_18: 3488.0,
    app_flat_18: 2,
    char_19: 'silver-wolf',
    app_rate_19: '0.3%',
    avg_round_19: 0,
    app_flat_19: 0,
    char_20: 'sampo',
    app_rate_20: '0.3%',
    avg_round_20: 0,
    app_flat_20: 0,
    char_21: 'bailu',
    app_rate_21: '0.3%',
    avg_round_21: 0,
    app_flat_21: 0,
    char_22: 'asta',
    app_rate_22: '0.3%',
    avg_round_22: 3280,
    app_flat_22: 1,
    char_23: 'luka',
    app_rate_23: '0.2%',
    avg_round_23: 3126,
    app_flat_23: 1,
    char_24: 'sushang',
    app_rate_24: '0.2%',
    avg_round_24: 0,
    app_flat_24: 0,
    char_25: 'blade',
    app_rate_25: '0.2%',
    avg_round_25: 0,
    app_flat_25: 0,
    char_26: 'robin',
    app_rate_26: '0.2%',
    avg_round_26: 0,
    app_flat_26: 0,
    char_27: 'march-7th',
    app_rate_27: '0.1%',
    avg_round_27: 0,
    app_flat_27: 0,
    char_28: 'hook',
    app_rate_28: '0.1%',
    avg_round_28: 3322,
    app_flat_28: 1,
    char_29: 'himeko',
    app_rate_29: '0.1%',
    avg_round_29: 0,
    app_flat_29: 0,
    char_30: 'mydei',
    app_rate_30: '0.1%',
    avg_round_30: 0,
    app_flat_30: 0
  },
  {
    char: 'pela',
    app: 6.06,
    char_1: 'acheron',
    app_rate_1: '56.43%',
    avg_round_1: 3330.0,
    app_flat_1: 212,
    char_2: 'jiaoqiu',
    app_rate_2: '35.81%',
    avg_round_2: 3339.0,
    app_flat_2: 189,
    char_3: 'castorice',
    app_rate_3: '29.76%',
    avg_round_3: 3384.0,
    app_flat_3: 147,
    char_4: 'trailblazer-remembrance',
    app_rate_4: '26.25%',
    avg_round_4: 3398.0,
    app_flat_4: 127,
    char_5: 'aventurine',
    app_rate_5: '24.97%',
    avg_round_5: 3314.0,
    app_flat_5: 127,
    char_6: 'gallagher',
    app_rate_6: '20.3%',
    avg_round_6: 3369.0,
    app_flat_6: 110,
    char_7: 'fu-xuan',
    app_rate_7: '16.47%',
    avg_round_7: 3317.0,
    app_flat_7: 52,
    char_8: 'luocha',
    app_rate_8: '12.86%',
    avg_round_8: 3347.0,
    app_flat_8: 58,
    char_9: 'tribbie',
    app_rate_9: '11.8%',
    avg_round_9: 3408.0,
    app_flat_9: 29,
    char_10: 'sunday',
    app_rate_10: '11.37%',
    avg_round_10: 3419.0,
    app_flat_10: 31,
    char_11: 'sparkle',
    app_rate_11: '8.71%',
    avg_round_11: 3580.0,
    app_flat_11: 5,
    char_12: 'mydei',
    app_rate_12: '7.76%',
    avg_round_12: 3377.0,
    app_flat_12: 27,
    char_13: 'ruan-mei',
    app_rate_13: '6.48%',
    avg_round_13: 3450.0,
    app_flat_13: 16,
    char_14: 'the-herta',
    app_rate_14: '4.46%',
    avg_round_14: 3331.0,
    app_flat_14: 24,
    char_15: 'huohuo',
    app_rate_15: '4.36%',
    avg_round_15: 3316.0,
    app_flat_15: 16,
    char_16: 'robin',
    app_rate_16: '3.4%',
    avg_round_16: 3550.0,
    app_flat_16: 6,
    char_17: 'lingsha',
    app_rate_17: '3.08%',
    avg_round_17: 3343,
    app_flat_17: 15,
    char_18: 'herta',
    app_rate_18: '2.98%',
    avg_round_18: 3259.0,
    app_flat_18: 13,
    char_19: 'bronya',
    app_rate_19: '2.66%',
    avg_round_19: 3286,
    app_flat_19: 1,
    char_20: 'silver-wolf',
    app_rate_20: '2.34%',
    avg_round_20: 3144.0,
    app_flat_20: 10,
    char_21: 'jade',
    app_rate_21: '1.7%',
    avg_round_21: 3402.0,
    app_flat_21: 10,
    char_22: 'gepard',
    app_rate_22: '1.06%',
    avg_round_22: 3288,
    app_flat_22: 3,
    char_23: 'anaxa',
    app_rate_23: '0.74%',
    avg_round_23: 3551,
    app_flat_23: 4,
    char_24: 'tingyun-fugue',
    app_rate_24: '0.53%',
    avg_round_24: 3250,
    app_flat_24: 1,
    char_25: 'welt',
    app_rate_25: '0.43%',
    avg_round_25: 3412,
    app_flat_25: 2,
    char_26: 'rappa',
    app_rate_26: '0.43%',
    avg_round_26: 3250,
    app_flat_26: 1,
    char_27: 'black-swan',
    app_rate_27: '0.43%',
    avg_round_27: 3137,
    app_flat_27: 1,
    char_28: 'jingliu',
    app_rate_28: '0.43%',
    avg_round_28: 0,
    app_flat_28: 0,
    char_29: 'lynx',
    app_rate_29: '0.43%',
    avg_round_29: 3341,
    app_flat_29: 3,
    char_30: 'bailu',
    app_rate_30: '0.32%',
    avg_round_30: 0,
    app_flat_30: 0
  },
  {
    char: 'bronya',
    app: 5.19,
    char_1: 'robin',
    app_rate_1: '27.45%',
    avg_round_1: 3562.0,
    app_flat_1: 58,
    char_2: 'ruan-mei',
    app_rate_2: '25.59%',
    avg_round_2: 3444.0,
    app_flat_2: 51,
    char_3: 'mydei',
    app_rate_3: '19.25%',
    avg_round_3: 3345.0,
    app_flat_3: 69,
    char_4: 'feixiao',
    app_rate_4: '18.88%',
    avg_round_4: 3467.0,
    app_flat_4: 61,
    char_5: 'sunday',
    app_rate_5: '18.76%',
    avg_round_5: 3420.0,
    app_flat_5: 47,
    char_6: 'march-7th-swordmaster',
    app_rate_6: '14.53%',
    avg_round_6: 3498,
    app_flat_6: 42,
    char_7: 'luocha',
    app_rate_7: '14.29%',
    avg_round_7: 3358.0,
    app_flat_7: 45,
    char_8: 'gallagher',
    app_rate_8: '13.66%',
    avg_round_8: 3369.0,
    app_flat_8: 51,
    char_9: 'acheron',
    app_rate_9: '13.04%',
    avg_round_9: 0,
    app_flat_9: 0,
    char_10: 'trailblazer-remembrance',
    app_rate_10: '12.67%',
    avg_round_10: 3430.0,
    app_flat_10: 45,
    char_11: 'tingyun-fugue',
    app_rate_11: '11.55%',
    avg_round_11: 3435.0,
    app_flat_11: 4,
    char_12: 'jiaoqiu',
    app_rate_12: '11.06%',
    avg_round_12: 3341.0,
    app_flat_12: 3,
    char_13: 'boothill',
    app_rate_13: '10.31%',
    avg_round_13: 3309.0,
    app_flat_13: 23,
    char_14: 'castorice',
    app_rate_14: '9.57%',
    avg_round_14: 3454.0,
    app_flat_14: 35,
    char_15: 'aventurine',
    app_rate_15: '8.2%',
    avg_round_15: 3336.0,
    app_flat_15: 22,
    char_16: 'anaxa',
    app_rate_16: '7.58%',
    avg_round_16: 3611.0,
    app_flat_16: 27,
    char_17: 'fu-xuan',
    app_rate_17: '7.08%',
    avg_round_17: 3150.0,
    app_flat_17: 4,
    char_18: 'blade',
    app_rate_18: '6.71%',
    avg_round_18: 3269,
    app_flat_18: 10,
    char_19: 'firefly',
    app_rate_19: '5.84%',
    avg_round_19: 0,
    app_flat_19: 0,
    char_20: 'huohuo',
    app_rate_20: '5.59%',
    avg_round_20: 3362.0,
    app_flat_20: 24,
    char_21: 'tribbie',
    app_rate_21: '5.34%',
    avg_round_21: 3481.0,
    app_flat_21: 15,
    char_22: 'aglaea',
    app_rate_22: '4.84%',
    avg_round_22: 3486.0,
    app_flat_22: 4,
    char_23: 'lingsha',
    app_rate_23: '4.6%',
    avg_round_23: 3352.0,
    app_flat_23: 12,
    char_24: 'pela',
    app_rate_24: '3.11%',
    avg_round_24: 3286,
    app_flat_24: 1,
    char_25: 'sparkle',
    app_rate_25: '2.98%',
    avg_round_25: 3271,
    app_flat_25: 7,
    char_26: 'jade',
    app_rate_26: '2.48%',
    avg_round_26: 3304.0,
    app_flat_26: 7,
    char_27: 'the-herta',
    app_rate_27: '2.36%',
    avg_round_27: 3296.0,
    app_flat_27: 8,
    char_28: 'topaz',
    app_rate_28: '1.74%',
    avg_round_28: 3320.0,
    app_flat_28: 7,
    char_29: 'herta',
    app_rate_29: '1.37%',
    avg_round_29: 3184,
    app_flat_29: 4,
    char_30: 'lynx',
    app_rate_30: '1.24%',
    avg_round_30: 3252.0,
    app_flat_30: 3
  },
  {
    char: 'boothill',
    app: 5.12,
    char_1: 'ruan-mei',
    app_rate_1: '94.47%',
    avg_round_1: 3447.0,
    app_flat_1: 248,
    char_2: 'tingyun-fugue',
    app_rate_2: '77.74%',
    avg_round_2: 3474.0,
    app_flat_2: 182,
    char_3: 'gallagher',
    app_rate_3: '48.93%',
    avg_round_3: 3424.0,
    app_flat_3: 146,
    char_4: 'lingsha',
    app_rate_4: '21.38%',
    avg_round_4: 3448.0,
    app_flat_4: 60,
    char_5: 'trailblazer-harmony',
    app_rate_5: '16.1%',
    avg_round_5: 3456.0,
    app_flat_5: 51,
    char_6: 'sunday',
    app_rate_6: '12.33%',
    avg_round_6: 3438.0,
    app_flat_6: 27,
    char_7: 'bronya',
    app_rate_7: '10.44%',
    avg_round_7: 3309.0,
    app_flat_7: 23,
    char_8: 'aventurine',
    app_rate_8: '5.91%',
    avg_round_8: 3378.0,
    app_flat_8: 9,
    char_9: 'huohuo',
    app_rate_9: '2.39%',
    avg_round_9: 3263.0,
    app_flat_9: 7,
    char_10: 'luocha',
    app_rate_10: '1.89%',
    avg_round_10: 3285.0,
    app_flat_10: 5,
    char_11: 'fu-xuan',
    app_rate_11: '1.64%',
    avg_round_11: 3317,
    app_flat_11: 2,
    char_12: 'trailblazer-remembrance',
    app_rate_12: '0.88%',
    avg_round_12: 3201,
    app_flat_12: 1,
    char_13: 'rappa',
    app_rate_13: '0.63%',
    avg_round_13: 3820,
    app_flat_13: 1,
    char_14: 'tribbie',
    app_rate_14: '0.63%',
    avg_round_14: 3807,
    app_flat_14: 1,
    char_15: 'anaxa',
    app_rate_15: '0.63%',
    avg_round_15: 0,
    app_flat_15: 0,
    char_16: 'robin',
    app_rate_16: '0.63%',
    avg_round_16: 0,
    app_flat_16: 0,
    char_17: 'feixiao',
    app_rate_17: '0.5%',
    avg_round_17: 0,
    app_flat_17: 0,
    char_18: 'jiaoqiu',
    app_rate_18: '0.5%',
    avg_round_18: 3655,
    app_flat_18: 1,
    char_19: 'bailu',
    app_rate_19: '0.38%',
    avg_round_19: 0,
    app_flat_19: 0,
    char_20: 'castorice',
    app_rate_20: '0.38%',
    avg_round_20: 0,
    app_flat_20: 0,
    char_21: 'acheron',
    app_rate_21: '0.25%',
    avg_round_21: 0,
    app_flat_21: 0,
    char_22: 'luka',
    app_rate_22: '0.25%',
    avg_round_22: 3320,
    app_flat_22: 1,
    char_23: 'clara',
    app_rate_23: '0.25%',
    avg_round_23: 0,
    app_flat_23: 0,
    char_24: 'sparkle',
    app_rate_24: '0.25%',
    avg_round_24: 3084,
    app_flat_24: 1,
    char_25: 'mydei',
    app_rate_25: '0.25%',
    avg_round_25: 3180,
    app_flat_25: 1,
    char_26: 'firefly',
    app_rate_26: '0.13%',
    avg_round_26: 0,
    app_flat_26: 0,
    char_27: 'silver-wolf',
    app_rate_27: '0.13%',
    avg_round_27: 0,
    app_flat_27: 0,
    char_28: 'blade',
    app_rate_28: '0.13%',
    avg_round_28: 3153,
    app_flat_28: 1,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'yunli',
    app: 4.83,
    char_1: 'robin',
    app_rate_1: '80.64%',
    avg_round_1: 3267.0,
    app_flat_1: 222,
    char_2: 'huohuo',
    app_rate_2: '41.79%',
    avg_round_2: 3242.0,
    app_flat_2: 111,
    char_3: 'sunday',
    app_rate_3: '23.5%',
    avg_round_3: 3212.0,
    app_flat_3: 66,
    char_4: 'trailblazer-remembrance',
    app_rate_4: '19.09%',
    avg_round_4: 3314.0,
    app_flat_4: 62,
    char_5: 'tribbie',
    app_rate_5: '17.76%',
    avg_round_5: 3403.0,
    app_flat_5: 46,
    char_6: 'sparkle',
    app_rate_6: '14.29%',
    avg_round_6: 3222.0,
    app_flat_6: 23,
    char_7: 'aventurine',
    app_rate_7: '14.15%',
    avg_round_7: 3246.0,
    app_flat_7: 41,
    char_8: 'feixiao',
    app_rate_8: '13.75%',
    avg_round_8: 3333.0,
    app_flat_8: 45,
    char_9: 'ruan-mei',
    app_rate_9: '12.28%',
    avg_round_9: 3412.0,
    app_flat_9: 19,
    char_10: 'tingyun',
    app_rate_10: '12.02%',
    avg_round_10: 3222.0,
    app_flat_10: 29,
    char_11: 'topaz',
    app_rate_11: '9.08%',
    avg_round_11: 3252.0,
    app_flat_11: 24,
    char_12: 'fu-xuan',
    app_rate_12: '7.74%',
    avg_round_12: 3179.0,
    app_flat_12: 15,
    char_13: 'lingsha',
    app_rate_13: '6.68%',
    avg_round_13: 3205.0,
    app_flat_13: 17,
    char_14: 'gallagher',
    app_rate_14: '4.14%',
    avg_round_14: 3193.0,
    app_flat_14: 13,
    char_15: 'luocha',
    app_rate_15: '4.14%',
    avg_round_15: 3244.0,
    app_flat_15: 9,
    char_16: 'march-7th-swordmaster',
    app_rate_16: '3.6%',
    avg_round_16: 3233.0,
    app_flat_16: 14,
    char_17: 'castorice',
    app_rate_17: '3.2%',
    avg_round_17: 3398.0,
    app_flat_17: 10,
    char_18: 'jade',
    app_rate_18: '2.14%',
    avg_round_18: 3178.0,
    app_flat_18: 3,
    char_19: 'the-herta',
    app_rate_19: '1.07%',
    avg_round_19: 3747,
    app_flat_19: 2,
    char_20: 'tingyun-fugue',
    app_rate_20: '1.07%',
    avg_round_20: 0,
    app_flat_20: 0,
    char_21: 'clara',
    app_rate_21: '1.07%',
    avg_round_21: 2890,
    app_flat_21: 1,
    char_22: 'herta',
    app_rate_22: '0.93%',
    avg_round_22: 3747,
    app_flat_22: 2,
    char_23: 'jiaoqiu',
    app_rate_23: '0.93%',
    avg_round_23: 3214,
    app_flat_23: 1,
    char_24: 'blade',
    app_rate_24: '0.8%',
    avg_round_24: 2846,
    app_flat_24: 1,
    char_25: 'lynx',
    app_rate_25: '0.67%',
    avg_round_25: 3062,
    app_flat_25: 1,
    char_26: 'acheron',
    app_rate_26: '0.67%',
    avg_round_26: 0,
    app_flat_26: 0,
    char_27: 'bronya',
    app_rate_27: '0.53%',
    avg_round_27: 3342,
    app_flat_27: 1,
    char_28: 'bailu',
    app_rate_28: '0.4%',
    avg_round_28: 0,
    app_flat_28: 0,
    char_29: 'firefly',
    app_rate_29: '0.27%',
    avg_round_29: 0,
    app_flat_29: 0,
    char_30: 'moze',
    app_rate_30: '0.27%',
    avg_round_30: 0,
    app_flat_30: 0
  },
  {
    char: 'anaxa',
    app: 4.31,
    char_1: 'robin',
    app_rate_1: '49.48%',
    avg_round_1: 3628.0,
    app_flat_1: 125,
    char_2: 'sunday',
    app_rate_2: '44.84%',
    avg_round_2: 3609.0,
    app_flat_2: 109,
    char_3: 'the-herta',
    app_rate_3: '34.23%',
    avg_round_3: 3543.0,
    app_flat_3: 108,
    char_4: 'ruan-mei',
    app_rate_4: '30.19%',
    avg_round_4: 3705.0,
    app_flat_4: 63,
    char_5: 'tribbie',
    app_rate_5: '22.87%',
    avg_round_5: 3575.0,
    app_flat_5: 62,
    char_6: 'aventurine',
    app_rate_6: '20.48%',
    avg_round_6: 3502.0,
    app_flat_6: 58,
    char_7: 'trailblazer-remembrance',
    app_rate_7: '18.09%',
    avg_round_7: 3618.0,
    app_flat_7: 57,
    char_8: 'gallagher',
    app_rate_8: '12.11%',
    avg_round_8: 3560.0,
    app_flat_8: 52,
    char_9: 'huohuo',
    app_rate_9: '11.66%',
    avg_round_9: 3541.0,
    app_flat_9: 34,
    char_10: 'bronya',
    app_rate_10: '9.12%',
    avg_round_10: 3611.0,
    app_flat_10: 27,
    char_11: 'lingsha',
    app_rate_11: '8.22%',
    avg_round_11: 3575.0,
    app_flat_11: 29,
    char_12: 'tingyun',
    app_rate_12: '6.88%',
    avg_round_12: 3709.0,
    app_flat_12: 14,
    char_13: 'fu-xuan',
    app_rate_13: '5.98%',
    avg_round_13: 3521.0,
    app_flat_13: 13,
    char_14: 'luocha',
    app_rate_14: '5.83%',
    avg_round_14: 3540.0,
    app_flat_14: 16,
    char_15: 'sparkle',
    app_rate_15: '4.48%',
    avg_round_15: 3595.0,
    app_flat_15: 11,
    char_16: 'jiaoqiu',
    app_rate_16: '4.04%',
    avg_round_16: 3519.0,
    app_flat_16: 6,
    char_17: 'tingyun-fugue',
    app_rate_17: '2.54%',
    avg_round_17: 3542.0,
    app_flat_17: 6,
    char_18: 'jade',
    app_rate_18: '1.49%',
    avg_round_18: 3483,
    app_flat_18: 3,
    char_19: 'pela',
    app_rate_19: '1.05%',
    avg_round_19: 3551,
    app_flat_19: 4,
    char_20: 'asta',
    app_rate_20: '0.75%',
    avg_round_20: 3628.0,
    app_flat_20: 3,
    char_21: 'boothill',
    app_rate_21: '0.75%',
    avg_round_21: 0,
    app_flat_21: 0,
    char_22: 'trailblazer-harmony',
    app_rate_22: '0.6%',
    avg_round_22: 0,
    app_flat_22: 0,
    char_23: 'acheron',
    app_rate_23: '0.6%',
    avg_round_23: 3107,
    app_flat_23: 2,
    char_24: 'bailu',
    app_rate_24: '0.45%',
    avg_round_24: 3266,
    app_flat_24: 1,
    char_25: 'moze',
    app_rate_25: '0.45%',
    avg_round_25: 3496,
    app_flat_25: 1,
    char_26: 'march-7th-swordmaster',
    app_rate_26: '0.45%',
    avg_round_26: 0,
    app_flat_26: 0,
    char_27: 'jing-yuan',
    app_rate_27: '0.45%',
    avg_round_27: 3210,
    app_flat_27: 1,
    char_28: 'clara',
    app_rate_28: '0.3%',
    avg_round_28: 3142.0,
    app_flat_28: 2,
    char_29: 'himeko',
    app_rate_29: '0.3%',
    avg_round_29: 0,
    app_flat_29: 0,
    char_30: 'mydei',
    app_rate_30: '0.3%',
    avg_round_30: 0,
    app_flat_30: 0
  },
  {
    char: 'rappa',
    app: 3.78,
    char_1: 'ruan-mei',
    app_rate_1: '90.46%',
    avg_round_1: 3300.0,
    app_flat_1: 141,
    char_2: 'tingyun-fugue',
    app_rate_2: '88.59%',
    avg_round_2: 3307.0,
    app_flat_2: 136,
    char_3: 'lingsha',
    app_rate_3: '52.81%',
    avg_round_3: 3330.0,
    app_flat_3: 80,
    char_4: 'gallagher',
    app_rate_4: '16.52%',
    avg_round_4: 3256.0,
    app_flat_4: 34,
    char_5: 'trailblazer-harmony',
    app_rate_5: '14.31%',
    avg_round_5: 3279.0,
    app_flat_5: 22,
    char_6: 'aventurine',
    app_rate_6: '8.18%',
    avg_round_6: 3285.0,
    app_flat_6: 17,
    char_7: 'huohuo',
    app_rate_7: '6.64%',
    avg_round_7: 3263.0,
    app_flat_7: 11,
    char_8: 'the-herta',
    app_rate_8: '4.94%',
    avg_round_8: 3373.0,
    app_flat_8: 12,
    char_9: 'luocha',
    app_rate_9: '3.24%',
    avg_round_9: 3315,
    app_flat_9: 5,
    char_10: 'firefly',
    app_rate_10: '3.07%',
    avg_round_10: 0,
    app_flat_10: 0,
    char_11: 'fu-xuan',
    app_rate_11: '2.56%',
    avg_round_11: 3172.0,
    app_flat_11: 5,
    char_12: 'tribbie',
    app_rate_12: '2.04%',
    avg_round_12: 3433.0,
    app_flat_12: 4,
    char_13: 'sunday',
    app_rate_13: '1.02%',
    avg_round_13: 3291.0,
    app_flat_13: 4,
    char_14: 'boothill',
    app_rate_14: '0.85%',
    avg_round_14: 3820,
    app_flat_14: 1,
    char_15: 'pela',
    app_rate_15: '0.68%',
    avg_round_15: 3250,
    app_flat_15: 1,
    char_16: 'trailblazer-remembrance',
    app_rate_16: '0.68%',
    avg_round_16: 3494,
    app_flat_16: 1,
    char_17: 'silver-wolf',
    app_rate_17: '0.51%',
    avg_round_17: 3384,
    app_flat_17: 1,
    char_18: 'march-7th',
    app_rate_18: '0.34%',
    avg_round_18: 0,
    app_flat_18: 0,
    char_19: 'bronya',
    app_rate_19: '0.34%',
    avg_round_19: 0,
    app_flat_19: 0,
    char_20: 'lynx',
    app_rate_20: '0.34%',
    avg_round_20: 3116,
    app_flat_20: 1,
    char_21: 'gepard',
    app_rate_21: '0.34%',
    avg_round_21: 3266,
    app_flat_21: 1,
    char_22: 'sparkle',
    app_rate_22: '0.17%',
    avg_round_22: 0,
    app_flat_22: 0,
    char_23: 'bailu',
    app_rate_23: '0.17%',
    avg_round_23: 0,
    app_flat_23: 0,
    char_24: 'yunli',
    app_rate_24: '0.17%',
    avg_round_24: 0,
    app_flat_24: 0,
    char_25: 'asta',
    app_rate_25: '0.17%',
    avg_round_25: 0,
    app_flat_25: 0,
    char_26: 'march-7th-swordmaster',
    app_rate_26: '0.17%',
    avg_round_26: 0,
    app_flat_26: 0,
    char_27: 'welt',
    app_rate_27: '0.17%',
    avg_round_27: 0,
    app_flat_27: 0,
    char_28: 'castorice',
    app_rate_28: '0.17%',
    avg_round_28: 0,
    app_flat_28: 0,
    char_29: 'robin',
    app_rate_29: '0.17%',
    avg_round_29: 0,
    app_flat_29: 0,
    char_30: 'jingliu',
    app_rate_30: '0.17%',
    avg_round_30: 0,
    app_flat_30: 0
  },
  {
    char: 'serval',
    app: 2.96,
    char_1: 'the-herta',
    app_rate_1: '100.0%',
    avg_round_1: 3406.0,
    app_flat_1: 217,
    char_2: 'tribbie',
    app_rate_2: '54.47%',
    avg_round_2: 3447.0,
    app_flat_2: 111,
    char_3: 'aventurine',
    app_rate_3: '27.23%',
    avg_round_3: 3400.0,
    app_flat_3: 74,
    char_4: 'trailblazer-remembrance',
    app_rate_4: '22.44%',
    avg_round_4: 3405.0,
    app_flat_4: 58,
    char_5: 'sunday',
    app_rate_5: '20.92%',
    avg_round_5: 3378.0,
    app_flat_5: 49,
    char_6: 'huohuo',
    app_rate_6: '19.39%',
    avg_round_6: 3407.0,
    app_flat_6: 40,
    char_7: 'fu-xuan',
    app_rate_7: '17.65%',
    avg_round_7: 3349.0,
    app_flat_7: 31,
    char_8: 'lingsha',
    app_rate_8: '17.65%',
    avg_round_8: 3428.0,
    app_flat_8: 35,
    char_9: 'gallagher',
    app_rate_9: '6.97%',
    avg_round_9: 3389.0,
    app_flat_9: 17,
    char_10: 'robin',
    app_rate_10: '5.45%',
    avg_round_10: 3231,
    app_flat_10: 6,
    char_11: 'luocha',
    app_rate_11: '3.92%',
    avg_round_11: 3354.0,
    app_flat_11: 7,
    char_12: 'ruan-mei',
    app_rate_12: '1.74%',
    avg_round_12: 3465,
    app_flat_12: 2,
    char_13: 'sparkle',
    app_rate_13: '0.65%',
    avg_round_13: 0,
    app_flat_13: 0,
    char_14: 'bailu',
    app_rate_14: '0.44%',
    avg_round_14: 3516,
    app_flat_14: 1,
    char_15: 'march-7th',
    app_rate_15: '0.22%',
    avg_round_15: 3406,
    app_flat_15: 1,
    char_16: 'gepard',
    app_rate_16: '0.22%',
    avg_round_16: 3408,
    app_flat_16: 1,
    char_17: 'asta',
    app_rate_17: '0.22%',
    avg_round_17: 0,
    app_flat_17: 0,
    char_18: 'herta',
    app_rate_18: '0.22%',
    avg_round_18: 0,
    app_flat_18: 0,
    char_19: 'pela',
    app_rate_19: '0.22%',
    avg_round_19: 3262,
    app_flat_19: 1,
    char_20: '-',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '-',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '-',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '-',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '-',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '-',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'blade',
    app: 2.79,
    char_1: 'castorice',
    app_rate_1: '65.36%',
    avg_round_1: 3432.0,
    app_flat_1: 132,
    char_2: 'tribbie',
    app_rate_2: '36.49%',
    avg_round_2: 3432.0,
    app_flat_2: 58,
    char_3: 'ruan-mei',
    app_rate_3: '29.1%',
    avg_round_3: 3401.0,
    app_flat_3: 35,
    char_4: 'gallagher',
    app_rate_4: '27.71%',
    avg_round_4: 3396.0,
    app_flat_4: 58,
    char_5: 'trailblazer-remembrance',
    app_rate_5: '25.17%',
    avg_round_5: 3440.0,
    app_flat_5: 58,
    char_6: 'luocha',
    app_rate_6: '24.25%',
    avg_round_6: 3402.0,
    app_flat_6: 46,
    char_7: 'sunday',
    app_rate_7: '21.02%',
    avg_round_7: 3320.0,
    app_flat_7: 16,
    char_8: 'robin',
    app_rate_8: '15.24%',
    avg_round_8: 3270.0,
    app_flat_8: 14,
    char_9: 'bronya',
    app_rate_9: '12.47%',
    avg_round_9: 3269,
    app_flat_9: 10,
    char_10: 'jade',
    app_rate_10: '6.93%',
    avg_round_10: 3208,
    app_flat_10: 6,
    char_11: 'lingsha',
    app_rate_11: '6.7%',
    avg_round_11: 3426.0,
    app_flat_11: 8,
    char_12: 'fu-xuan',
    app_rate_12: '5.77%',
    avg_round_12: 3276.0,
    app_flat_12: 6,
    char_13: 'sparkle',
    app_rate_13: '4.62%',
    avg_round_13: 3126,
    app_flat_13: 4,
    char_14: 'huohuo',
    app_rate_14: '4.62%',
    avg_round_14: 3358,
    app_flat_14: 4,
    char_15: 'mydei',
    app_rate_15: '2.08%',
    avg_round_15: 3454.0,
    app_flat_15: 4,
    char_16: 'jiaoqiu',
    app_rate_16: '1.85%',
    avg_round_16: 3483,
    app_flat_16: 1,
    char_17: 'yunli',
    app_rate_17: '1.39%',
    avg_round_17: 2846,
    app_flat_17: 1,
    char_18: 'lynx',
    app_rate_18: '1.39%',
    avg_round_18: 3083,
    app_flat_18: 2,
    char_19: 'tingyun-fugue',
    app_rate_19: '1.15%',
    avg_round_19: 3302,
    app_flat_19: 3,
    char_20: 'aventurine',
    app_rate_20: '0.92%',
    avg_round_20: 0,
    app_flat_20: 0,
    char_21: 'feixiao',
    app_rate_21: '0.92%',
    avg_round_21: 0,
    app_flat_21: 0,
    char_22: 'firefly',
    app_rate_22: '0.69%',
    avg_round_22: 0,
    app_flat_22: 0,
    char_23: 'jingliu',
    app_rate_23: '0.46%',
    avg_round_23: 3224,
    app_flat_23: 1,
    char_24: 'trailblazer-harmony',
    app_rate_24: '0.46%',
    avg_round_24: 0,
    app_flat_24: 0,
    char_25: 'silver-wolf',
    app_rate_25: '0.46%',
    avg_round_25: 0,
    app_flat_25: 0,
    char_26: 'march-7th-swordmaster',
    app_rate_26: '0.46%',
    avg_round_26: 3144,
    app_flat_26: 1,
    char_27: 'tingyun',
    app_rate_27: '0.23%',
    avg_round_27: 3172,
    app_flat_27: 1,
    char_28: 'natasha',
    app_rate_28: '0.23%',
    avg_round_28: 0,
    app_flat_28: 0,
    char_29: 'aglaea',
    app_rate_29: '0.23%',
    avg_round_29: 0,
    app_flat_29: 0,
    char_30: 'anaxa',
    app_rate_30: '0.23%',
    avg_round_30: 0,
    app_flat_30: 0
  },
  {
    char: 'argenti',
    app: 2.61,
    char_1: 'the-herta',
    app_rate_1: '77.28%',
    avg_round_1: 3500.0,
    app_flat_1: 158,
    char_2: 'tribbie',
    app_rate_2: '54.57%',
    avg_round_2: 3545.0,
    app_flat_2: 109,
    char_3: 'sunday',
    app_rate_3: '29.14%',
    avg_round_3: 3369.0,
    app_flat_3: 38,
    char_4: 'trailblazer-remembrance',
    app_rate_4: '28.4%',
    avg_round_4: 3497.0,
    app_flat_4: 62,
    char_5: 'aventurine',
    app_rate_5: '27.65%',
    avg_round_5: 3465.0,
    app_flat_5: 51,
    char_6: 'huohuo',
    app_rate_6: '19.26%',
    avg_round_6: 3445.0,
    app_flat_6: 34,
    char_7: 'robin',
    app_rate_7: '12.1%',
    avg_round_7: 3470.0,
    app_flat_7: 12,
    char_8: 'lingsha',
    app_rate_8: '10.86%',
    avg_round_8: 3452.0,
    app_flat_8: 22,
    char_9: 'fu-xuan',
    app_rate_9: '10.12%',
    avg_round_9: 3429.0,
    app_flat_9: 18,
    char_10: 'luocha',
    app_rate_10: '8.4%',
    avg_round_10: 3469.0,
    app_flat_10: 15,
    char_11: 'ruan-mei',
    app_rate_11: '7.65%',
    avg_round_11: 3247.0,
    app_flat_11: 9,
    char_12: 'gallagher',
    app_rate_12: '5.43%',
    avg_round_12: 3515.0,
    app_flat_12: 13,
    char_13: 'sparkle',
    app_rate_13: '3.46%',
    avg_round_13: 3342.0,
    app_flat_13: 3,
    char_14: 'tingyun',
    app_rate_14: '1.48%',
    avg_round_14: 3468,
    app_flat_14: 1,
    char_15: 'jade',
    app_rate_15: '0.99%',
    avg_round_15: 3311,
    app_flat_15: 1,
    char_16: 'jiaoqiu',
    app_rate_16: '0.74%',
    avg_round_16: 0,
    app_flat_16: 0,
    char_17: 'mydei',
    app_rate_17: '0.74%',
    avg_round_17: 3542,
    app_flat_17: 1,
    char_18: 'pela',
    app_rate_18: '0.49%',
    avg_round_18: 3219,
    app_flat_18: 1,
    char_19: 'herta',
    app_rate_19: '0.25%',
    avg_round_19: 0,
    app_flat_19: 0,
    char_20: 'acheron',
    app_rate_20: '0.25%',
    avg_round_20: 0,
    app_flat_20: 0,
    char_21: 'bronya',
    app_rate_21: '0.25%',
    avg_round_21: 0,
    app_flat_21: 0,
    char_22: 'lynx',
    app_rate_22: '0.25%',
    avg_round_22: 3381,
    app_flat_22: 1,
    char_23: 'anaxa',
    app_rate_23: '0.25%',
    avg_round_23: 0,
    app_flat_23: 0,
    char_24: '-',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '-',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'tingyun',
    app: 1.53,
    char_1: 'robin',
    app_rate_1: '57.38%',
    avg_round_1: 3294.0,
    app_flat_1: 41,
    char_2: 'yunli',
    app_rate_2: '37.97%',
    avg_round_2: 3222.0,
    app_flat_2: 29,
    char_3: 'ruan-mei',
    app_rate_3: '29.54%',
    avg_round_3: 3491.0,
    app_flat_3: 8,
    char_4: 'sunday',
    app_rate_4: '24.05%',
    avg_round_4: 3389.0,
    app_flat_4: 8,
    char_5: 'huohuo',
    app_rate_5: '21.94%',
    avg_round_5: 3253.0,
    app_flat_5: 17,
    char_6: 'anaxa',
    app_rate_6: '19.41%',
    avg_round_6: 3709.0,
    app_flat_6: 14,
    char_7: 'trailblazer-remembrance',
    app_rate_7: '18.14%',
    avg_round_7: 3576.0,
    app_flat_7: 14,
    char_8: 'castorice',
    app_rate_8: '16.88%',
    avg_round_8: 0,
    app_flat_8: 0,
    char_9: 'sparkle',
    app_rate_9: '14.35%',
    avg_round_9: 3377,
    app_flat_9: 8,
    char_10: 'seele',
    app_rate_10: '10.55%',
    avg_round_10: 3379.0,
    app_flat_10: 7,
    char_11: 'tribbie',
    app_rate_11: '8.86%',
    avg_round_11: 3395.0,
    app_flat_11: 5,
    char_12: 'aventurine',
    app_rate_12: '5.49%',
    avg_round_12: 3092,
    app_flat_12: 3,
    char_13: 'the-herta',
    app_rate_13: '2.95%',
    avg_round_13: 3541,
    app_flat_13: 1,
    char_14: 'fu-xuan',
    app_rate_14: '2.95%',
    avg_round_14: 3116,
    app_flat_14: 1,
    char_15: 'herta',
    app_rate_15: '2.53%',
    avg_round_15: 3541,
    app_flat_15: 1,
    char_16: 'argenti',
    app_rate_16: '2.53%',
    avg_round_16: 3468,
    app_flat_16: 1,
    char_17: 'gallagher',
    app_rate_17: '2.11%',
    avg_round_17: 3351,
    app_flat_17: 3,
    char_18: 'luocha',
    app_rate_18: '2.11%',
    avg_round_18: 3102,
    app_flat_18: 1,
    char_19: 'bronya',
    app_rate_19: '2.11%',
    avg_round_19: 3872,
    app_flat_19: 1,
    char_20: 'tingyun-fugue',
    app_rate_20: '1.69%',
    avg_round_20: 0,
    app_flat_20: 0,
    char_21: 'jiaoqiu',
    app_rate_21: '1.69%',
    avg_round_21: 0,
    app_flat_21: 0,
    char_22: 'imbibitor-lunae',
    app_rate_22: '1.69%',
    avg_round_22: 3106,
    app_flat_22: 1,
    char_23: 'lingsha',
    app_rate_23: '1.69%',
    avg_round_23: 0,
    app_flat_23: 0,
    char_24: 'acheron',
    app_rate_24: '1.27%',
    avg_round_24: 0,
    app_flat_24: 0,
    char_25: 'clara',
    app_rate_25: '1.27%',
    avg_round_25: 3363,
    app_flat_25: 1,
    char_26: 'jade',
    app_rate_26: '1.27%',
    avg_round_26: 0,
    app_flat_26: 0,
    char_27: 'firefly',
    app_rate_27: '0.84%',
    avg_round_27: 0,
    app_flat_27: 0,
    char_28: 'mydei',
    app_rate_28: '0.84%',
    avg_round_28: 0,
    app_flat_28: 0,
    char_29: 'topaz',
    app_rate_29: '0.84%',
    avg_round_29: 0,
    app_flat_29: 0,
    char_30: 'dan-heng',
    app_rate_30: '0.84%',
    avg_round_30: 3251,
    app_flat_30: 1
  },
  {
    char: 'aglaea',
    app: 1.51,
    char_1: 'sunday',
    app_rate_1: '85.04%',
    avg_round_1: 3344.0,
    app_flat_1: 25,
    char_2: 'robin',
    app_rate_2: '69.23%',
    avg_round_2: 3353.0,
    app_flat_2: 17,
    char_3: 'huohuo',
    app_rate_3: '32.48%',
    avg_round_3: 3234.0,
    app_flat_3: 9,
    char_4: 'tribbie',
    app_rate_4: '22.22%',
    avg_round_4: 3404,
    app_flat_4: 8,
    char_5: 'trailblazer-remembrance',
    app_rate_5: '21.37%',
    avg_round_5: 3400.0,
    app_flat_5: 2,
    char_6: 'bronya',
    app_rate_6: '16.67%',
    avg_round_6: 3486.0,
    app_flat_6: 4,
    char_7: 'fu-xuan',
    app_rate_7: '10.68%',
    avg_round_7: 3309.0,
    app_flat_7: 4,
    char_8: 'gallagher',
    app_rate_8: '7.69%',
    avg_round_8: 3192,
    app_flat_8: 2,
    char_9: 'aventurine',
    app_rate_9: '5.98%',
    avg_round_9: 3223,
    app_flat_9: 1,
    char_10: 'ruan-mei',
    app_rate_10: '5.56%',
    avg_round_10: 0,
    app_flat_10: 0,
    char_11: 'luocha',
    app_rate_11: '5.13%',
    avg_round_11: 3418,
    app_flat_11: 1,
    char_12: 'feixiao',
    app_rate_12: '3.42%',
    avg_round_12: 0,
    app_flat_12: 0,
    char_13: 'lingsha',
    app_rate_13: '3.42%',
    avg_round_13: 0,
    app_flat_13: 0,
    char_14: 'silver-wolf',
    app_rate_14: '2.99%',
    avg_round_14: 3512,
    app_flat_14: 1,
    char_15: 'jade',
    app_rate_15: '2.14%',
    avg_round_15: 0,
    app_flat_15: 0,
    char_16: 'asta',
    app_rate_16: '1.28%',
    avg_round_16: 3514,
    app_flat_16: 1,
    char_17: 'sparkle',
    app_rate_17: '0.85%',
    avg_round_17: 0,
    app_flat_17: 0,
    char_18: 'castorice',
    app_rate_18: '0.85%',
    avg_round_18: 0,
    app_flat_18: 0,
    char_19: 'lynx',
    app_rate_19: '0.85%',
    avg_round_19: 0,
    app_flat_19: 0,
    char_20: 'blade',
    app_rate_20: '0.43%',
    avg_round_20: 0,
    app_flat_20: 0,
    char_21: 'herta',
    app_rate_21: '0.43%',
    avg_round_21: 0,
    app_flat_21: 0,
    char_22: 'natasha',
    app_rate_22: '0.43%',
    avg_round_22: 0,
    app_flat_22: 0,
    char_23: 'bailu',
    app_rate_23: '0.43%',
    avg_round_23: 0,
    app_flat_23: 0,
    char_24: 'tingyun-fugue',
    app_rate_24: '0.43%',
    avg_round_24: 0,
    app_flat_24: 0,
    char_25: '-',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'silver-wolf',
    app: 1.23,
    char_1: 'acheron',
    app_rate_1: '60.21%',
    avg_round_1: 3219.0,
    app_flat_1: 29,
    char_2: 'fu-xuan',
    app_rate_2: '31.94%',
    avg_round_2: 3156.0,
    app_flat_2: 9,
    char_3: 'sparkle',
    app_rate_3: '28.27%',
    avg_round_3: 0,
    app_flat_3: 0,
    char_4: 'aventurine',
    app_rate_4: '26.18%',
    avg_round_4: 3244.0,
    app_flat_4: 17,
    char_5: 'jiaoqiu',
    app_rate_5: '19.9%',
    avg_round_5: 3256.0,
    app_flat_5: 18,
    char_6: 'castorice',
    app_rate_6: '16.75%',
    avg_round_6: 3434.0,
    app_flat_6: 7,
    char_7: 'pela',
    app_rate_7: '11.52%',
    avg_round_7: 3144.0,
    app_flat_7: 10,
    char_8: 'tribbie',
    app_rate_8: '9.42%',
    avg_round_8: 3388,
    app_flat_8: 1,
    char_9: 'gallagher',
    app_rate_9: '9.42%',
    avg_round_9: 3444.0,
    app_flat_9: 4,
    char_10: 'trailblazer-remembrance',
    app_rate_10: '8.9%',
    avg_round_10: 3458.0,
    app_flat_10: 5,
    char_11: 'sunday',
    app_rate_11: '8.9%',
    avg_round_11: 3353.0,
    app_flat_11: 4,
    char_12: 'robin',
    app_rate_12: '6.81%',
    avg_round_12: 0,
    app_flat_12: 0,
    char_13: 'luocha',
    app_rate_13: '6.28%',
    avg_round_13: 3373.0,
    app_flat_13: 5,
    char_14: 'ruan-mei',
    app_rate_14: '5.76%',
    avg_round_14: 3493,
    app_flat_14: 2,
    char_15: 'lingsha',
    app_rate_15: '5.24%',
    avg_round_15: 3414.0,
    app_flat_15: 2,
    char_16: 'seele',
    app_rate_16: '4.71%',
    avg_round_16: 0,
    app_flat_16: 0,
    char_17: 'bronya',
    app_rate_17: '4.19%',
    avg_round_17: 3262.0,
    app_flat_17: 2,
    char_18: 'aglaea',
    app_rate_18: '3.66%',
    avg_round_18: 3512,
    app_flat_18: 1,
    char_19: 'tingyun-fugue',
    app_rate_19: '3.14%',
    avg_round_19: 3305,
    app_flat_19: 1,
    char_20: 'huohuo',
    app_rate_20: '3.14%',
    avg_round_20: 3081,
    app_flat_20: 1,
    char_21: 'mydei',
    app_rate_21: '2.62%',
    avg_round_21: 3300.0,
    app_flat_21: 3,
    char_22: 'the-herta',
    app_rate_22: '2.09%',
    avg_round_22: 3384,
    app_flat_22: 1,
    char_23: 'dr-ratio',
    app_rate_23: '2.09%',
    avg_round_23: 0,
    app_flat_23: 0,
    char_24: 'firefly',
    app_rate_24: '2.09%',
    avg_round_24: 0,
    app_flat_24: 0,
    char_25: 'rappa',
    app_rate_25: '1.57%',
    avg_round_25: 3384,
    app_flat_25: 1,
    char_26: 'gepard',
    app_rate_26: '1.57%',
    avg_round_26: 0,
    app_flat_26: 0,
    char_27: 'trailblazer-harmony',
    app_rate_27: '1.57%',
    avg_round_27: 0,
    app_flat_27: 0,
    char_28: 'lynx',
    app_rate_28: '1.57%',
    avg_round_28: 0,
    app_flat_28: 0,
    char_29: 'herta',
    app_rate_29: '1.57%',
    avg_round_29: 0,
    app_flat_29: 0,
    char_30: 'qingque',
    app_rate_30: '1.57%',
    avg_round_30: 0,
    app_flat_30: 0
  },
  {
    char: 'seele',
    app: 0.99,
    char_1: 'robin',
    app_rate_1: '70.59%',
    avg_round_1: 3434.0,
    app_flat_1: 22,
    char_2: 'sunday',
    app_rate_2: '49.02%',
    avg_round_2: 3360.0,
    app_flat_2: 21,
    char_3: 'sparkle',
    app_rate_3: '37.25%',
    avg_round_3: 3358.0,
    app_flat_3: 13,
    char_4: 'ruan-mei',
    app_rate_4: '29.41%',
    avg_round_4: 3334.0,
    app_flat_4: 7,
    char_5: 'fu-xuan',
    app_rate_5: '22.22%',
    avg_round_5: 3286.0,
    app_flat_5: 5,
    char_6: 'trailblazer-remembrance',
    app_rate_6: '19.61%',
    avg_round_6: 3448.0,
    app_flat_6: 9,
    char_7: 'tingyun',
    app_rate_7: '16.34%',
    avg_round_7: 3379.0,
    app_flat_7: 7,
    char_8: 'tribbie',
    app_rate_8: '12.42%',
    avg_round_8: 3370.0,
    app_flat_8: 3,
    char_9: 'huohuo',
    app_rate_9: '7.19%',
    avg_round_9: 3203,
    app_flat_9: 2,
    char_10: 'silver-wolf',
    app_rate_10: '5.88%',
    avg_round_10: 0,
    app_flat_10: 0,
    char_11: 'bronya',
    app_rate_11: '5.23%',
    avg_round_11: 0,
    app_flat_11: 0,
    char_12: 'feixiao',
    app_rate_12: '4.58%',
    avg_round_12: 0,
    app_flat_12: 0,
    char_13: 'gallagher',
    app_rate_13: '3.92%',
    avg_round_13: 3318.0,
    app_flat_13: 3,
    char_14: 'castorice',
    app_rate_14: '3.27%',
    avg_round_14: 3461.0,
    app_flat_14: 3,
    char_15: 'aventurine',
    app_rate_15: '3.27%',
    avg_round_15: 3308.0,
    app_flat_15: 3,
    char_16: 'asta',
    app_rate_16: '1.96%',
    avg_round_16: 0,
    app_flat_16: 0,
    char_17: 'tingyun-fugue',
    app_rate_17: '1.31%',
    avg_round_17: 0,
    app_flat_17: 0,
    char_18: 'lynx',
    app_rate_18: '1.31%',
    avg_round_18: 0,
    app_flat_18: 0,
    char_19: 'luocha',
    app_rate_19: '1.31%',
    avg_round_19: 0,
    app_flat_19: 0,
    char_20: 'march-7th-swordmaster',
    app_rate_20: '1.31%',
    avg_round_20: 0,
    app_flat_20: 0,
    char_21: 'lingsha',
    app_rate_21: '0.65%',
    avg_round_21: 3504,
    app_flat_21: 1,
    char_22: 'yunli',
    app_rate_22: '0.65%',
    avg_round_22: 0,
    app_flat_22: 0,
    char_23: 'jiaoqiu',
    app_rate_23: '0.65%',
    avg_round_23: 0,
    app_flat_23: 0,
    char_24: 'clara',
    app_rate_24: '0.65%',
    avg_round_24: 0,
    app_flat_24: 0,
    char_25: '-',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'clara',
    app: 0.9,
    char_1: 'robin',
    app_rate_1: '70.71%',
    avg_round_1: 3170.0,
    app_flat_1: 22,
    char_2: 'aventurine',
    app_rate_2: '27.86%',
    avg_round_2: 3156.0,
    app_flat_2: 13,
    char_3: 'tribbie',
    app_rate_3: '24.29%',
    avg_round_3: 3318.0,
    app_flat_3: 5,
    char_4: 'ruan-mei',
    app_rate_4: '19.29%',
    avg_round_4: 3137,
    app_flat_4: 3,
    char_5: 'feixiao',
    app_rate_5: '16.43%',
    avg_round_5: 3247.0,
    app_flat_5: 13,
    char_6: 'huohuo',
    app_rate_6: '15.0%',
    avg_round_6: 3040.0,
    app_flat_6: 2,
    char_7: 'fu-xuan',
    app_rate_7: '12.14%',
    avg_round_7: 0,
    app_flat_7: 0,
    char_8: 'trailblazer-remembrance',
    app_rate_8: '11.43%',
    avg_round_8: 3215.0,
    app_flat_8: 6,
    char_9: 'topaz',
    app_rate_9: '11.43%',
    avg_round_9: 3120.0,
    app_flat_9: 4,
    char_10: 'castorice',
    app_rate_10: '10.71%',
    avg_round_10: 3256.0,
    app_flat_10: 6,
    char_11: 'sparkle',
    app_rate_11: '10.71%',
    avg_round_11: 3318,
    app_flat_11: 2,
    char_12: 'march-7th-swordmaster',
    app_rate_12: '10.0%',
    avg_round_12: 3200.0,
    app_flat_12: 2,
    char_13: 'gallagher',
    app_rate_13: '9.29%',
    avg_round_13: 3194.0,
    app_flat_13: 7,
    char_14: 'luocha',
    app_rate_14: '7.86%',
    avg_round_14: 3258.0,
    app_flat_14: 4,
    char_15: 'yunli',
    app_rate_15: '5.71%',
    avg_round_15: 2890,
    app_flat_15: 1,
    char_16: 'jade',
    app_rate_16: '5.71%',
    avg_round_16: 0,
    app_flat_16: 0,
    char_17: 'lingsha',
    app_rate_17: '5.0%',
    avg_round_17: 3095.0,
    app_flat_17: 3,
    char_18: 'sunday',
    app_rate_18: '4.29%',
    avg_round_18: 0,
    app_flat_18: 0,
    char_19: 'herta',
    app_rate_19: '3.57%',
    avg_round_19: 3017,
    app_flat_19: 1,
    char_20: 'the-herta',
    app_rate_20: '2.86%',
    avg_round_20: 3167,
    app_flat_20: 2,
    char_21: 'tingyun',
    app_rate_21: '2.14%',
    avg_round_21: 3363,
    app_flat_21: 1,
    char_22: 'anaxa',
    app_rate_22: '1.43%',
    avg_round_22: 3142.0,
    app_flat_22: 2,
    char_23: 'tingyun-fugue',
    app_rate_23: '1.43%',
    avg_round_23: 0,
    app_flat_23: 0,
    char_24: 'boothill',
    app_rate_24: '1.43%',
    avg_round_24: 0,
    app_flat_24: 0,
    char_25: 'firefly',
    app_rate_25: '0.71%',
    avg_round_25: 0,
    app_flat_25: 0,
    char_26: 'mydei',
    app_rate_26: '0.71%',
    avg_round_26: 3196,
    app_flat_26: 1,
    char_27: 'jiaoqiu',
    app_rate_27: '0.71%',
    avg_round_27: 3074,
    app_flat_27: 1,
    char_28: 'lynx',
    app_rate_28: '0.71%',
    avg_round_28: 0,
    app_flat_28: 0,
    char_29: 'pela',
    app_rate_29: '0.71%',
    avg_round_29: 2988,
    app_flat_29: 1,
    char_30: 'bailu',
    app_rate_30: '0.71%',
    avg_round_30: 0,
    app_flat_30: 0
  },
  {
    char: 'bailu',
    app: 0.84,
    char_1: 'castorice',
    app_rate_1: '46.15%',
    avg_round_1: 3497.0,
    app_flat_1: 24,
    char_2: 'trailblazer-remembrance',
    app_rate_2: '43.08%',
    avg_round_2: 3484.0,
    app_flat_2: 26,
    char_3: 'tribbie',
    app_rate_3: '33.08%',
    avg_round_3: 3453.0,
    app_flat_3: 22,
    char_4: 'ruan-mei',
    app_rate_4: '26.15%',
    avg_round_4: 3442.0,
    app_flat_4: 8,
    char_5: 'robin',
    app_rate_5: '19.23%',
    avg_round_5: 3345.0,
    app_flat_5: 12,
    char_6: 'the-herta',
    app_rate_6: '17.69%',
    avg_round_6: 3376.0,
    app_flat_6: 15,
    char_7: 'sunday',
    app_rate_7: '16.15%',
    avg_round_7: 3362.0,
    app_flat_7: 10,
    char_8: 'feixiao',
    app_rate_8: '12.31%',
    avg_round_8: 3352.0,
    app_flat_8: 10,
    char_9: 'herta',
    app_rate_9: '11.54%',
    avg_round_9: 3356,
    app_flat_9: 10,
    char_10: 'march-7th-swordmaster',
    app_rate_10: '10.77%',
    avg_round_10: 3352.0,
    app_flat_10: 10,
    char_11: 'jade',
    app_rate_11: '6.92%',
    avg_round_11: 3391.0,
    app_flat_11: 4,
    char_12: 'bronya',
    app_rate_12: '5.38%',
    avg_round_12: 3471,
    app_flat_12: 2,
    char_13: 'mydei',
    app_rate_13: '5.38%',
    avg_round_13: 3331,
    app_flat_13: 4,
    char_14: 'sparkle',
    app_rate_14: '3.85%',
    avg_round_14: 3498.0,
    app_flat_14: 2,
    char_15: 'tingyun-fugue',
    app_rate_15: '3.85%',
    avg_round_15: 3382,
    app_flat_15: 1,
    char_16: 'fu-xuan',
    app_rate_16: '3.08%',
    avg_round_16: 0,
    app_flat_16: 0,
    char_17: 'firefly',
    app_rate_17: '3.08%',
    avg_round_17: 0,
    app_flat_17: 0,
    char_18: 'anaxa',
    app_rate_18: '2.31%',
    avg_round_18: 3266,
    app_flat_18: 1,
    char_19: 'boothill',
    app_rate_19: '2.31%',
    avg_round_19: 0,
    app_flat_19: 0,
    char_20: 'gallagher',
    app_rate_20: '2.31%',
    avg_round_20: 0,
    app_flat_20: 0,
    char_21: 'pela',
    app_rate_21: '2.31%',
    avg_round_21: 0,
    app_flat_21: 0,
    char_22: 'acheron',
    app_rate_22: '2.31%',
    avg_round_22: 0,
    app_flat_22: 0,
    char_23: 'trailblazer-harmony',
    app_rate_23: '2.31%',
    avg_round_23: 0,
    app_flat_23: 0,
    char_24: 'yunli',
    app_rate_24: '2.31%',
    avg_round_24: 0,
    app_flat_24: 0,
    char_25: 'topaz',
    app_rate_25: '2.31%',
    avg_round_25: 0,
    app_flat_25: 0,
    char_26: 'lingsha',
    app_rate_26: '1.54%',
    avg_round_26: 0,
    app_flat_26: 0,
    char_27: 'jiaoqiu',
    app_rate_27: '1.54%',
    avg_round_27: 0,
    app_flat_27: 0,
    char_28: 'serval',
    app_rate_28: '1.54%',
    avg_round_28: 3516,
    app_flat_28: 1,
    char_29: 'jingliu',
    app_rate_29: '1.54%',
    avg_round_29: 0,
    app_flat_29: 0,
    char_30: 'huohuo',
    app_rate_30: '0.77%',
    avg_round_30: 0,
    app_flat_30: 0
  },
  {
    char: 'imbibitor-lunae',
    app: 0.73,
    char_1: 'sunday',
    app_rate_1: '59.29%',
    avg_round_1: 3458,
    app_flat_1: 1,
    char_2: 'sparkle',
    app_rate_2: '49.56%',
    avg_round_2: 3106,
    app_flat_2: 1,
    char_3: 'robin',
    app_rate_3: '30.97%',
    avg_round_3: 0,
    app_flat_3: 0,
    char_4: 'huohuo',
    app_rate_4: '28.32%',
    avg_round_4: 0,
    app_flat_4: 0,
    char_5: 'ruan-mei',
    app_rate_5: '26.55%',
    avg_round_5: 3458,
    app_flat_5: 1,
    char_6: 'aventurine',
    app_rate_6: '23.01%',
    avg_round_6: 3106,
    app_flat_6: 1,
    char_7: 'luocha',
    app_rate_7: '21.24%',
    avg_round_7: 0,
    app_flat_7: 0,
    char_8: 'tribbie',
    app_rate_8: '18.58%',
    avg_round_8: 0,
    app_flat_8: 0,
    char_9: 'trailblazer-remembrance',
    app_rate_9: '15.04%',
    avg_round_9: 3458,
    app_flat_9: 1,
    char_10: 'fu-xuan',
    app_rate_10: '7.96%',
    avg_round_10: 0,
    app_flat_10: 0,
    char_11: 'gallagher',
    app_rate_11: '7.08%',
    avg_round_11: 0,
    app_flat_11: 0,
    char_12: 'tingyun',
    app_rate_12: '3.54%',
    avg_round_12: 3106,
    app_flat_12: 1,
    char_13: 'jiaoqiu',
    app_rate_13: '2.65%',
    avg_round_13: 0,
    app_flat_13: 0,
    char_14: 'pela',
    app_rate_14: '0.88%',
    avg_round_14: 0,
    app_flat_14: 0,
    char_15: 'jade',
    app_rate_15: '0.88%',
    avg_round_15: 0,
    app_flat_15: 0,
    char_16: 'bronya',
    app_rate_16: '0.88%',
    avg_round_16: 0,
    app_flat_16: 0,
    char_17: 'tingyun-fugue',
    app_rate_17: '0.88%',
    avg_round_17: 0,
    app_flat_17: 0,
    char_18: 'lynx',
    app_rate_18: '0.88%',
    avg_round_18: 0,
    app_flat_18: 0,
    char_19: 'mydei',
    app_rate_19: '0.88%',
    avg_round_19: 0,
    app_flat_19: 0,
    char_20: 'silver-wolf',
    app_rate_20: '0.88%',
    avg_round_20: 0,
    app_flat_20: 0,
    char_21: '-',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '-',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '-',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '-',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '-',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'moze',
    app: 0.64,
    char_1: 'feixiao',
    app_rate_1: '93.94%',
    avg_round_1: 3301.0,
    app_flat_1: 44,
    char_2: 'robin',
    app_rate_2: '86.87%',
    avg_round_2: 3308.0,
    app_flat_2: 41,
    char_3: 'aventurine',
    app_rate_3: '78.79%',
    avg_round_3: 3301.0,
    app_flat_3: 40,
    char_4: 'gallagher',
    app_rate_4: '7.07%',
    avg_round_4: 3472.0,
    app_flat_4: 2,
    char_5: 'lingsha',
    app_rate_5: '4.04%',
    avg_round_5: 3249.0,
    app_flat_5: 3,
    char_6: 'ruan-mei',
    app_rate_6: '4.04%',
    avg_round_6: 0,
    app_flat_6: 0,
    char_7: 'anaxa',
    app_rate_7: '3.03%',
    avg_round_7: 3496,
    app_flat_7: 1,
    char_8: 'march-7th-swordmaster',
    app_rate_8: '3.03%',
    avg_round_8: 3086,
    app_flat_8: 1,
    char_9: 'tribbie',
    app_rate_9: '3.03%',
    avg_round_9: 3319,
    app_flat_9: 1,
    char_10: 'fu-xuan',
    app_rate_10: '3.03%',
    avg_round_10: 0,
    app_flat_10: 0,
    char_11: 'luocha',
    app_rate_11: '2.02%',
    avg_round_11: 0,
    app_flat_11: 0,
    char_12: 'yunli',
    app_rate_12: '2.02%',
    avg_round_12: 0,
    app_flat_12: 0,
    char_13: 'jiaoqiu',
    app_rate_13: '2.02%',
    avg_round_13: 0,
    app_flat_13: 0,
    char_14: 'trailblazer-remembrance',
    app_rate_14: '2.02%',
    avg_round_14: 3496,
    app_flat_14: 1,
    char_15: 'huohuo',
    app_rate_15: '1.01%',
    avg_round_15: 0,
    app_flat_15: 0,
    char_16: 'bronya',
    app_rate_16: '1.01%',
    avg_round_16: 0,
    app_flat_16: 0,
    char_17: 'dr-ratio',
    app_rate_17: '1.01%',
    avg_round_17: 0,
    app_flat_17: 0,
    char_18: 'sunday',
    app_rate_18: '1.01%',
    avg_round_18: 3224,
    app_flat_18: 1,
    char_19: 'tingyun',
    app_rate_19: '1.01%',
    avg_round_19: 0,
    app_flat_19: 0,
    char_20: '-',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '-',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '-',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '-',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '-',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '-',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'lynx',
    app: 0.6,
    char_1: 'trailblazer-remembrance',
    app_rate_1: '41.94%',
    avg_round_1: 3435.0,
    app_flat_1: 19,
    char_2: 'sunday',
    app_rate_2: '37.63%',
    avg_round_2: 3347.0,
    app_flat_2: 17,
    char_3: 'mydei',
    app_rate_3: '33.33%',
    avg_round_3: 3340.0,
    app_flat_3: 17,
    char_4: 'castorice',
    app_rate_4: '31.18%',
    avg_round_4: 3461.0,
    app_flat_4: 9,
    char_5: 'tribbie',
    app_rate_5: '21.51%',
    avg_round_5: 3484.0,
    app_flat_5: 7,
    char_6: 'ruan-mei',
    app_rate_6: '17.2%',
    avg_round_6: 3302.0,
    app_flat_6: 6,
    char_7: 'robin',
    app_rate_7: '16.13%',
    avg_round_7: 3323,
    app_flat_7: 6,
    char_8: 'sparkle',
    app_rate_8: '16.13%',
    avg_round_8: 3231.0,
    app_flat_8: 7,
    char_9: 'the-herta',
    app_rate_9: '12.9%',
    avg_round_9: 3401.0,
    app_flat_9: 6,
    char_10: 'bronya',
    app_rate_10: '10.75%',
    avg_round_10: 3252.0,
    app_flat_10: 3,
    char_11: 'jade',
    app_rate_11: '10.75%',
    avg_round_11: 3403.0,
    app_flat_11: 5,
    char_12: 'blade',
    app_rate_12: '6.45%',
    avg_round_12: 3083,
    app_flat_12: 2,
    char_13: 'yunli',
    app_rate_13: '5.38%',
    avg_round_13: 3062,
    app_flat_13: 1,
    char_14: 'herta',
    app_rate_14: '5.38%',
    avg_round_14: 3330,
    app_flat_14: 1,
    char_15: 'pela',
    app_rate_15: '4.3%',
    avg_round_15: 3341,
    app_flat_15: 3,
    char_16: 'silver-wolf',
    app_rate_16: '3.23%',
    avg_round_16: 0,
    app_flat_16: 0,
    char_17: 'jiaoqiu',
    app_rate_17: '3.23%',
    avg_round_17: 3358,
    app_flat_17: 1,
    char_18: 'aglaea',
    app_rate_18: '2.15%',
    avg_round_18: 0,
    app_flat_18: 0,
    char_19: 'seele',
    app_rate_19: '2.15%',
    avg_round_19: 0,
    app_flat_19: 0,
    char_20: 'feixiao',
    app_rate_20: '2.15%',
    avg_round_20: 3321,
    app_flat_20: 1,
    char_21: 'fu-xuan',
    app_rate_21: '2.15%',
    avg_round_21: 0,
    app_flat_21: 0,
    char_22: 'rappa',
    app_rate_22: '2.15%',
    avg_round_22: 3116,
    app_flat_22: 1,
    char_23: 'tingyun-fugue',
    app_rate_23: '2.15%',
    avg_round_23: 3116,
    app_flat_23: 1,
    char_24: 'acheron',
    app_rate_24: '2.15%',
    avg_round_24: 3358,
    app_flat_24: 1,
    char_25: 'luocha',
    app_rate_25: '1.08%',
    avg_round_25: 0,
    app_flat_25: 0,
    char_26: 'march-7th-swordmaster',
    app_rate_26: '1.08%',
    avg_round_26: 3321,
    app_flat_26: 1,
    char_27: 'clara',
    app_rate_27: '1.08%',
    avg_round_27: 0,
    app_flat_27: 0,
    char_28: 'gallagher',
    app_rate_28: '1.08%',
    avg_round_28: 0,
    app_flat_28: 0,
    char_29: 'imbibitor-lunae',
    app_rate_29: '1.08%',
    avg_round_29: 0,
    app_flat_29: 0,
    char_30: 'argenti',
    app_rate_30: '1.08%',
    avg_round_30: 3381,
    app_flat_30: 1
  },
  {
    char: 'black-swan',
    app: 0.34,
    char_1: 'acheron',
    app_rate_1: '58.49%',
    avg_round_1: 3050.0,
    app_flat_1: 2,
    char_2: 'kafka',
    app_rate_2: '52.83%',
    avg_round_2: 0,
    app_flat_2: 0,
    char_3: 'ruan-mei',
    app_rate_3: '35.85%',
    avg_round_3: 3062,
    app_flat_3: 1,
    char_4: 'aventurine',
    app_rate_4: '24.53%',
    avg_round_4: 3137,
    app_flat_4: 1,
    char_5: 'huohuo',
    app_rate_5: '20.75%',
    avg_round_5: 0,
    app_flat_5: 0,
    char_6: 'robin',
    app_rate_6: '15.09%',
    avg_round_6: 0,
    app_flat_6: 0,
    char_7: 'fu-xuan',
    app_rate_7: '13.21%',
    avg_round_7: 2962,
    app_flat_7: 1,
    char_8: 'jiaoqiu',
    app_rate_8: '13.21%',
    avg_round_8: 2962,
    app_flat_8: 1,
    char_9: 'lingsha',
    app_rate_9: '9.43%',
    avg_round_9: 3062,
    app_flat_9: 1,
    char_10: 'gallagher',
    app_rate_10: '9.43%',
    avg_round_10: 0,
    app_flat_10: 0,
    char_11: 'pela',
    app_rate_11: '7.55%',
    avg_round_11: 3137,
    app_flat_11: 1,
    char_12: 'castorice',
    app_rate_12: '5.66%',
    avg_round_12: 3428,
    app_flat_12: 1,
    char_13: 'tribbie',
    app_rate_13: '5.66%',
    avg_round_13: 0,
    app_flat_13: 0,
    char_14: 'trailblazer-remembrance',
    app_rate_14: '3.77%',
    avg_round_14: 3428,
    app_flat_14: 1,
    char_15: 'gepard',
    app_rate_15: '3.77%',
    avg_round_15: 0,
    app_flat_15: 0,
    char_16: 'sampo',
    app_rate_16: '3.77%',
    avg_round_16: 0,
    app_flat_16: 0,
    char_17: 'sparkle',
    app_rate_17: '3.77%',
    avg_round_17: 0,
    app_flat_17: 0,
    char_18: 'luocha',
    app_rate_18: '3.77%',
    avg_round_18: 3428,
    app_flat_18: 1,
    char_19: 'bailu',
    app_rate_19: '1.89%',
    avg_round_19: 0,
    app_flat_19: 0,
    char_20: 'bronya',
    app_rate_20: '1.89%',
    avg_round_20: 0,
    app_flat_20: 0,
    char_21: 'luka',
    app_rate_21: '1.89%',
    avg_round_21: 3062,
    app_flat_21: 1,
    char_22: 'trailblazer-harmony',
    app_rate_22: '1.89%',
    avg_round_22: 0,
    app_flat_22: 0,
    char_23: 'clara',
    app_rate_23: '1.89%',
    avg_round_23: 0,
    app_flat_23: 0,
    char_24: '-',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '-',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'jingliu',
    app: 0.34,
    char_1: 'sunday',
    app_rate_1: '50.0%',
    avg_round_1: 3139.0,
    app_flat_1: 4,
    char_2: 'tribbie',
    app_rate_2: '38.46%',
    avg_round_2: 3173.0,
    app_flat_2: 3,
    char_3: 'huohuo',
    app_rate_3: '34.62%',
    avg_round_3: 3130.0,
    app_flat_3: 2,
    char_4: 'ruan-mei',
    app_rate_4: '28.85%',
    avg_round_4: 0,
    app_flat_4: 0,
    char_5: 'luocha',
    app_rate_5: '25.0%',
    avg_round_5: 3215,
    app_flat_5: 3,
    char_6: 'bronya',
    app_rate_6: '17.31%',
    avg_round_6: 3025,
    app_flat_6: 1,
    char_7: 'castorice',
    app_rate_7: '15.38%',
    avg_round_7: 3327.0,
    app_flat_7: 3,
    char_8: 'robin',
    app_rate_8: '13.46%',
    avg_round_8: 3150,
    app_flat_8: 1,
    char_9: 'fu-xuan',
    app_rate_9: '13.46%',
    avg_round_9: 0,
    app_flat_9: 0,
    char_10: 'trailblazer-remembrance',
    app_rate_10: '11.54%',
    avg_round_10: 3290.0,
    app_flat_10: 3,
    char_11: 'mydei',
    app_rate_11: '7.69%',
    avg_round_11: 3025,
    app_flat_11: 1,
    char_12: 'aventurine',
    app_rate_12: '7.69%',
    avg_round_12: 3096,
    app_flat_12: 1,
    char_13: 'gallagher',
    app_rate_13: '7.69%',
    avg_round_13: 3336,
    app_flat_13: 1,
    char_14: 'pela',
    app_rate_14: '7.69%',
    avg_round_14: 0,
    app_flat_14: 0,
    char_15: 'bailu',
    app_rate_15: '3.85%',
    avg_round_15: 0,
    app_flat_15: 0,
    char_16: 'blade',
    app_rate_16: '3.85%',
    avg_round_16: 3224,
    app_flat_16: 1,
    char_17: 'lingsha',
    app_rate_17: '1.92%',
    avg_round_17: 0,
    app_flat_17: 0,
    char_18: 'sparkle',
    app_rate_18: '1.92%',
    avg_round_18: 0,
    app_flat_18: 0,
    char_19: 'herta',
    app_rate_19: '1.92%',
    avg_round_19: 0,
    app_flat_19: 0,
    char_20: 'jade',
    app_rate_20: '1.92%',
    avg_round_20: 0,
    app_flat_20: 0,
    char_21: 'silver-wolf',
    app_rate_21: '1.92%',
    avg_round_21: 0,
    app_flat_21: 0,
    char_22: 'the-herta',
    app_rate_22: '1.92%',
    avg_round_22: 0,
    app_flat_22: 0,
    char_23: 'rappa',
    app_rate_23: '1.92%',
    avg_round_23: 0,
    app_flat_23: 0,
    char_24: '-',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '-',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'gepard',
    app: 0.29,
    char_1: 'acheron',
    app_rate_1: '51.11%',
    avg_round_1: 3288,
    app_flat_1: 3,
    char_2: 'the-herta',
    app_rate_2: '37.78%',
    avg_round_2: 3291.0,
    app_flat_2: 8,
    char_3: 'jiaoqiu',
    app_rate_3: '28.89%',
    avg_round_3: 3288,
    app_flat_3: 3,
    char_4: 'herta',
    app_rate_4: '24.44%',
    avg_round_4: 3229.0,
    app_flat_4: 4,
    char_5: 'pela',
    app_rate_5: '22.22%',
    avg_round_5: 3288,
    app_flat_5: 3,
    char_6: 'sparkle',
    app_rate_6: '20.0%',
    avg_round_6: 3261,
    app_flat_6: 1,
    char_7: 'robin',
    app_rate_7: '15.56%',
    avg_round_7: 3351,
    app_flat_7: 3,
    char_8: 'tribbie',
    app_rate_8: '13.33%',
    avg_round_8: 3102,
    app_flat_8: 1,
    char_9: 'sunday',
    app_rate_9: '11.11%',
    avg_round_9: 3340.0,
    app_flat_9: 2,
    char_10: 'trailblazer-remembrance',
    app_rate_10: '8.89%',
    avg_round_10: 3270,
    app_flat_10: 3,
    char_11: 'bronya',
    app_rate_11: '8.89%',
    avg_round_11: 0,
    app_flat_11: 0,
    char_12: 'ruan-mei',
    app_rate_12: '8.89%',
    avg_round_12: 0,
    app_flat_12: 0,
    char_13: 'jade',
    app_rate_13: '8.89%',
    avg_round_13: 3368,
    app_flat_13: 2,
    char_14: 'silver-wolf',
    app_rate_14: '6.67%',
    avg_round_14: 0,
    app_flat_14: 0,
    char_15: 'feixiao',
    app_rate_15: '6.67%',
    avg_round_15: 3289,
    app_flat_15: 2,
    char_16: 'march-7th-swordmaster',
    app_rate_16: '6.67%',
    avg_round_16: 3289,
    app_flat_16: 2,
    char_17: 'black-swan',
    app_rate_17: '4.44%',
    avg_round_17: 0,
    app_flat_17: 0,
    char_18: 'rappa',
    app_rate_18: '4.44%',
    avg_round_18: 3266,
    app_flat_18: 1,
    char_19: 'huohuo',
    app_rate_19: '2.22%',
    avg_round_19: 0,
    app_flat_19: 0,
    char_20: 'firefly',
    app_rate_20: '2.22%',
    avg_round_20: 0,
    app_flat_20: 0,
    char_21: 'tingyun-fugue',
    app_rate_21: '2.22%',
    avg_round_21: 0,
    app_flat_21: 0,
    char_22: 'serval',
    app_rate_22: '2.22%',
    avg_round_22: 3408,
    app_flat_22: 1,
    char_23: 'trailblazer-harmony',
    app_rate_23: '2.22%',
    avg_round_23: 0,
    app_flat_23: 0,
    char_24: '-',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '-',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'jing-yuan',
    app: 0.28,
    char_1: 'sunday',
    app_rate_1: '95.35%',
    avg_round_1: 3202.0,
    app_flat_1: 6,
    char_2: 'robin',
    app_rate_2: '53.49%',
    avg_round_2: 3058.0,
    app_flat_2: 2,
    char_3: 'tribbie',
    app_rate_3: '30.23%',
    avg_round_3: 3255.0,
    app_flat_3: 3,
    char_4: 'aventurine',
    app_rate_4: '25.58%',
    avg_round_4: 3142,
    app_flat_4: 2,
    char_5: 'fu-xuan',
    app_rate_5: '18.6%',
    avg_round_5: 3218,
    app_flat_5: 1,
    char_6: 'gallagher',
    app_rate_6: '16.28%',
    avg_round_6: 3190.0,
    app_flat_6: 2,
    char_7: 'huohuo',
    app_rate_7: '11.63%',
    avg_round_7: 0,
    app_flat_7: 0,
    char_8: 'sparkle',
    app_rate_8: '6.98%',
    avg_round_8: 0,
    app_flat_8: 0,
    char_9: 'the-herta',
    app_rate_9: '6.98%',
    avg_round_9: 0,
    app_flat_9: 0,
    char_10: 'anaxa',
    app_rate_10: '6.98%',
    avg_round_10: 3210,
    app_flat_10: 1,
    char_11: 'trailblazer-remembrance',
    app_rate_11: '6.98%',
    avg_round_11: 0,
    app_flat_11: 0,
    char_12: 'luocha',
    app_rate_12: '6.98%',
    avg_round_12: 3210,
    app_flat_12: 1,
    char_13: 'lingsha',
    app_rate_13: '4.65%',
    avg_round_13: 0,
    app_flat_13: 0,
    char_14: 'feixiao',
    app_rate_14: '2.33%',
    avg_round_14: 0,
    app_flat_14: 0,
    char_15: 'ruan-mei',
    app_rate_15: '2.33%',
    avg_round_15: 0,
    app_flat_15: 0,
    char_16: 'bronya',
    app_rate_16: '2.33%',
    avg_round_16: 0,
    app_flat_16: 0,
    char_17: 'jade',
    app_rate_17: '2.33%',
    avg_round_17: 0,
    app_flat_17: 0,
    char_18: '-',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '-',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '-',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '-',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '-',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '-',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '-',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '-',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'kafka',
    app: 0.25,
    char_1: 'black-swan',
    app_rate_1: '71.79%',
    avg_round_1: 0,
    app_flat_1: 0,
    char_2: 'acheron',
    app_rate_2: '48.72%',
    avg_round_2: 0,
    app_flat_2: 0,
    char_3: 'ruan-mei',
    app_rate_3: '38.46%',
    avg_round_3: 0,
    app_flat_3: 0,
    char_4: 'aventurine',
    app_rate_4: '25.64%',
    avg_round_4: 0,
    app_flat_4: 0,
    char_5: 'fu-xuan',
    app_rate_5: '17.95%',
    avg_round_5: 0,
    app_flat_5: 0,
    char_6: 'huohuo',
    app_rate_6: '17.95%',
    avg_round_6: 0,
    app_flat_6: 0,
    char_7: 'jiaoqiu',
    app_rate_7: '17.95%',
    avg_round_7: 0,
    app_flat_7: 0,
    char_8: 'robin',
    app_rate_8: '15.38%',
    avg_round_8: 0,
    app_flat_8: 0,
    char_9: 'gallagher',
    app_rate_9: '10.26%',
    avg_round_9: 0,
    app_flat_9: 0,
    char_10: 'sampo',
    app_rate_10: '7.69%',
    avg_round_10: 0,
    app_flat_10: 0,
    char_11: 'tribbie',
    app_rate_11: '7.69%',
    avg_round_11: 0,
    app_flat_11: 0,
    char_12: 'lingsha',
    app_rate_12: '5.13%',
    avg_round_12: 0,
    app_flat_12: 0,
    char_13: 'luocha',
    app_rate_13: '5.13%',
    avg_round_13: 0,
    app_flat_13: 0,
    char_14: 'the-herta',
    app_rate_14: '2.56%',
    avg_round_14: 0,
    app_flat_14: 0,
    char_15: 'jade',
    app_rate_15: '2.56%',
    avg_round_15: 0,
    app_flat_15: 0,
    char_16: 'firefly',
    app_rate_16: '2.56%',
    avg_round_16: 0,
    app_flat_16: 0,
    char_17: 'tingyun-fugue',
    app_rate_17: '2.56%',
    avg_round_17: 0,
    app_flat_17: 0,
    char_18: '-',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '-',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '-',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '-',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '-',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '-',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '-',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '-',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'himeko',
    app: 0.24,
    char_1: 'tingyun-fugue',
    app_rate_1: '48.65%',
    avg_round_1: 3109,
    app_flat_1: 2,
    char_2: 'ruan-mei',
    app_rate_2: '45.95%',
    avg_round_2: 3109,
    app_flat_2: 2,
    char_3: 'the-herta',
    app_rate_3: '35.14%',
    avg_round_3: 3351.0,
    app_flat_3: 7,
    char_4: 'lingsha',
    app_rate_4: '32.43%',
    avg_round_4: 3202.0,
    app_flat_4: 4,
    char_5: 'firefly',
    app_rate_5: '24.32%',
    avg_round_5: 0,
    app_flat_5: 0,
    char_6: 'aventurine',
    app_rate_6: '18.92%',
    avg_round_6: 3310.0,
    app_flat_6: 4,
    char_7: 'trailblazer-remembrance',
    app_rate_7: '13.51%',
    avg_round_7: 3411,
    app_flat_7: 2,
    char_8: 'fu-xuan',
    app_rate_8: '13.51%',
    avg_round_8: 3468,
    app_flat_8: 1,
    char_9: 'robin',
    app_rate_9: '13.51%',
    avg_round_9: 3231,
    app_flat_9: 2,
    char_10: 'tribbie',
    app_rate_10: '10.81%',
    avg_round_10: 3399,
    app_flat_10: 1,
    char_11: 'huohuo',
    app_rate_11: '10.81%',
    avg_round_11: 3354,
    app_flat_11: 1,
    char_12: 'sunday',
    app_rate_12: '8.11%',
    avg_round_12: 3323.0,
    app_flat_12: 3,
    char_13: 'feixiao',
    app_rate_13: '5.41%',
    avg_round_13: 3192,
    app_flat_13: 1,
    char_14: 'anaxa',
    app_rate_14: '5.41%',
    avg_round_14: 0,
    app_flat_14: 0,
    char_15: 'castorice',
    app_rate_15: '2.7%',
    avg_round_15: 0,
    app_flat_15: 0,
    char_16: 'march-7th-swordmaster',
    app_rate_16: '2.7%',
    avg_round_16: 0,
    app_flat_16: 0,
    char_17: 'trailblazer-harmony',
    app_rate_17: '2.7%',
    avg_round_17: 0,
    app_flat_17: 0,
    char_18: 'gallagher',
    app_rate_18: '2.7%',
    avg_round_18: 0,
    app_flat_18: 0,
    char_19: 'bronya',
    app_rate_19: '2.7%',
    avg_round_19: 0,
    app_flat_19: 0,
    char_20: '-',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '-',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '-',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '-',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '-',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '-',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'dr-ratio',
    app: 0.19,
    char_1: 'robin',
    app_rate_1: '68.97%',
    avg_round_1: 3253.0,
    app_flat_1: 6,
    char_2: 'aventurine',
    app_rate_2: '68.97%',
    avg_round_2: 3250.0,
    app_flat_2: 4,
    char_3: 'topaz',
    app_rate_3: '41.38%',
    avg_round_3: 3149.0,
    app_flat_3: 3,
    char_4: 'tribbie',
    app_rate_4: '17.24%',
    avg_round_4: 3314,
    app_flat_4: 1,
    char_5: 'silver-wolf',
    app_rate_5: '13.79%',
    avg_round_5: 0,
    app_flat_5: 0,
    char_6: 'gallagher',
    app_rate_6: '13.79%',
    avg_round_6: 3199,
    app_flat_6: 1,
    char_7: 'sunday',
    app_rate_7: '13.79%',
    avg_round_7: 3199,
    app_flat_7: 1,
    char_8: 'ruan-mei',
    app_rate_8: '13.79%',
    avg_round_8: 0,
    app_flat_8: 0,
    char_9: 'jiaoqiu',
    app_rate_9: '13.79%',
    avg_round_9: 0,
    app_flat_9: 0,
    char_10: 'tingyun',
    app_rate_10: '6.9%',
    avg_round_10: 0,
    app_flat_10: 0,
    char_11: 'feixiao',
    app_rate_11: '3.45%',
    avg_round_11: 3340,
    app_flat_11: 1,
    char_12: 'yunli',
    app_rate_12: '3.45%',
    avg_round_12: 3340,
    app_flat_12: 1,
    char_13: 'lingsha',
    app_rate_13: '3.45%',
    avg_round_13: 0,
    app_flat_13: 0,
    char_14: 'moze',
    app_rate_14: '3.45%',
    avg_round_14: 0,
    app_flat_14: 0,
    char_15: 'march-7th-swordmaster',
    app_rate_15: '3.45%',
    avg_round_15: 0,
    app_flat_15: 0,
    char_16: 'jade',
    app_rate_16: '3.45%',
    avg_round_16: 0,
    app_flat_16: 0,
    char_17: 'clara',
    app_rate_17: '3.45%',
    avg_round_17: 0,
    app_flat_17: 0,
    char_18: 'anaxa',
    app_rate_18: '3.45%',
    avg_round_18: 0,
    app_flat_18: 0,
    char_19: '-',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '-',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '-',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '-',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '-',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '-',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '-',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'xueyi',
    app: 0.18,
    char_1: 'ruan-mei',
    app_rate_1: '85.71%',
    avg_round_1: 3252.0,
    app_flat_1: 5,
    char_2: 'tingyun-fugue',
    app_rate_2: '75.0%',
    avg_round_2: 3211.0,
    app_flat_2: 4,
    char_3: 'lingsha',
    app_rate_3: '39.29%',
    avg_round_3: 3151.0,
    app_flat_3: 3,
    char_4: 'trailblazer-harmony',
    app_rate_4: '28.57%',
    avg_round_4: 3250,
    app_flat_4: 1,
    char_5: 'robin',
    app_rate_5: '25.0%',
    avg_round_5: 3406,
    app_flat_5: 2,
    char_6: 'tribbie',
    app_rate_6: '21.43%',
    avg_round_6: 3277,
    app_flat_6: 2,
    char_7: 'trailblazer-remembrance',
    app_rate_7: '10.71%',
    avg_round_7: 3288,
    app_flat_7: 1,
    char_8: 'gallagher',
    app_rate_8: '3.57%',
    avg_round_8: 0,
    app_flat_8: 0,
    char_9: 'sunday',
    app_rate_9: '3.57%',
    avg_round_9: 0,
    app_flat_9: 0,
    char_10: 'sparkle',
    app_rate_10: '3.57%',
    avg_round_10: 0,
    app_flat_10: 0,
    char_11: 'blade',
    app_rate_11: '3.57%',
    avg_round_11: 0,
    app_flat_11: 0,
    char_12: '-',
    app_rate_12: '0.00%',
    avg_round_12: 0.0,
    app_flat_12: 0,
    char_13: '-',
    app_rate_13: '0.00%',
    avg_round_13: 0.0,
    app_flat_13: 0,
    char_14: '-',
    app_rate_14: '0.00%',
    avg_round_14: 0.0,
    app_flat_14: 0,
    char_15: '-',
    app_rate_15: '0.00%',
    avg_round_15: 0.0,
    app_flat_15: 0,
    char_16: '-',
    app_rate_16: '0.00%',
    avg_round_16: 0.0,
    app_flat_16: 0,
    char_17: '-',
    app_rate_17: '0.00%',
    avg_round_17: 0.0,
    app_flat_17: 0,
    char_18: '-',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '-',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '-',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '-',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '-',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '-',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '-',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '-',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'qingque',
    app: 0.16,
    char_1: 'sparkle',
    app_rate_1: '76.0%',
    avg_round_1: 3106,
    app_flat_1: 1,
    char_2: 'fu-xuan',
    app_rate_2: '64.0%',
    avg_round_2: 3106,
    app_flat_2: 1,
    char_3: 'tribbie',
    app_rate_3: '28.0%',
    avg_round_3: 0,
    app_flat_3: 0,
    char_4: 'sunday',
    app_rate_4: '24.0%',
    avg_round_4: 0,
    app_flat_4: 0,
    char_5: 'the-herta',
    app_rate_5: '24.0%',
    avg_round_5: 3331,
    app_flat_5: 1,
    char_6: 'trailblazer-remembrance',
    app_rate_6: '24.0%',
    avg_round_6: 3218.0,
    app_flat_6: 2,
    char_7: 'huohuo',
    app_rate_7: '12.0%',
    avg_round_7: 0,
    app_flat_7: 0,
    char_8: 'silver-wolf',
    app_rate_8: '12.0%',
    avg_round_8: 0,
    app_flat_8: 0,
    char_9: 'lingsha',
    app_rate_9: '8.0%',
    avg_round_9: 0,
    app_flat_9: 0,
    char_10: 'aventurine',
    app_rate_10: '8.0%',
    avg_round_10: 3331,
    app_flat_10: 1,
    char_11: 'tingyun',
    app_rate_11: '4.0%',
    avg_round_11: 0,
    app_flat_11: 0,
    char_12: 'robin',
    app_rate_12: '4.0%',
    avg_round_12: 0,
    app_flat_12: 0,
    char_13: 'ruan-mei',
    app_rate_13: '4.0%',
    avg_round_13: 0,
    app_flat_13: 0,
    char_14: 'jade',
    app_rate_14: '4.0%',
    avg_round_14: 0,
    app_flat_14: 0,
    char_15: 'luocha',
    app_rate_15: '4.0%',
    avg_round_15: 0,
    app_flat_15: 0,
    char_16: '-',
    app_rate_16: '0.00%',
    avg_round_16: 0.0,
    app_flat_16: 0,
    char_17: '-',
    app_rate_17: '0.00%',
    avg_round_17: 0.0,
    app_flat_17: 0,
    char_18: '-',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '-',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '-',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '-',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '-',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '-',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '-',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '-',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'asta',
    app: 0.15,
    char_1: 'ruan-mei',
    app_rate_1: '41.67%',
    avg_round_1: 3280,
    app_flat_1: 1,
    char_2: 'robin',
    app_rate_2: '29.17%',
    avg_round_2: 3787,
    app_flat_2: 1,
    char_3: 'sunday',
    app_rate_3: '29.17%',
    avg_round_3: 3514,
    app_flat_3: 1,
    char_4: 'anaxa',
    app_rate_4: '20.83%',
    avg_round_4: 3628.0,
    app_flat_4: 3,
    char_5: 'gallagher',
    app_rate_5: '16.67%',
    avg_round_5: 3514.0,
    app_flat_5: 2,
    char_6: 'firefly',
    app_rate_6: '16.67%',
    avg_round_6: 0,
    app_flat_6: 0,
    char_7: 'tingyun-fugue',
    app_rate_7: '16.67%',
    avg_round_7: 3280,
    app_flat_7: 1,
    char_8: 'trailblazer-remembrance',
    app_rate_8: '16.67%',
    avg_round_8: 3480,
    app_flat_8: 1,
    char_9: 'tribbie',
    app_rate_9: '12.5%',
    avg_round_9: 3532.0,
    app_flat_9: 2,
    char_10: 'aglaea',
    app_rate_10: '12.5%',
    avg_round_10: 3514,
    app_flat_10: 1,
    char_11: 'trailblazer-harmony',
    app_rate_11: '12.5%',
    avg_round_11: 3280,
    app_flat_11: 1,
    char_12: 'seele',
    app_rate_12: '12.5%',
    avg_round_12: 0,
    app_flat_12: 0,
    char_13: 'the-herta',
    app_rate_13: '8.33%',
    avg_round_13: 3549,
    app_flat_13: 1,
    char_14: 'castorice',
    app_rate_14: '8.33%',
    avg_round_14: 3480,
    app_flat_14: 1,
    char_15: 'sparkle',
    app_rate_15: '4.17%',
    avg_round_15: 3549,
    app_flat_15: 1,
    char_16: 'topaz',
    app_rate_16: '4.17%',
    avg_round_16: 0,
    app_flat_16: 0,
    char_17: 'hook',
    app_rate_17: '4.17%',
    avg_round_17: 0,
    app_flat_17: 0,
    char_18: 'jiaoqiu',
    app_rate_18: '4.17%',
    avg_round_18: 0,
    app_flat_18: 0,
    char_19: 'rappa',
    app_rate_19: '4.17%',
    avg_round_19: 0,
    app_flat_19: 0,
    char_20: 'bronya',
    app_rate_20: '4.17%',
    avg_round_20: 3787,
    app_flat_20: 1,
    char_21: 'march-7th-swordmaster',
    app_rate_21: '4.17%',
    avg_round_21: 0,
    app_flat_21: 0,
    char_22: 'silver-wolf',
    app_rate_22: '4.17%',
    avg_round_22: 0,
    app_flat_22: 0,
    char_23: 'feixiao',
    app_rate_23: '4.17%',
    avg_round_23: 0,
    app_flat_23: 0,
    char_24: 'aventurine',
    app_rate_24: '4.17%',
    avg_round_24: 0,
    app_flat_24: 0,
    char_25: 'serval',
    app_rate_25: '4.17%',
    avg_round_25: 0,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'march-7th',
    app: 0.08,
    char_1: 'acheron',
    app_rate_1: '41.67%',
    avg_round_1: 0,
    app_flat_1: 0,
    char_2: 'the-herta',
    app_rate_2: '33.33%',
    avg_round_2: 3406,
    app_flat_2: 1,
    char_3: 'robin',
    app_rate_3: '25.0%',
    avg_round_3: 0,
    app_flat_3: 0,
    char_4: 'pela',
    app_rate_4: '25.0%',
    avg_round_4: 0,
    app_flat_4: 0,
    char_5: 'rappa',
    app_rate_5: '16.67%',
    avg_round_5: 0,
    app_flat_5: 0,
    char_6: 'tingyun-fugue',
    app_rate_6: '16.67%',
    avg_round_6: 0,
    app_flat_6: 0,
    char_7: 'trailblazer-remembrance',
    app_rate_7: '16.67%',
    avg_round_7: 3406,
    app_flat_7: 1,
    char_8: 'jade',
    app_rate_8: '16.67%',
    avg_round_8: 0,
    app_flat_8: 0,
    char_9: 'herta',
    app_rate_9: '16.67%',
    avg_round_9: 0,
    app_flat_9: 0,
    char_10: 'sparkle',
    app_rate_10: '16.67%',
    avg_round_10: 0,
    app_flat_10: 0,
    char_11: 'ruan-mei',
    app_rate_11: '16.67%',
    avg_round_11: 0,
    app_flat_11: 0,
    char_12: 'trailblazer-harmony',
    app_rate_12: '8.33%',
    avg_round_12: 0,
    app_flat_12: 0,
    char_13: 'serval',
    app_rate_13: '8.33%',
    avg_round_13: 3406,
    app_flat_13: 1,
    char_14: 'jiaoqiu',
    app_rate_14: '8.33%',
    avg_round_14: 0,
    app_flat_14: 0,
    char_15: 'yunli',
    app_rate_15: '8.33%',
    avg_round_15: 0,
    app_flat_15: 0,
    char_16: 'topaz',
    app_rate_16: '8.33%',
    avg_round_16: 0,
    app_flat_16: 0,
    char_17: 'tribbie',
    app_rate_17: '8.33%',
    avg_round_17: 0,
    app_flat_17: 0,
    char_18: 'silver-wolf',
    app_rate_18: '8.33%',
    avg_round_18: 0,
    app_flat_18: 0,
    char_19: '-',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '-',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '-',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '-',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '-',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '-',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '-',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'sampo',
    app: 0.06,
    char_1: 'ruan-mei',
    app_rate_1: '100.0%',
    avg_round_1: 3223,
    app_flat_1: 2,
    char_2: 'tingyun-fugue',
    app_rate_2: '50.0%',
    avg_round_2: 2955,
    app_flat_2: 1,
    char_3: 'gallagher',
    app_rate_3: '30.0%',
    avg_round_3: 2955,
    app_flat_3: 1,
    char_4: 'kafka',
    app_rate_4: '30.0%',
    avg_round_4: 0,
    app_flat_4: 0,
    char_5: 'trailblazer-harmony',
    app_rate_5: '30.0%',
    avg_round_5: 0,
    app_flat_5: 0,
    char_6: 'robin',
    app_rate_6: '20.0%',
    avg_round_6: 3491,
    app_flat_6: 1,
    char_7: 'black-swan',
    app_rate_7: '20.0%',
    avg_round_7: 0,
    app_flat_7: 0,
    char_8: 'bailu',
    app_rate_8: '10.0%',
    avg_round_8: 0,
    app_flat_8: 0,
    char_9: 'sunday',
    app_rate_9: '10.0%',
    avg_round_9: 3491,
    app_flat_9: 1,
    char_10: '-',
    app_rate_10: '0.00%',
    avg_round_10: 0.0,
    app_flat_10: 0,
    char_11: '-',
    app_rate_11: '0.00%',
    avg_round_11: 0.0,
    app_flat_11: 0,
    char_12: '-',
    app_rate_12: '0.00%',
    avg_round_12: 0.0,
    app_flat_12: 0,
    char_13: '-',
    app_rate_13: '0.00%',
    avg_round_13: 0.0,
    app_flat_13: 0,
    char_14: '-',
    app_rate_14: '0.00%',
    avg_round_14: 0.0,
    app_flat_14: 0,
    char_15: '-',
    app_rate_15: '0.00%',
    avg_round_15: 0.0,
    app_flat_15: 0,
    char_16: '-',
    app_rate_16: '0.00%',
    avg_round_16: 0.0,
    app_flat_16: 0,
    char_17: '-',
    app_rate_17: '0.00%',
    avg_round_17: 0.0,
    app_flat_17: 0,
    char_18: '-',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '-',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '-',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '-',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '-',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '-',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '-',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '-',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'welt',
    app: 0.06,
    char_1: 'acheron',
    app_rate_1: '50.0%',
    avg_round_1: 3412,
    app_flat_1: 2,
    char_2: 'pela',
    app_rate_2: '40.0%',
    avg_round_2: 3412,
    app_flat_2: 2,
    char_3: 'tribbie',
    app_rate_3: '30.0%',
    avg_round_3: 3569,
    app_flat_3: 1,
    char_4: 'ruan-mei',
    app_rate_4: '20.0%',
    avg_round_4: 0,
    app_flat_4: 0,
    char_5: 'sparkle',
    app_rate_5: '20.0%',
    avg_round_5: 0,
    app_flat_5: 0,
    char_6: 'sunday',
    app_rate_6: '20.0%',
    avg_round_6: 0,
    app_flat_6: 0,
    char_7: 'jiaoqiu',
    app_rate_7: '10.0%',
    avg_round_7: 0,
    app_flat_7: 0,
    char_8: 'mydei',
    app_rate_8: '10.0%',
    avg_round_8: 0,
    app_flat_8: 0,
    char_9: 'trailblazer-remembrance',
    app_rate_9: '10.0%',
    avg_round_9: 0,
    app_flat_9: 0,
    char_10: 'aventurine',
    app_rate_10: '10.0%',
    avg_round_10: 0,
    app_flat_10: 0,
    char_11: 'rappa',
    app_rate_11: '10.0%',
    avg_round_11: 0,
    app_flat_11: 0,
    char_12: 'tingyun-fugue',
    app_rate_12: '10.0%',
    avg_round_12: 0,
    app_flat_12: 0,
    char_13: 'trailblazer-harmony',
    app_rate_13: '10.0%',
    avg_round_13: 0,
    app_flat_13: 0,
    char_14: 'the-herta',
    app_rate_14: '10.0%',
    avg_round_14: 0,
    app_flat_14: 0,
    char_15: 'herta',
    app_rate_15: '10.0%',
    avg_round_15: 0,
    app_flat_15: 0,
    char_16: 'fu-xuan',
    app_rate_16: '10.0%',
    avg_round_16: 0,
    app_flat_16: 0,
    char_17: 'robin',
    app_rate_17: '10.0%',
    avg_round_17: 3255,
    app_flat_17: 1,
    char_18: 'bronya',
    app_rate_18: '10.0%',
    avg_round_18: 0,
    app_flat_18: 0,
    char_19: '-',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '-',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '-',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '-',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '-',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '-',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '-',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'dan-heng',
    app: 0.05,
    char_1: 'robin',
    app_rate_1: '100.0%',
    avg_round_1: 3245,
    app_flat_1: 2,
    char_2: 'sunday',
    app_rate_2: '42.86%',
    avg_round_2: 3239,
    app_flat_2: 1,
    char_3: 'sparkle',
    app_rate_3: '28.57%',
    avg_round_3: 3251,
    app_flat_3: 1,
    char_4: 'tingyun',
    app_rate_4: '28.57%',
    avg_round_4: 3251,
    app_flat_4: 1,
    char_5: 'trailblazer-remembrance',
    app_rate_5: '14.29%',
    avg_round_5: 0,
    app_flat_5: 0,
    char_6: 'huohuo',
    app_rate_6: '14.29%',
    avg_round_6: 0,
    app_flat_6: 0,
    char_7: 'bronya',
    app_rate_7: '14.29%',
    avg_round_7: 0,
    app_flat_7: 0,
    char_8: 'feixiao',
    app_rate_8: '14.29%',
    avg_round_8: 0,
    app_flat_8: 0,
    char_9: 'topaz',
    app_rate_9: '14.29%',
    avg_round_9: 0,
    app_flat_9: 0,
    char_10: 'march-7th-swordmaster',
    app_rate_10: '14.29%',
    avg_round_10: 3239,
    app_flat_10: 1,
    char_11: 'aventurine',
    app_rate_11: '14.29%',
    avg_round_11: 0,
    app_flat_11: 0,
    char_12: '-',
    app_rate_12: '0.00%',
    avg_round_12: 0.0,
    app_flat_12: 0,
    char_13: '-',
    app_rate_13: '0.00%',
    avg_round_13: 0.0,
    app_flat_13: 0,
    char_14: '-',
    app_rate_14: '0.00%',
    avg_round_14: 0.0,
    app_flat_14: 0,
    char_15: '-',
    app_rate_15: '0.00%',
    avg_round_15: 0.0,
    app_flat_15: 0,
    char_16: '-',
    app_rate_16: '0.00%',
    avg_round_16: 0.0,
    app_flat_16: 0,
    char_17: '-',
    app_rate_17: '0.00%',
    avg_round_17: 0.0,
    app_flat_17: 0,
    char_18: '-',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '-',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '-',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '-',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '-',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '-',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '-',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '-',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'luka',
    app: 0.05,
    char_1: 'ruan-mei',
    app_rate_1: '87.5%',
    avg_round_1: 3110.0,
    app_flat_1: 4,
    char_2: 'lingsha',
    app_rate_2: '62.5%',
    avg_round_2: 3062,
    app_flat_2: 1,
    char_3: 'tingyun-fugue',
    app_rate_3: '50.0%',
    avg_round_3: 3095,
    app_flat_3: 1,
    char_4: 'gallagher',
    app_rate_4: '37.5%',
    avg_round_4: 3110.0,
    app_flat_4: 2,
    char_5: 'boothill',
    app_rate_5: '25.0%',
    avg_round_5: 3320,
    app_flat_5: 1,
    char_6: 'trailblazer-harmony',
    app_rate_6: '25.0%',
    avg_round_6: 3126,
    app_flat_6: 1,
    char_7: 'aventurine',
    app_rate_7: '12.5%',
    avg_round_7: 0,
    app_flat_7: 0,
    char_8: 'black-swan',
    app_rate_8: '12.5%',
    avg_round_8: 3062,
    app_flat_8: 1,
    char_9: 'fu-xuan',
    app_rate_9: '12.5%',
    avg_round_9: 3320,
    app_flat_9: 1,
    char_10: '-',
    app_rate_10: '0.00%',
    avg_round_10: 0.0,
    app_flat_10: 0,
    char_11: '-',
    app_rate_11: '0.00%',
    avg_round_11: 0.0,
    app_flat_11: 0,
    char_12: '-',
    app_rate_12: '0.00%',
    avg_round_12: 0.0,
    app_flat_12: 0,
    char_13: '-',
    app_rate_13: '0.00%',
    avg_round_13: 0.0,
    app_flat_13: 0,
    char_14: '-',
    app_rate_14: '0.00%',
    avg_round_14: 0.0,
    app_flat_14: 0,
    char_15: '-',
    app_rate_15: '0.00%',
    avg_round_15: 0.0,
    app_flat_15: 0,
    char_16: '-',
    app_rate_16: '0.00%',
    avg_round_16: 0.0,
    app_flat_16: 0,
    char_17: '-',
    app_rate_17: '0.00%',
    avg_round_17: 0.0,
    app_flat_17: 0,
    char_18: '-',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '-',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '-',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '-',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '-',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '-',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '-',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '-',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'sushang',
    app: 0.05,
    char_1: 'ruan-mei',
    app_rate_1: '75.0%',
    avg_round_1: 3365,
    app_flat_1: 1,
    char_2: 'robin',
    app_rate_2: '50.0%',
    avg_round_2: 3287,
    app_flat_2: 2,
    char_3: 'trailblazer-harmony',
    app_rate_3: '25.0%',
    avg_round_3: 0,
    app_flat_3: 0,
    char_4: 'gallagher',
    app_rate_4: '25.0%',
    avg_round_4: 3209,
    app_flat_4: 1,
    char_5: 'sunday',
    app_rate_5: '25.0%',
    avg_round_5: 3365,
    app_flat_5: 1,
    char_6: 'tingyun-fugue',
    app_rate_6: '25.0%',
    avg_round_6: 0,
    app_flat_6: 0,
    char_7: 'trailblazer-remembrance',
    app_rate_7: '12.5%',
    avg_round_7: 0,
    app_flat_7: 0,
    char_8: 'huohuo',
    app_rate_8: '12.5%',
    avg_round_8: 0,
    app_flat_8: 0,
    char_9: 'march-7th-swordmaster',
    app_rate_9: '12.5%',
    avg_round_9: 3209,
    app_flat_9: 1,
    char_10: 'lingsha',
    app_rate_10: '12.5%',
    avg_round_10: 0,
    app_flat_10: 0,
    char_11: 'sparkle',
    app_rate_11: '12.5%',
    avg_round_11: 0,
    app_flat_11: 0,
    char_12: 'tribbie',
    app_rate_12: '12.5%',
    avg_round_12: 0,
    app_flat_12: 0,
    char_13: '-',
    app_rate_13: '0.00%',
    avg_round_13: 0.0,
    app_flat_13: 0,
    char_14: '-',
    app_rate_14: '0.00%',
    avg_round_14: 0.0,
    app_flat_14: 0,
    char_15: '-',
    app_rate_15: '0.00%',
    avg_round_15: 0.0,
    app_flat_15: 0,
    char_16: '-',
    app_rate_16: '0.00%',
    avg_round_16: 0.0,
    app_flat_16: 0,
    char_17: '-',
    app_rate_17: '0.00%',
    avg_round_17: 0.0,
    app_flat_17: 0,
    char_18: '-',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '-',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '-',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '-',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '-',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '-',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '-',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '-',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'natasha',
    app: 0.04,
    char_1: 'tribbie',
    app_rate_1: '50.0%',
    avg_round_1: 3352,
    app_flat_1: 2,
    char_2: 'sunday',
    app_rate_2: '33.33%',
    avg_round_2: 0,
    app_flat_2: 0,
    char_3: 'robin',
    app_rate_3: '33.33%',
    avg_round_3: 0,
    app_flat_3: 0,
    char_4: 'the-herta',
    app_rate_4: '33.33%',
    avg_round_4: 3352,
    app_flat_4: 2,
    char_5: 'herta',
    app_rate_5: '33.33%',
    avg_round_5: 3352,
    app_flat_5: 2,
    char_6: 'blade',
    app_rate_6: '16.67%',
    avg_round_6: 0,
    app_flat_6: 0,
    char_7: 'ruan-mei',
    app_rate_7: '16.67%',
    avg_round_7: 0,
    app_flat_7: 0,
    char_8: 'feixiao',
    app_rate_8: '16.67%',
    avg_round_8: 0,
    app_flat_8: 0,
    char_9: 'topaz',
    app_rate_9: '16.67%',
    avg_round_9: 0,
    app_flat_9: 0,
    char_10: 'aglaea',
    app_rate_10: '16.67%',
    avg_round_10: 0,
    app_flat_10: 0,
    char_11: 'yunli',
    app_rate_11: '16.67%',
    avg_round_11: 0,
    app_flat_11: 0,
    char_12: 'trailblazer-remembrance',
    app_rate_12: '16.67%',
    avg_round_12: 0,
    app_flat_12: 0,
    char_13: '-',
    app_rate_13: '0.00%',
    avg_round_13: 0.0,
    app_flat_13: 0,
    char_14: '-',
    app_rate_14: '0.00%',
    avg_round_14: 0.0,
    app_flat_14: 0,
    char_15: '-',
    app_rate_15: '0.00%',
    avg_round_15: 0.0,
    app_flat_15: 0,
    char_16: '-',
    app_rate_16: '0.00%',
    avg_round_16: 0.0,
    app_flat_16: 0,
    char_17: '-',
    app_rate_17: '0.00%',
    avg_round_17: 0.0,
    app_flat_17: 0,
    char_18: '-',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '-',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '-',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '-',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '-',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '-',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '-',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '-',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'hook',
    app: 0.03,
    char_1: 'ruan-mei',
    app_rate_1: '60.0%',
    avg_round_1: 3322,
    app_flat_1: 1,
    char_2: 'tribbie',
    app_rate_2: '60.0%',
    avg_round_2: 0,
    app_flat_2: 0,
    char_3: 'lingsha',
    app_rate_3: '40.0%',
    avg_round_3: 3322,
    app_flat_3: 1,
    char_4: 'sparkle',
    app_rate_4: '40.0%',
    avg_round_4: 0,
    app_flat_4: 0,
    char_5: 'bailu',
    app_rate_5: '20.0%',
    avg_round_5: 0,
    app_flat_5: 0,
    char_6: 'asta',
    app_rate_6: '20.0%',
    avg_round_6: 0,
    app_flat_6: 0,
    char_7: 'jiaoqiu',
    app_rate_7: '20.0%',
    avg_round_7: 0,
    app_flat_7: 0,
    char_8: 'trailblazer-harmony',
    app_rate_8: '20.0%',
    avg_round_8: 3322,
    app_flat_8: 1,
    char_9: 'fu-xuan',
    app_rate_9: '20.0%',
    avg_round_9: 0,
    app_flat_9: 0,
    char_10: '-',
    app_rate_10: '0.00%',
    avg_round_10: 0.0,
    app_flat_10: 0,
    char_11: '-',
    app_rate_11: '0.00%',
    avg_round_11: 0.0,
    app_flat_11: 0,
    char_12: '-',
    app_rate_12: '0.00%',
    avg_round_12: 0.0,
    app_flat_12: 0,
    char_13: '-',
    app_rate_13: '0.00%',
    avg_round_13: 0.0,
    app_flat_13: 0,
    char_14: '-',
    app_rate_14: '0.00%',
    avg_round_14: 0.0,
    app_flat_14: 0,
    char_15: '-',
    app_rate_15: '0.00%',
    avg_round_15: 0.0,
    app_flat_15: 0,
    char_16: '-',
    app_rate_16: '0.00%',
    avg_round_16: 0.0,
    app_flat_16: 0,
    char_17: '-',
    app_rate_17: '0.00%',
    avg_round_17: 0.0,
    app_flat_17: 0,
    char_18: '-',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '-',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '-',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '-',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '-',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '-',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '-',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '-',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'hanya',
    app: 0.03,
    char_1: 'the-herta',
    app_rate_1: '40.0%',
    avg_round_1: 0,
    app_flat_1: 0,
    char_2: 'herta',
    app_rate_2: '40.0%',
    avg_round_2: 0,
    app_flat_2: 0,
    char_3: 'firefly',
    app_rate_3: '20.0%',
    avg_round_3: 0,
    app_flat_3: 0,
    char_4: 'tingyun-fugue',
    app_rate_4: '20.0%',
    avg_round_4: 0,
    app_flat_4: 0,
    char_5: 'ruan-mei',
    app_rate_5: '20.0%',
    avg_round_5: 0,
    app_flat_5: 0,
    char_6: 'feixiao',
    app_rate_6: '20.0%',
    avg_round_6: 0,
    app_flat_6: 0,
    char_7: 'march-7th-swordmaster',
    app_rate_7: '20.0%',
    avg_round_7: 0,
    app_flat_7: 0,
    char_8: 'robin',
    app_rate_8: '20.0%',
    avg_round_8: 0,
    app_flat_8: 0,
    char_9: 'aventurine',
    app_rate_9: '20.0%',
    avg_round_9: 0,
    app_flat_9: 0,
    char_10: 'castorice',
    app_rate_10: '20.0%',
    avg_round_10: 3355,
    app_flat_10: 1,
    char_11: 'trailblazer-remembrance',
    app_rate_11: '20.0%',
    avg_round_11: 3355,
    app_flat_11: 1,
    char_12: 'luocha',
    app_rate_12: '20.0%',
    avg_round_12: 3355,
    app_flat_12: 1,
    char_13: 'fu-xuan',
    app_rate_13: '20.0%',
    avg_round_13: 0,
    app_flat_13: 0,
    char_14: '-',
    app_rate_14: '0.00%',
    avg_round_14: 0.0,
    app_flat_14: 0,
    char_15: '-',
    app_rate_15: '0.00%',
    avg_round_15: 0.0,
    app_flat_15: 0,
    char_16: '-',
    app_rate_16: '0.00%',
    avg_round_16: 0.0,
    app_flat_16: 0,
    char_17: '-',
    app_rate_17: '0.00%',
    avg_round_17: 0.0,
    app_flat_17: 0,
    char_18: '-',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '-',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '-',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '-',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '-',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '-',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '-',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '-',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'guinaifen',
    app: 0.01,
    char_1: 'acheron',
    app_rate_1: '100.0%',
    avg_round_1: 3177,
    app_flat_1: 1,
    char_2: 'bronya',
    app_rate_2: '50.0%',
    avg_round_2: 0,
    app_flat_2: 0,
    char_3: 'fu-xuan',
    app_rate_3: '50.0%',
    avg_round_3: 0,
    app_flat_3: 0,
    char_4: 'jiaoqiu',
    app_rate_4: '50.0%',
    avg_round_4: 3177,
    app_flat_4: 1,
    char_5: 'aventurine',
    app_rate_5: '50.0%',
    avg_round_5: 3177,
    app_flat_5: 1,
    char_6: '-',
    app_rate_6: '0.00%',
    avg_round_6: 0.0,
    app_flat_6: 0,
    char_7: '-',
    app_rate_7: '0.00%',
    avg_round_7: 0.0,
    app_flat_7: 0,
    char_8: '-',
    app_rate_8: '0.00%',
    avg_round_8: 0.0,
    app_flat_8: 0,
    char_9: '-',
    app_rate_9: '0.00%',
    avg_round_9: 0.0,
    app_flat_9: 0,
    char_10: '-',
    app_rate_10: '0.00%',
    avg_round_10: 0.0,
    app_flat_10: 0,
    char_11: '-',
    app_rate_11: '0.00%',
    avg_round_11: 0.0,
    app_flat_11: 0,
    char_12: '-',
    app_rate_12: '0.00%',
    avg_round_12: 0.0,
    app_flat_12: 0,
    char_13: '-',
    app_rate_13: '0.00%',
    avg_round_13: 0.0,
    app_flat_13: 0,
    char_14: '-',
    app_rate_14: '0.00%',
    avg_round_14: 0.0,
    app_flat_14: 0,
    char_15: '-',
    app_rate_15: '0.00%',
    avg_round_15: 0.0,
    app_flat_15: 0,
    char_16: '-',
    app_rate_16: '0.00%',
    avg_round_16: 0.0,
    app_flat_16: 0,
    char_17: '-',
    app_rate_17: '0.00%',
    avg_round_17: 0.0,
    app_flat_17: 0,
    char_18: '-',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '-',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '-',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '-',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '-',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '-',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '-',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '-',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'yukong',
    app: 0.01,
    char_1: 'feixiao',
    app_rate_1: '50.0%',
    avg_round_1: 3212,
    app_flat_1: 1,
    char_2: 'march-7th-swordmaster',
    app_rate_2: '50.0%',
    avg_round_2: 3212,
    app_flat_2: 1,
    char_3: 'aventurine',
    app_rate_3: '50.0%',
    avg_round_3: 3212,
    app_flat_3: 1,
    char_4: 'the-herta',
    app_rate_4: '50.0%',
    avg_round_4: 0,
    app_flat_4: 0,
    char_5: 'herta',
    app_rate_5: '50.0%',
    avg_round_5: 0,
    app_flat_5: 0,
    char_6: 'lingsha',
    app_rate_6: '50.0%',
    avg_round_6: 0,
    app_flat_6: 0,
    char_7: '-',
    app_rate_7: '0.00%',
    avg_round_7: 0.0,
    app_flat_7: 0,
    char_8: '-',
    app_rate_8: '0.00%',
    avg_round_8: 0.0,
    app_flat_8: 0,
    char_9: '-',
    app_rate_9: '0.00%',
    avg_round_9: 0.0,
    app_flat_9: 0,
    char_10: '-',
    app_rate_10: '0.00%',
    avg_round_10: 0.0,
    app_flat_10: 0,
    char_11: '-',
    app_rate_11: '0.00%',
    avg_round_11: 0.0,
    app_flat_11: 0,
    char_12: '-',
    app_rate_12: '0.00%',
    avg_round_12: 0.0,
    app_flat_12: 0,
    char_13: '-',
    app_rate_13: '0.00%',
    avg_round_13: 0.0,
    app_flat_13: 0,
    char_14: '-',
    app_rate_14: '0.00%',
    avg_round_14: 0.0,
    app_flat_14: 0,
    char_15: '-',
    app_rate_15: '0.00%',
    avg_round_15: 0.0,
    app_flat_15: 0,
    char_16: '-',
    app_rate_16: '0.00%',
    avg_round_16: 0.0,
    app_flat_16: 0,
    char_17: '-',
    app_rate_17: '0.00%',
    avg_round_17: 0.0,
    app_flat_17: 0,
    char_18: '-',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '-',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '-',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '-',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '-',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '-',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '-',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '-',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'yanqing',
    app: 0.01,
    char_1: 'robin',
    app_rate_1: '100.0%',
    avg_round_1: 0,
    app_flat_1: 0,
    char_2: 'sunday',
    app_rate_2: '100.0%',
    avg_round_2: 0,
    app_flat_2: 0,
    char_3: 'aventurine',
    app_rate_3: '100.0%',
    avg_round_3: 0,
    app_flat_3: 0,
    char_4: '-',
    app_rate_4: '0.00%',
    avg_round_4: 0.0,
    app_flat_4: 0,
    char_5: '-',
    app_rate_5: '0.00%',
    avg_round_5: 0.0,
    app_flat_5: 0,
    char_6: '-',
    app_rate_6: '0.00%',
    avg_round_6: 0.0,
    app_flat_6: 0,
    char_7: '-',
    app_rate_7: '0.00%',
    avg_round_7: 0.0,
    app_flat_7: 0,
    char_8: '-',
    app_rate_8: '0.00%',
    avg_round_8: 0.0,
    app_flat_8: 0,
    char_9: '-',
    app_rate_9: '0.00%',
    avg_round_9: 0.0,
    app_flat_9: 0,
    char_10: '-',
    app_rate_10: '0.00%',
    avg_round_10: 0.0,
    app_flat_10: 0,
    char_11: '-',
    app_rate_11: '0.00%',
    avg_round_11: 0.0,
    app_flat_11: 0,
    char_12: '-',
    app_rate_12: '0.00%',
    avg_round_12: 0.0,
    app_flat_12: 0,
    char_13: '-',
    app_rate_13: '0.00%',
    avg_round_13: 0.0,
    app_flat_13: 0,
    char_14: '-',
    app_rate_14: '0.00%',
    avg_round_14: 0.0,
    app_flat_14: 0,
    char_15: '-',
    app_rate_15: '0.00%',
    avg_round_15: 0.0,
    app_flat_15: 0,
    char_16: '-',
    app_rate_16: '0.00%',
    avg_round_16: 0.0,
    app_flat_16: 0,
    char_17: '-',
    app_rate_17: '0.00%',
    avg_round_17: 0.0,
    app_flat_17: 0,
    char_18: '-',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '-',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '-',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '-',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '-',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '-',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '-',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '-',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'trailblazer-destruction',
    app: 0.01,
    char_1: 'castorice',
    app_rate_1: '100.0%',
    avg_round_1: 0,
    app_flat_1: 0,
    char_2: 'mydei',
    app_rate_2: '100.0%',
    avg_round_2: 0,
    app_flat_2: 0,
    char_3: 'luocha',
    app_rate_3: '100.0%',
    avg_round_3: 0,
    app_flat_3: 0,
    char_4: '-',
    app_rate_4: '0.00%',
    avg_round_4: 0.0,
    app_flat_4: 0,
    char_5: '-',
    app_rate_5: '0.00%',
    avg_round_5: 0.0,
    app_flat_5: 0,
    char_6: '-',
    app_rate_6: '0.00%',
    avg_round_6: 0.0,
    app_flat_6: 0,
    char_7: '-',
    app_rate_7: '0.00%',
    avg_round_7: 0.0,
    app_flat_7: 0,
    char_8: '-',
    app_rate_8: '0.00%',
    avg_round_8: 0.0,
    app_flat_8: 0,
    char_9: '-',
    app_rate_9: '0.00%',
    avg_round_9: 0.0,
    app_flat_9: 0,
    char_10: '-',
    app_rate_10: '0.00%',
    avg_round_10: 0.0,
    app_flat_10: 0,
    char_11: '-',
    app_rate_11: '0.00%',
    avg_round_11: 0.0,
    app_flat_11: 0,
    char_12: '-',
    app_rate_12: '0.00%',
    avg_round_12: 0.0,
    app_flat_12: 0,
    char_13: '-',
    app_rate_13: '0.00%',
    avg_round_13: 0.0,
    app_flat_13: 0,
    char_14: '-',
    app_rate_14: '0.00%',
    avg_round_14: 0.0,
    app_flat_14: 0,
    char_15: '-',
    app_rate_15: '0.00%',
    avg_round_15: 0.0,
    app_flat_15: 0,
    char_16: '-',
    app_rate_16: '0.00%',
    avg_round_16: 0.0,
    app_flat_16: 0,
    char_17: '-',
    app_rate_17: '0.00%',
    avg_round_17: 0.0,
    app_flat_17: 0,
    char_18: '-',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '-',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '-',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '-',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '-',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '-',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '-',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '-',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  }
];
